<main id="main" class="main">
  <section class="section dashboard">
    <div class="row">
      <div class="col-md-12">
        <!-- <h3>Click Here! to go CCAvenue</h3>
        <button mat-button (click)="checkout()">Checkout Payment Gateway</button>

      <form #form ngNoForm
      id="nonseamless"
      method="post"
      name="redirect"
      action="https://test.ccavenue.com/transaction/transaction.do?command=initiateTransaction">
        <input type="hidden" id="encRequest" name="encRequest" value="{{encRequestRes}}">
        <input type="hidden" name="access_code" id="access_code" value="{{accessCode}}">
    </form> -->
        <!-- Main Corporate Details Form -->
        <div *ngIf="basicInfo">
          <form class="onbordingform linescrollbar form-container" [formGroup]="clientregform">
            <div class="row mb-2 px-2 ">
              <h6 class="admintitle position-relative ">
                <span class="bartitlelabel">{{'Corporate Customer Info'}}</span>
                <!-- <div class="col-2 position-absolute" style="top: 5px !important;right: -90px !important; cursor:pointer">
                  <i class="fa fa-edit" style="font-size: 16px; color:white"></i>
                </div> -->
              </h6>

            </div>

            <div class="row" *ngIf="showBrokerData">
              <div class="col-md-6">
                <label for="Corporation"
                  class="Corporation">{{lang?.Broker}}:<Strong>{{filteredallBrokers[0]?.name}}</Strong></label>
              </div>
              <div class="col-md-5" style="max-height: 100px;
    overflow-y: auto;">
                <!-- <label for="Corporation" class="Corporation">Profile: <span *ngFor="let profile of brokerProfileslist"
                    [value]="profile.originalBrokerId">

                    <Strong>{{profile.name}}</Strong>({{profile.additionalData.statement}})<br>
                  </span>&nbsp;&nbsp;
                </label> -->

                <label for="Corporation" class="Corporation">{{lang.Profile}}: <span
                    [value]="brokerProfileslist1?.originalBrokerId">
                    <Strong>{{brokerProfileslist1?.name}}</Strong>({{brokerProfileslist1?.additionalData?.statement}})<br>
                  </span>&nbsp;&nbsp;
                </label>

              </div>
              <div class="col-md-1">
                <i class="fa fa-pencil" (click)="ShowBrokerData()" style="cursor:pointer"></i>
              </div>
            </div>
            <hr>
            <!--  -->
            <div class="row" *ngIf="allBrokerscheck">
              <div class="col-12 col-md-6">
                <div class="form-group">
                  <label for="Corporation" class="Corporation">{{lang.Brokers}}</label>
                  <select class="form-control select2" id="parentidrole" placeholder="Select"
                    formControlName="brokerName" data-live-search="true" [(ngModel)]="ParentBrokerId"
                    (change)="getBrokerProfiles($event.target.value)">
                    <option value="" label="" disabled>Select</option>
                    <option *ngFor="let broker of allBrokers" [value]="broker.id">
                      {{ broker.name }}-{{ broker.brokerType }}-{{
                      broker.salesTrackingCode
                      }}
                    </option>
                  </select>

                  <!-- <div *ngIf="client['corporationName'].touched && client['corporationName'].invalid" class="help-block text-danger">
                  <div *ngIf="client['corporationName'].errors && client['corporationName'].errors['required']">Please enter corporation name</div>
                  <div *ngIf="client['corporationName'].errors && client['corporationName'].errors['minlength']">Corporation name should be 3 character</div>
                  <div *ngIf="client['corporationName'].errors && client['corporationName'].errors['maxlength']">Corporation name must not exceed 30 characters</div>
                </div> -->
                </div>

              </div>
              <div class="col-12 col-md-6">
                <div class="form-group">
                  <label for="Corporation">{{lang.Select_Profile}}</label>

                  <select class="form-control select2" id="parentidrole" placeholder="Select" formControlName="profile"
                    data-live-search="true" [(ngModel)]="profileid">
                    <option *ngFor="let profile of brokerProfileslistSearch" [value]="profile?.originalBrokerId"
                      selected>

                      {{profile.name}}({{profile.additionalData.statement}})
                    </option>
                  </select>
                  <div *ngIf="
                  client['profile'].touched &&
                  client['profile'].invalid
                " class="help-block text-danger">
                    <div *ngIf="
                    client['profile'].errors &&
                    client['profile'].errors['required']
                  ">
                      {{lang.Please_select_profile}}
                    </div>
                  </div>


                </div>
              </div>
              <div class="col-12 col-md-3" *ngIf="false">
                <div class="form-group">
                  <label for="Corporation">Payment Platform</label>

                  <select class="form-control select2" id="paymentPlatform" placeholder="Select" formControlName="paymentPlatform"
                    data-live-search="true" [(ngModel)]="paymentPlatform" disabled>
                    <option *ngFor="let platform of paymentPlatformsList" [value]="platform">
                      {{platform}}
                    </option>
                  </select>
                  <div *ngIf="client['paymentPlatform'].touched && client['paymentPlatform'].invalid" class="help-block text-danger">
                    <div *ngIf="client['paymentPlatform'].errors && client['paymentPlatform'].errors['required']">
                      Please select payment platform
                    </div>
                  </div>
                </div>
              </div>
              <!-- <div class="col-3 d-flex justify-content-start align-items-start mt-4 " *ngIf="isGenericLink()">
                <button (click)="copylink()" ngxClipboard [cbContent]="genericLink" title="Copy Generic Enrollment Link"
                  class="btn btn-outline-primary text-center p-0 pb-1 px-1 "><u style="font-size:12px">
                    {{lang.Signuplink}}</u></button>
                <i class="fa fa-copy" title="Copy Generic Enrollment Link" style="font-size:16px; cursor:pointer"
                  ></i>
              </div> -->

            </div>
            <div class="row">
              <div class="col-12 col-md-3">
                <div class="form-group">
                  <label for="Corporation" class="Corporation">{{lang.Name_of_Corporation}}<span
                      style="color: red">*</span></label>

                  <input type="text" class="form-control checking-field" id="nameofcorporation"
                    placeholder={{lang.Name_of_Corporation}} formControlName="corporationName"
                    [(ngModel)]="corporationName" />
                  <div *ngIf="
                      client['corporationName'].touched &&
                      client['corporationName'].invalid
                    " class="help-block text-danger">
                    <div *ngIf="
                        client['corporationName'].errors &&
                        client['corporationName'].errors['required']
                      ">
                      {{lang.Please_enter_Corporation_name}}
                    </div>
                    <div *ngIf="
                        client['corporationName'].errors &&
                        client['corporationName'].errors['minlength']
                      ">
                      {{lang.Corporation_name_should_be_2_characters}}
                    </div>
                    <div *ngIf="
                        client['corporationName'].errors &&
                        client['corporationName'].errors['maxlength']
                      ">
                      {{lang.Corporation_name_must_not_exceed_255_characters}}
                    </div>
                    <!-- <div *ngIf="
                        client['corporationName'].errors &&
                        client['corporationName'].errors['pattern']
                      ">
                      Special Characters are not allowed in corporation name.
                    </div> -->
                  </div>
                </div>
              </div>

              <div class="col-12 col-md-3">
                <div class="form-group">
                  <label for="contactEmail" class="Corporation">Contact Email<span
                      style="color: red;">*</span></label>
                  <!-- <input type="text" class="form-control checking-field" id="contactEmail"
                    placeholder="Contact Email" formControlName="contactEmail" [(ngModel)]="contactEmail"/> -->
                  <input type="text" class="form-control checking-field" id="contactEmail" placeholder='Contact Email'
                      formControlName="contactEmail" (input)="textChangeToLowerCase2('contactEmail')" style="text-transform: none;" />
                  <p class="mt-1 mb-0" style="font-size: 11px; line-height: 12px;">
                    *This contact will be used as a primary communication for major process emails such as payments, invoices, etc,.
                  </p>
                  <div *ngIf="client['contactEmail'].touched && client['contactEmail'].invalid" class="help-block text-danger">
                    <div *ngIf="client['contactEmail'].errors && client['contactEmail'].errors['required']">
                      Please enter contact Email
                    </div>
                  </div>
                </div>
              </div>
              
              <div class="col-12 col-md-3">
                <div class="form-group">
                  <label for="Corporation" class="Corporation">{{lang.Policy_Start_Date}}
                    <span style="color: red">*</span>
                  </label>
                  <select class="form-control" id="planenrollmentdate" placeholder="Select"
                    formControlName="PolicyStartDate" [(ngModel)]="PolicyStartDate">
                    <option value="" [disabled]="true">{{lang.Select}}</option>
                    <option *ngFor="let name of enrollmentDates" [value]="name" [label]="name">
                      {{ name }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="col 12 col-md-3">
                <div class="form-group">
                  <label for="multiSelectProviance" class="Corporation">
                    {{lang.Provincial_offices_in_Operation}}
                  <span
                      style="color: red">*</span></label>
                  <ng-multiselect-dropdown #multiSelectDropdown formControlName="multiSelectProviance"
                    placeholder={{lang.Select}} [settings]="dropdownSettings" [data]="multiSlectProviances"
                    (onSelect)="multiSelectProvianceItemSelect($event)"
                    (onSelectAll)="multiSelectProvianceSelectAll($event)"
                    (onDeSelect)="multiSelectProvianceItemDeSelect($event)" (onDeSelectAll)="
                      multiSelectProvianceItemDeSelectAll($event)
                    ">


                    <!-- please select Atleast one Province -->
                  </ng-multiselect-dropdown>
                  <div *ngIf="client['multiSelectProviance'].touched" class="help-block text-danger">
                    <div *ngIf="
                        client['multiSelectProviance'].errors &&
                        client['multiSelectProviance'].errors['required']
                      ">
                      {{lang.Please_select_Atleast_one_Province}}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12 col-md-6">
                <div class="form-group">
                  <label for="Corporation" class="Corporation">{{lang.Street_Address}}
                    <span
                      style="color: red">*</span>
                  </label>
                  <input type="text" class="form-control checking-field" id="Street Address"
                    placeholder={{lang.Street_Address}} (keypress)="alphaNumarics($event)"
                    formControlName="streetAddress" [(ngModel)]="streetAddress" />
                  <div *ngIf="
                      client['streetAddress'].touched &&
                      client['streetAddress'].invalid
                    " class="help-block text-danger">
                    <div *ngIf="
                        client['streetAddress'].errors &&
                        client['streetAddress'].errors['required']
                      ">
                      {{lang.Please_enter_street_address}}
                    </div>
                    <div *ngIf="
                        client['streetAddress'].errors &&
                        client['streetAddress'].errors['pattern']
                      ">
                      {{lang.Special_Characters_Blank_Spaces_are_not_allowed_in_street_address}}
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-12 col-md-3">
                <div class="form-group">
                  <label for="Corporation" class="Corporation">{{lang.Street_Address_Line_2}}</label>

                  <input type="text" class="form-control checking-field" id="StreetAddreess2"
                    (keypress)="alphaNumarics($event)" placeholder={{lang.Street_Address_Line_2}}
                    [(ngModel)]="streetAddress2" formControlName="streetAddress2" />
                  <div *ngIf="
                      client['streetAddress2'].errors &&
                      client['streetAddress2'].errors['pattern']
                    " class="help-block text-danger">
                    {{lang.Special_Characters_Blank_Spaces_are_not_allowed_in_street_address}}
                  </div>
                </div>
              </div>
              <div class="col-12 col-md-3">
                <div class="form-group">
                  <label for="Corporation" class="Corporation">{{lang.Unit_Apt_Suite}} #</label>

                  <input type="text" class="form-control checking-field" id="apt_suite"
                    placeholder={{lang.Unit_Apt_Suite}}# [(ngModel)]="aptSuite" formControlName="apt_suite" />
                  <!-- <div *ngIf="
                      client['apt_suite'].errors &&
                      client['apt_suite'].errors['pattern']
                    " class="help-block text-danger">

                  </div> -->
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12 col-md-3">
                <div class="form-group">
                  <label for="Corporation" class="Corporation">{{lang.Country}}<span style="color: red">*</span></label>

                  <select class="form-control" id="country" placeholder="Country" formControlName="country"
                    [(ngModel)]="country" (change)="getprovincelist($event)">
                    <option value="" [disabled]="true">{{lang.Select}}</option>
                    <option *ngFor="let country of countryList" [value]="country.name">
                      {{ country.name }}
                    </option>
                  </select>
                  <div *ngIf="
                      client['country'].touched && client['country'].invalid
                    " class="help-block text-danger">
                    <div *ngIf="
                        client['country'].errors &&
                        client['country'].errors['required']
                      ">
                      {{lang.Please_select_country}}
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-12 col-md-3">
                <div class="form-group">
                  <label for="Corporation" class="Corporation">{{lang.City}}<span style="color: red">*</span></label>

                  <input type="text" class="form-control checking-field" id="city" placeholder={{lang.City}}
                    style="text-transform: capitalize" formControlName="city" [(ngModel)]="city" />
                  <div *ngIf="client['city'].touched && client['city'].invalid" class="help-block text-danger">
                    <div *ngIf="
                        client['city'].errors &&
                        client['city'].errors['required']
                      ">
                      {{lang.Please_enter_city}}
                    </div>
                    <div *ngIf="
                        client['city'].errors &&
                        client['city'].errors['pattern']
                      ">
                      {{lang.Special_Characters_Blank_Spaces_are_not_allowed_in_city}}.
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-12 col-md-3">
                <div class="form-group">
                  <label for="Corporation" class="Corporation">{{ provianceDispaly
                    }}<span style="color: red">*</span></label>
                  <select class="form-control" id="Province" placeholder="Province" formControlName="Province"
                    (change)="provincelist($event)" [(ngModel)]="province">
                    <option value="" [disabled]="true">{{lang.Select}}</option>
                    <option *ngFor="let name of configprovincereslist" [value]="name.shortName">
                      {{ name.shortName }}
                    </option>
                  </select>

                  <div *ngIf="
                      client['Province'].touched && client['Province'].invalid
                    " class="help-block text-danger">
                    <div *ngIf="
                        client['Province'].errors &&
                        client['Province'].errors['required']
                      ">
                      {{lang.Please_select_Province}}
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-12 col-md-3">
                <div class="form-group">
                  <label for="Corporation" class="Corporation">{{
                    postalCodeDisplay
                    }}<span style="color: red">*</span></label>

                  <input type="text" class="form-control checking-field" id="postalcode"
                    placeholder={{postalCodeDisplay}} onkeyup="this.value = this.value.toUpperCase();"
                    formControlName="postalCode" [(ngModel)]="postalCode"
                    (input)="changeTextToUppercase('postalcode', $event)" />
                  <div *ngIf="client['postalCode'].touched" class="help-block text-danger">
                    <div *ngIf="
                        client['postalCode'].errors &&
                        client['postalCode'].errors['required']
                      ">
                      {{lang.Please_enter_postal_code}}
                    </div>
                    <div *ngIf="
                        invalidpostalcodeprivince ||
                        (client['postalCode'].touched &&
                          client['postalCode'].hasError('invalidPostalCode'))
                      ">
                      {{lang.Please_enter_valid_postal_code}}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="row pt-2">
              <div class="form-group col-12">
                <h6 class="admintitle" style="
                  height: 35px;
                  display: flex;
                  justify-content: space-between;
                  align-items: center;
                  padding: 0px 10px;
                ">
                  {{lang.Group_Contacts}}
                  <button *ngIf="showaddadmin" class="m-0 btn btn-primary addgroupadmininfo" type="button"
                    data-bs-toggle="modal" data-bs-target="#basicModal1" (click)="hidegrpadmindetails()">
                    +&nbsp;{{lang?.Add ?? 'Add'}}
                  </button>
                </h6>
              </div>
            </div>

            <form class="onbordingform" [formGroup]="adminform" (ngSubmit)="addadmin()" *ngIf="addadminform">
              <div class="row">
                <div class="col-12 col-md-3">
                  <div class="form-group">
                    <label for="Corporation" class="Corporation">{{lang.First_Name}}<span
                        style="color: red">*</span></label>

                    <input type="text" class="form-control checking-field" id="adminfirstname"
                      placeholder={{lang.First_Name}} (keypress)="alphabatesOnly($event)"
                      formControlName="adminfirstname" style="text-transform: capitalize" />

                    <div *ngIf="
                        f['adminfirstname'].touched &&
                        f['adminfirstname'].invalid
                      " class="help-block text-danger">
                      <div *ngIf="
                          f['adminfirstname'].errors &&
                          f['adminfirstname'].errors['required']
                        ">
                        {{lang.Please_enter_first_name}}
                      </div>
                      <div *ngIf="
                          f['adminfirstname'].errors &&
                          f['adminfirstname'].errors['minlength']
                        ">
                        {{lang.First_name_should_be_3_characters}}
                      </div>
                      <div *ngIf="
                          f['adminfirstname'].errors &&
                          f['adminfirstname'].errors['maxlength']
                        ">
                        {{lang.First_name_must_not_exceed_20_characters}}
                      </div>
                      <div *ngIf="
                          f['adminfirstname'].errors &&
                          f['adminfirstname'].errors['pattern']
                        ">
                        {{lang.First_Name_Shouldn_t_allow_numbers_special_characters_and_blank_spaces}}

                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-12 col-md-3">
                  <div class="form-group">
                    <label for="Corporation" class="Corporation">{{lang.Last_Name}}<span
                        style="color: red">*</span></label>

                    <input type="text" class="form-control checking-field" id="adminlastname"
                      (keypress)="alphabatesOnly($event)" placeholder={{lang.Last_Name}}
                      style="text-transform: capitalize" formControlName="adminlastname" />

                    <div *ngIf="
                        f['adminlastname'].touched && f['adminlastname'].invalid
                      " class="help-block text-danger">
                      <div *ngIf="
                          f['adminlastname'].errors &&
                          f['adminlastname'].errors['required']
                        ">
                        {{lang.Please_enter_Last_name}}
                      </div>
                      <div *ngIf="
                          f['adminlastname'].errors &&
                          f['adminlastname'].errors['minlength']
                        ">
                        {{lang.Last_name_should_be_2_characters}}
                      </div>
                      <div *ngIf="
                          f['adminlastname'].errors &&
                          f['adminlastname'].errors['maxlength']
                        ">
                        {{lang.Last_name_must_not_exceed_20_characters}}
                      </div>
                      <div *ngIf="
                          f['adminlastname'].errors &&
                          f['adminlastname'].errors['pattern']
                        ">
                        {{lang.Last_Name_Shouldn_t_allow_numbers_special_characters_and_blank_spaces}}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-12 col-md-3">
                  <div class="form-group">
                    <label for="Corporation" class="Corporation">{{lang.Phone_Number}}<span
                        style="color: red">*</span></label>

                    <input type="tel" class="form-control checking-field" id="adminphone"
                      placeholder={{lang.Phone_Number}} (keypress)="numberOnly($event)" (change)="phoneFormat($event)"
                      formControlName="adminphone" />

                    <div *ngIf="f['adminphone'].touched && f['adminphone'].invalid" class="help-block text-danger">
                      <div *ngIf="
                          f['adminphone'].errors &&
                          f['adminphone'].errors['required']
                        ">
                        {{lang.Please_enter_phone_number}}
                      </div>
                      <div *ngIf="
                          f['adminphone'].errors &&
                          f['adminphone'].errors['minlength']
                        ">
                        {{lang.Phone_number_minimum_of_10_digits}}
                      </div>
                      <div *ngIf="
                          f['adminphone'].errors &&
                          f['adminphone'].errors['maxlength']
                        ">
                        {{lang.Phone_number_maximum_of_10_digits}}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-12 col-md-3">
                  <div class="form-group">
                    <label for="Corporation" class="Corporation">{{lang.Email}}<span style="color: red">*</span></label>

                    <input type="text" class="form-control checking-field" id="email" placeholder={{lang.Email}}
                      formControlName="adminemail" (input)="textChangeToLowerCase(f, 'adminemail')" />
                    <div *ngIf="f['adminemail'].touched && f['adminemail'].invalid" class="help-block text-danger">
                      <div *ngIf="
                                          f['adminemail'].errors &&
                                          f['adminemail'].errors['required']
                                        ">
                        {{lang.Please_enter_email}}
                      </div>
                      <div *ngIf="
                                          f['adminemail'].errors &&
                                          f['adminemail'].errors['pattern']
                                        ">
                        {{lang.Please_enter_valid_email}}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">

                <div class="col-12 col-md-3">
                  <div class="form-group">
                    <label for="Corporation" class="Corporation">{{lang.Role}}<span style="color: red">*</span></label>

                    <select (change)="othersField($event)" class="form-control" id="adminrole" formControlName="role"
                      placeholder="Role">
                      <option value="" [disabled]="true">{{lang.Select}}</option>
                      <!-- <option *ngFor="let groupContact of groupContactsData" [value]="groupContact['key']">
                        {{groupContact.display}}</option> -->
                      <option value="CORPORATE_ACCOUNTANT">{{lang.Accountant}}</option>
                      <option value="CORPORATE_EXECUTIVE">{{lang.Executive}}</option>
                      <option value="CORPORATE_PLAN_ADMINISTRATOR">
                        {{lang.Plan_Administrator}}
                      </option>
                      <option value="CORPORATE_ADMIN">
                        {{lang.System_Administrator}}
                      </option>
                      <option value="CORPORATE_WELLNESS_CHAMPION">
                        {{lang.Wellness_Champion}}
                      </option>
                      <option value="CORPORATE_OTHERS">{{lang.Others}}</option>
                    </select>

                    <div *ngIf="f['role'].touched && f['role'].invalid" class="help-block text-danger">
                      <div *ngIf="f['role'].errors && f['role'].errors['required']">
                        {{lang.Please_select_role}}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-12 col-md-3" *ngIf="showOtherField">
                  <div class="form-group">
                    <label for="Corporation" class="Corporation">{{lang.Other}}</label>
                    <input type="text" class="form-control checking-field" id="roleName" formControlName="roleName" />
                  </div>
                </div>

                <div class="col-12 col-md-12">
                  <button [hidden]="adminform.invalid" type="submit" class="btn btn-primary">
                    {{lang.Save}}
                  </button>
                </div>
              </div>
            </form>
            <div class="row">
              <div class="col-md-12">
                <div class="form-group">
                  <div style="overflow: auto; direction: ltr; width: 100%" class="mb-2">
                    <table align="left" *ngIf="showaddadmin">
                      <tr>
                        <th>{{lang.First_Name}}</th>
                        <th>{{lang.Last_Name}}</th>
                        <th>{{lang.Phone_Number}}</th>
                        <th>{{lang.Email}}</th>
                        <th>{{lang.Role}}</th>
                        <th></th>
                      </tr>
                      <tbody>
                        <tr *ngFor="let admin of adminData; let i = index"
                          [ngClass]="{ orange: i % 2 == 0, white: i % 2 != 0 }">
                          <td>{{ admin.firstName }}</td>
                          <td>{{ admin.lastName }}</td>
                          <td>{{ admin.phoneNum | phoneFormat }}</td>
                          <td>{{ admin.email }}</td>
                          <td>
                            <!-- <span *ngIf="admin.role=='CORPORATE_ADMIN'">Admin</span> -->
                            <span *ngIf="admin.role == 'CORPORATE_ACCOUNTANT'">{{lang.Accountant}}</span>
                            <span *ngIf="admin.role == 'CORPORATE_ADMIN'"> {{lang.System_Administrator}}
                            </span>
                            <span *ngIf="admin.role == 'CORPORATE_EXECUTIVE'">{{lang.Executive}}</span>
                            <span *ngIf="
                                admin.role == 'CORPORATE_PLAN_ADMINISTRATOR'
                              "> {{lang.Plan_Administrator}}</span>
                            <span *ngIf="
                                admin.role == 'CORPORATE_WELLNESS_CHAMPION'
                              "> {{lang.Wellness_Champion}}</span>
                            <span *ngIf="admin.role == 'CORPORATE_OTHERS'" class="text-capitalize">{{ admin.roleName |
                              titlecase }}</span>
                            <span *ngIf="admin.role == 'CUSTOMER'">Customer</span>
                          </td>

                          <td style="text-align: right; display: inline-flex">
                            <button class="btn btn-default editpencil" data-bs-toggle="modal"
                              data-bs-target="#basicModaledit" (click)="editadmin(admin, i)">
                              <i class="bi bi-pencil-fill"></i></button>&nbsp;&nbsp;<button
                              class="btn btn-default deleteicon" (click)="deleteadmin(i)">
                              <i class="bi bi-trash-fill"></i>
                            </button>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <!-- <button *ngIf="showaddadmin" class="btn btn-primary addgroupadmininfo" type="button"
                  data-bs-toggle="modal" data-bs-target="#basicModal1" (click)="hidegrpadmindetails()">
                  {{lang.Add_More}}
                </button> -->
              </div>
            </div>
            <div class="row">
              <div class="form-group col-md-12">
                <h6 class="admintitle">
                  {{lang.Enrollment_start_date_for_new_hires}}&nbsp;&nbsp;
                </h6>
              </div>
              <div class="row mt-1">
                <div class="form-group col-5">
                  <div class="label waitingperiod">
                    <b>{{lang.Waiting_period_for_new_hires}}</b>
                    <!-- <b>Waiting Period for new hires</b> -->
                  </div>

                  <!-- <table class="newhiresperiod">

                                  <tr class="waitingperiodTable">
                                    <td><input type="radio"  name="waitingPeriod" formControlName="waitingPeriod" value="0" id="nowaitingPeriod"  [(ngModel)]="waitTime" [checked]="waitTime == 0 || waitTime == '0'" (change)="customSelected = false" />&nbsp;<label for="y" class="waitingperiod">No Waiting Period</label></td>
                                    <td><input type="radio"  name="waitingPeriod" formControlName="waitingPeriod" value="3" id="3" [(ngModel)]="waitTime" [checked]="waitTime == 3 || waitTime == '3'" (change)="customSelected = false" />&nbsp;<label for="y" class="waitingperiod">Three Months</label></td>
                                    <td><input type="radio"  name="waitingPeriod" formControlName="waitingPeriod" value="6" id="6" [(ngModel)]="waitTime" [checked]="waitTime == 6 || waitTime == '6'" (change)="customSelected = false" />&nbsp;<label for="y" class="waitingperiod">Six Months</label></td>
                                    <td><input type="radio"  name="waitingPeriod" formControlName="waitingPeriod" value=""  id="custom" (change)="customSelected = true"/>&nbsp;<label for="y" class="waitingperiod">Custom</label></td>
                                    <td *ngIf="customSelected"><input type="text" class="form-control1"  (keypress)="numberOnly($event)" id="y"  formControlName="waitingPeriod" name="waitingPeriod" style="width:25%;margin-top:-5px"/>&nbsp;Months</td>
                                  </tr>

                                  <div *ngIf="client['waitingPeriod'].touched && client['waitingPeriod'].invalid" class="help-block text-danger">
                                    <div *ngIf="client['waitingPeriod'].errors && client['waitingPeriod'].errors['required']">Please select waiting period</div>
                                  </div>

                                </table> -->
                  <!-- <div class="row">   [checked]="NoWaithingPeridos"  [checked]="threeMonths"  [checked]="SixMonths" -->
                  <div class="d-flex gap-1 flex-shrink-0 ">
                    <div class="d-flex">
                      <input type="radio" class="" name="waitingPeriod" formControlName="waitingPeriod"
                        id="nowaitingPeriod" [value]="0" (change)="waitingPeriodChange($event)" />&nbsp;<label
                        for="nowaiting" class="form-check-label pe-1 my-auto">{{lang.None}}</label>
                    </div>

                    <div class="d-flex">
                      <input type="radio" name="waitingPeriod" class="" formControlName="waitingPeriod" id="threemonths"
                        [value]="3" (change)="waitingPeriodChange($event)" />&nbsp;<label for="threemonths"
                        class="form-check-label pe-1 my-auto">{{lang.Three_Months}}
                      </label>
                    </div>
                    <div class="d-flex">
                      <input type="radio" name="waitingPeriod" class="" formControlName="waitingPeriod" id="sixmonths"
                        [value]="6" (change)="waitingPeriodChange($event)" />&nbsp;<label for="sixmonths"
                        class="form-check-label pe-1 my-auto">{{lang.Six_Months}}
                      </label>
                    </div>
                    <div class="d-flex">
                      <input type="radio" name="waitingPeriod" class="" formControlName="waitingPeriod"
                        id="customselection" value="Custom" (change)="waitingPeriodChange($event)" />&nbsp;<label
                        for="customselection" class="form-check-label pe-1 my-auto">{{lang.Custom}}</label>
                    </div>

                  </div>

                  <div class="form-group col-3 ps-0 pe-0 mt-0 mb-0  ">
                    <div *ngIf="customSelected">
                      <label for="customMonths" class="">{{lang.Months}}<span style="color: red">*</span></label>
                      <input type="number" [min]="1" class="form-control" (keypress)="numberOnly($event)"
                        id="customMonths" [(ngModel)]="waitTime" formControlName="waitingPeriodCustom" />&nbsp;
                    </div>
                    <span class="help-block text-danger"
                      *ngIf="client['waitingPeriodCustom'].errors && client['waitingPeriodCustom'].errors['required']">
                      {{lang.Please_enter_months}}
                    </span>
                    <span class="help-block text-danger"
                      *ngIf="client['waitingPeriodCustom'].errors && client['waitingPeriodCustom'].errors['min']">
                      {{lang.Please_enter_valid_number_of_months}}
                    </span>
                  </div>


                  <!-- <input type="radio" name="waitingPeriod" class="" formControlName="waitingPeriod" [value]="" id="customselection"  (change)="customSelected=true"
                                       />&nbsp;<label for="customselection" class="form-check-label pe-1">Custom</label> -->

                  <!-- </div> -->

                  <!-- </div> -->
                </div>

                <div class="form-group col-5">
                  <div class="label waitingperiod" style="margin-bottom: 15px">
                    <!-- <b>{{lang.Waiting_period_for_Employees_on_initial_sign_up}}</b> -->
                    <b>Waiting period for Employees on initial enrollment</b>

                    <br />
                    <div class="row mt-1">

                      <div class="form-check col-3">
                        <input type="radio" name="waitingPeriodinitialsignup" id="waitingPeriodinitialsignupNo"
                          [value]="false" formControlName="waitingPeriodinitialsignup" />
                        <label for="waitingPeriodinitialsignupNo"
                          class="walletConfig my-auto">&nbsp;&nbsp;{{lang.No}}</label>
                      </div>
                      <div class="form-check col-3">
                        <input type="radio" name="waitingPeriodinitialsignup" id="waitingPeriodinitialsignupYes"
                          [value]="true" formControlName="waitingPeriodinitialsignup" />
                        <label for="waitingPeriodinitialsignupYes"
                          class="walletConfig my-auto">&nbsp;&nbsp;{{lang.Yes}}</label>
                      </div>
                      <div *ngIf="
                          client['waitingPeriodinitialsignup'].touched &&
                          client['waitingPeriodinitialsignup'].invalid
                        " class="help-block text-danger">
                        <div *ngIf="
                            client['waitingPeriodinitialsignup'].errors &&
                            client['waitingPeriodinitialsignup'].errors[
                              'required'
                            ]
                          ">
                          <!-- {{lang.Please_Select_waiting_period_for_employees_on_initial_signup}} -->
                          Please Select waiting period for employees on initial enrollment
                        </div>
                      </div>
                    </div>

                    <!-- <input type="radio" class="form-check-input border border-dark" formControlName="waitingPeriodinitialsignup" name="waitingPeriodinitialsignup" value=true >
                    <label class="walletConfig" style="padding-left: 5px;font-size: 12px;">Yes</label>
                    <input type="radio" class="form-check-input border border-dark" formControlName="waitingPeriodinitialsignup" name="waitingPeriodinitialsignup" value=false style="margin-left: 15px;">
                    <label class="walletConfig" style="padding-left: 5px;font-size: 12px;">No</label> -->
                    <!-- <div class="help-block text-danger"
                    *ngIf="clientregform.get('waitingPeriodinitialsignup').touched&&
                    client['waitingPeriodinitialsignup'].errors['required']">
                        Please select waiting period for Employees
                   </div> -->
                  </div>
                </div>


              </div>
              <!-- <div class="row text-end" *ngIf="customSelected">
                <div class="help-block text-danger"
                *ngIf="clientregform.get('waitingPeriod').touched&&
                (clientregform.get('waitingPeriod').value==undefined||clientregform.get('waitingPeriod').value=='')">
                    Please enter months
               </div>
              </div> -->
            </div>
            <br />
            <div class="row">
              <div class="col-12 col-md-5" *ngIf="role==='ADMINISTRATOR'">
                <div class="form-group">
                  <h6 class="admintitle">
                    GroupBenefitz Wallet<sup>TM</sup> for employees?&nbsp;&nbsp;
                  </h6>

                  <div class="row">
                    <div class="form-check col-12 col-md-3">
                      <input type="radio" name="walletConfig" id="walletconfigyes" [value]="true"
                        formControlName="walletConfig" [(ngModel)]="setupWallet" [checked]="setupWallet === true"
                        (click)="checkwalletConfig($event)" />
                      <label for="walletconfigyes" class="walletConfig">&nbsp;&nbsp;{{lang.Yes}}</label>
                    </div>
                    <div class="form-check col-12 col-md-3">
                      <input type="radio" name="walletConfig" id="walletconfigyno" [value]="false"
                        formControlName="walletConfig" [(ngModel)]="setupWallet" [checked]="setupWallet === false"
                        (click)="checkwalletConfig($event)" />
                      <label for="walletconfigyno" class="walletConfig">&nbsp;&nbsp;{{lang.No}}</label>
                    </div>

                    <div *ngIf="
                                                      client['walletConfig'].touched &&
                                                      client['walletConfig'].invalid
                                                    " class="help-block text-danger">
                      <div *ngIf="
                                                        client['walletConfig'].errors &&
                                                        client['walletConfig'].errors['required']
                                                      ">
                        {{lang.Please_select_wallet_configuration}}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-12 col-md-5">
                <div class="form-group">
                  <h6 class="admintitle">
                    Define Plan Coverage tiers for employees?&nbsp;&nbsp;
                  </h6>
                  <div class="row">
                    <div class="form-check col-12 col-md-3">
                      <input type="radio" name="tierConfig" id="tierConfigyes" [value]="true"
                        formControlName="tierConfig" [(ngModel)]="setUplevelofCoverage"
                        [checked]="setUplevelofCoverage === true" />
                      <label for="tierConfigyes" class="tierConfig">&nbsp;&nbsp;{{lang.Yes}}</label>
                    </div>
                    <div class="form-check col-12 col-md-3">
                      <input type="radio" name="tierConfig" id="tierConfigno" [value]="false"
                        formControlName="tierConfig" [(ngModel)]="setUplevelofCoverage"
                        [checked]="setUplevelofCoverage === false" />
                      <label for="tierConfigno" class="tierConfig">&nbsp;&nbsp;{{lang.No}}</label>
                    </div>
                    <div *ngIf="
                                                      client['tierConfig'].touched &&
                                                      client['tierConfig'].invalid
                                                    " class="help-block text-danger">
                      <div *ngIf="
                                                        client['tierConfig'].errors &&
                                                        client['tierConfig'].errors['required']
                                                      ">
                        {{lang.Please_select_tier_configuration}}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- <div class="row" style="margin-bottom:5px" *ngIf="clientregform.get('walletConfig')?.value === true">
                <div class="col-12 col-md-5">
                  <div class="form-group">
                    <h6 class="admintitle">
                      Banking Information&nbsp;&nbsp;
                    </h6>
                  </div>
                         <div class="row">
                    <div class="col-12 col-md-4">
                      <div class="form-group">
                        <label for="Corporation" class="Corporation">Bank Code<span style="color: red">*</span></label>
                        <input class="form-control checking-field" id="banknumber" placeholder="Bank Code" name="banknumber"
                          autocomplete="off" formControlName="bankCode" maxlength="3" (input)="touchedmsg()"
                          (keypress)="($event.charCode >= 48 && $event.charCode < 58)" />
<div *ngIf="
                                                      client['bankCode'].touched &&
                                                      client['bankCode'].invalid
                                                    " class="help-block text-danger">
  <div *ngIf="
                                                        client['bankCode'].errors &&
                                                        client['bankCode'].errors['required']
                                                      ">
    Please enter bank code
  </div>
</div>

                          </div>
                      </div>
                        <div class="col-12 col-md-4">
                          <div class="form-group">
                            <label for="Corporation" class="Corporation">Transit Number<span style="color: red">*</span></label>
                            <input class="form-control checking-field" id="branch" placeholder={{lang.Transit}} name="branch"
                              formControlName="BankTransit" autocomplete="off" maxlength="5" (input)="touchedmsg()"
                              (keypress)="($event.charCode >= 48 && $event.charCode < 58)" />
                              <div *ngIf="
                                                                                    client['BankTransit'].touched &&
                                                                                    client['BankTransit'].invalid
                                                                                  " class="help-block text-danger">
                                <div *ngIf="
                                                                                      client['BankTransit'].errors &&
                                                                                      client['BankTransit'].errors['required']
                                                                                    ">
                                  Please enter bank transit number
                                </div>
                              </div>
                          </div>
                        </div>
                        <div class="col-12 col-md-4">
                          <div class="form-group">
                            <label for="Corporation" class="Corporation">Account Number<span style="color: red">*</span></label>
                                        <input class="form-control checking-field" id="accountnumber" placeholder="Account Number" autocomplete="off"
                                          name="accountnumber" formControlName="accounNum" maxlength="12" (input)="touchedmsg()"
                                          (keypress)="($event.charCode >= 48 && $event.charCode < 58)" />
                                            <div *ngIf="
                                                                                                                                client['accounNum'].touched &&
                                                                                                                                client['accounNum'].invalid
                                                                                                                              " class="help-block text-danger">
                                              <div *ngIf="
                                                                                                                                  client['accounNum'].errors &&
                                                                                                                                  client['accounNum'].errors['required']
                                                                                                                                ">
                                                Please enter account number
                                              </div>
                                            </div>
                          </div>
                        </div>


                          </div>
                          <div class="row" style="margin-top:5px">
                            <div class="col-12 col-md-3">
                              <button class="saveAndNext" id="basicformSubmit1stScreen" type="button" (click)="submitBankInfo()">
                                Verify
                              </button>
                            </div>
                          </div>
                </div>
              </div> -->
            <div class="row">
              <div class="col-12 col-md-5">
                <div class="form-group">
                  <h6 class="admintitle">
                    {{lang.Payment_Information}}&nbsp;&nbsp;
                  </h6>

                  <div class="form-check ps-0 d-flex">
                    <input class="" type="radio" id="creditpaymentInfo" name="paymentInfo" formControlName="paymentInfo"
                      value="creditcard" (click)="checkPaymentInfo($event)" />
                    <label class="form-check-label ps-1 my-auto" for="flexRadioDefault1">
                      {{lang.Credit_Card}}
                    </label>
                  </div>
                  <div class="form-check ps-0 d-flex">
                    <input class="" type="radio" id="padcreditpaymentInfo" name="paymentInfo"
                      formControlName="paymentInfo" value="pad" (click)="checkPaymentInfo($event)" />
                    <label class="form-check-label ps-1 my-auto" for="flexRadioDefault2">
                      {{lang.Pre_Authorized_Debit}}
                    </label>
                  </div>
                  <div class="form-check d-flex">
                    <input class="form-check-input" type="radio" name="paymentInfo" id="invoicepaymentInfo"
                      formControlName="paymentInfo" value="invoicemonthy" (click)="checkPaymentInfo($event)"
                      *ngIf="role == 'CORPORATE_ADMIN'" />
                    <label class="form-check-label my-auto" for="flexRadioDefault3" *ngIf="role == 'CORPORATE_ADMIN'">
                      {{lang.Invoice_Monthly}}
                    </label>
                  </div>
                  <div *ngIf="
                      client['paymentInfo'].touched &&
                      client['paymentInfo'].invalid
                    " class="help-block text-danger">
                    <div *ngIf="
                        client['paymentInfo'].errors &&
                        client['paymentInfo'].errors['required']
                      ">
                      {{lang.Please_select_payment_information}}
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-12 col-md-5">
                <div class="form-group">
                  <h6 class="admintitle">
                    {{lang.Corporate_Logo}}&nbsp;&nbsp;<label for="adminlogo" class="adminlogo1"
                      *ngIf="uploadlogoafter"><strong>&nbsp;{{lang.Update}}</strong></label>
                  </h6>
                  <div class="uploadCorporateLogo">
                    <label style="float: right; color: red" title="Delete logo" *ngIf="uploadlogoafter"
                      (click)="uploadadminlogoclear($event)"><i class="bi bi-trash-fill"></i></label>

                    <label for="adminlogo" class="adminlogo">
                      <span *ngIf="showimagelogo">
                        <p style="font-size: 10px">
                          {{lang.Click_to_upload_COMPANY_LOGO_Max_300x100_px_png_jpg}}
                        </p>
                      </span>
                      <img *ngIf="!showimagelogo" [src]="imagedisplay" style="max-height: 50px" />
                    </label>

                    <input id="adminlogo" type="file" accept="image/*" style="display: none"
                      formControlName="corporatelogo" (change)="uploadadminlogo($event)" />

                    <input id="adminlogo1" type="file" accept="image/*" style="display: none"
                      formControlName="corporatelogo" (change)="uploadadminlogo1($event)" />
                  </div>

                  <div *ngIf="
                      client['corporatelogo'].touched &&
                      client['corporatelogo'].invalid
                    " class="help-block text-danger">
                    <div *ngIf="
                        client['corporatelogo'].errors &&
                        client['corporatelogo'].errors['required']
                      ">
                      {{lang.Please_upload_corporate_logo}}
                    </div>
                  </div>
                </div>
              </div>
            </div>


            <div class="row">
              <div class="col-12 col-md-3">
                <div class="form-group">
                  <h6 class="admintitle">
                    <!-- {{lang.Show_Employer_Name_for_Signups}}?&nbsp;&nbsp; -->
                    Show Employer Name for Enrollments?&nbsp;&nbsp;
                  </h6>

                  <div class="row">
                    <div class="form-check col-12 col-md-6">
                      <input type="radio" name="ShowEmployer" id="ShowEmployerYes" value="true"
                        formControlName="ShowEmployer" />
                      <label for="ShowEmployerYes" class="walletConfig">&nbsp;&nbsp;{{lang.Yes}}</label>
                    </div>
                    <div class="form-check col-12 col-md-6">
                      <input type="radio" name="ShowEmployer" id="ShowEmployerno" value="false"
                        formControlName="ShowEmployer" />
                      <label for="ShowEmployerNo" class="walletConfig">&nbsp;&nbsp;{{lang.No}}</label>
                    </div>

                    <div *ngIf="
                        client['ShowEmployer'].touched &&
                        client['ShowEmployer'].invalid
                      " class="help-block text-danger">
                      <div *ngIf="
                          client['ShowEmployer'].errors &&
                          client['ShowEmployer'].errors['required']
                        ">
                        {{lang.Please_select_wallet_configuration}}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-12 col-md-3" *ngIf="role==='ADMINISTRATOR'">
                <div class="form-group">
                  <h6 class="admintitle">
                    {{lang.Auto_select_plans_for_Employee}}?&nbsp;&nbsp;
                  </h6>
                  <div class="row">
                    <div class="form-check col-12 col-md-6">
                      <input type="radio" name="autoSelectEmp" id="tierConfigyes" [value]="true"
                        formControlName="autoSelectEmp" />
                      <label for="autoSelectEmpYes" class="tierConfig">&nbsp;&nbsp;{{lang.Yes}}</label>
                    </div>
                    <div class="form-check col-12 col-md-6">
                      <input type="radio" name="autoSelectEmp" id="tierConfigno" [value]="false"
                        formControlName="autoSelectEmp" />
                      <label for="autoSelectEmpno" class="tierConfig">&nbsp;&nbsp;{{lang.No}}</label>
                    </div>
                    <div *ngIf="
                        client['autoSelectEmp'].touched &&
                        client['autoSelectEmp'].invalid
                      " class="help-block text-danger">
                      <div *ngIf="
                          client['autoSelectEmp'].errors &&
                          client['autoSelectEmp'].errors['required']
                        ">
                        {{lang.Please_select}}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-12 col-md-3" *ngIf="role==='ADMINISTRATOR'">
                <div class="form-group">
                  <h6 class="admintitle">
                    Show Employee List Page?&nbsp;&nbsp;
                  </h6>
                  <!-- <div class="label waitingperiod">
      Employee Data
    </div> -->
                  <div class="row">
                    <div class="form-check col-12 col-md-6">
                      <input type="radio" name="showEmployeeList" id="tierConfigyes" [value]="true" t
                        data-toggle="tooltip" formControlName="showEmployeeListData" />
                      <label for="showEmployeeListYes" class="tierConfig">&nbsp;&nbsp;{{lang.Yes}}</label>
                    </div>
                    <div class="form-check col-12 col-md-6">
                      <input type="radio" name="showEmployeeList" id="tierConfigno" [value]="false"
                        formControlName="showEmployeeListData" />
                      <label for="showEmployeeListno" class="tierConfig">&nbsp;&nbsp;{{lang.No}}</label>
                    </div>
                    <div *ngIf="
                                      client['showEmployeeListData'].touched &&
                                      client['showEmployeeListData'].invalid
                                    " class="help-block text-danger">
                      <div *ngIf="
                                        client['showEmployeeListData'].errors &&
                                        client['showEmployeeListData'].errors['required']
                                      ">
                        {{lang.Please_select}}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-12 col-md-3">
                <div class="form-group">
                  <h6 class="admintitle mb-2">{{lang.No_of_Employees}}</h6>

                  <input type="text" class="form-control text-center" formControlName="expectednoofEmployees"
                    (keypress)="numberOnly($event)" (paste)="onPaste($event)" [(ngModel)]="noOfEmployees" />
                  <div *ngIf="
                                    client['expectednoofEmployees'].touched &&
                                    client['expectednoofEmployees'].invalid
                                  " class="help-block text-danger">
                    <div *ngIf="
                                      client['expectednoofEmployees'].errors &&
                                      client['expectednoofEmployees'].errors['required']
                                    ">
                      {{lang.Please_enter_no_of_employees}}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="row">

            </div>
            <!-- </fieldset> -->
          </form>

          <div class="d-flex justify-content-between" style="padding-top: 10px">
            <button class="saveAndNext" id="" type="button" (click)="gotodashboard()">
              <i aria-hidden="true" class="fa fa-long-arrow-left"></i>&nbsp;&nbsp;Previous
            </button>

            <button class="saveAndNext" id="basicformSubmit1stScreen" type="button" (click)="submitbasicInfo()">
              {{ basicInfoFormTouched ? '{{lang.Save_Next}}' : 'Plans' }}&nbsp;&nbsp;<i aria-hidden="true"
                class="fa fa-long-arrow-right"></i>
            </button>
          </div>
        </div>

        <div *ngIf="showTiersTable">
          <div class="row paddingHeader">
            <div class="col-12 col-md-12 d-flex justify-content-between"
              style="background:#142a49!important; font-size:14px">
              <h6 class="admintitle my-auto">
                Manage Tiers&nbsp;&nbsp;
              </h6>
              <button class="addCustomer my-auto" (click)="addNewTier()">+&nbsp;Add Tier</button>


            </div>
          </div>
          <div class="d-flex flex-column justify-content-between" style="min-height: 80vh;">
            <div class="row">
              <div class="table-responsive manage-tiers">
                <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" id="DataTables_Table_0"
                  class="table text-nowrap">
                  <thead>
                    <tr>
                      <!-- <th>S.no</th> -->
                      <th>S.no</th>
                      <th>Tier Name</th>
                      <!-- <th>Description</th> -->
                      <th>Time of Service</th>
                      <th>Member Count</th>
                      <th>Plans</th>
                      <th>Link</th>
                      <th>Wallet</th>
                      <th>Status</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let item of corporateTiers;let i = index">
                      <td>{{i+1}}</td>
                      <td>{{item.name}}</td>
                      <!-- <td>{{item.description}}</td> -->
                      <td>
                        <span *ngIf="item.timeOfService==false">None</span>
                        <span
                          *ngIf="item.timeOfService==true">Min:&nbsp;{{item.fromLength}}&nbsp;{{item.timeOfServiceValue}}
                          <br> Max:&nbsp;{{item.toLength}}&nbsp;{{item.timeOfServiceValue}}</span>
                      </td>
                      <td class="tierMember" (click)="showTierMember(item)" style="text-align:center">
                        {{item.memberCount}}</td>
                      <td>
                        <ng-container
                          *ngIf="item.plans?.paidByCompany?.length > 0 || item.plans?.coveredByCompany?.length > 0 || item.plans?.paidByEmployee?.length > 0; else noData">
                          <!-- <span *ngIf="item.plans?.paidByCompany?.length > 0">
                          {{ getPaidByCompanyPlanLevelNames(item.plans?.paidByCompany) }}
                        </span>
                        <span *ngIf="item.plans?.coveredByCompany?.length > 0">
                          {{ getCoveredByCompanyPlanLevelNames(item.plans?.coveredByCompany) }}
                        </span>
                        <span *ngIf="item.plans?.paidByEmployee?.length > 0">
                          {{ getEmployeePaidPlanLevelNames(item.plans?.paidByEmployee) }}
                        </span> -->
                          <span *ngFor="let plan of item.plans?.paidByCompany">
                            {{plan.planLevelName}}<span *ngIf="plan.coverage"><span
                                *ngIf="plan.coverage==001">-Single</span><span
                                *ngIf="plan.coverage==010">-Couple</span><span
                                *ngIf="plan.coverage==100">-Family</span></span>
                            <!-- <span *ngIf="plan?.coverage!=''">({{getCoverage(plan?.coverage)}})</span> -->
                            <br />
                          </span>
                          <span *ngFor="let plan of item.plans?.coveredByCompany">
                            {{plan.planLevelName}}<span *ngIf="plan.coverage"><span
                                *ngIf="plan.coverage==001">-Single</span><span
                                *ngIf="plan.coverage==010">-Couple</span><span
                                *ngIf="plan.coverage==100">-Family</span></span>
                            <!-- <span *ngIf="plan?.coverage!=''">({{getCoverage(plan?.coverage)}})</span> -->
                            <br />
                          </span>
                          <span *ngFor="let plan of item.plans?.paidByEmployee">
                            {{plan.planLevelName}}<span *ngIf="plan.coverage"><span
                                *ngIf="plan.coverage==001">-Single</span><span
                                *ngIf="plan.coverage==010">-Couple</span><span
                                *ngIf="plan.coverage==100">-Family</span></span>
                            <!-- <span *ngIf="plan?.coverage!=''">({{getCoverage(plan?.coverage)}})</span> -->
                            <br />
                          </span>
                        </ng-container>

                        <ng-template #noData>
                          <span>NA</span>
                        </ng-template>
                      </td>
                      <td [ngClass]="(item.plans.paidByCompany.length > 0 ||
                      item.plans.coveredByCompany.length > 0 || item.plans.paidByEmployee.length > 0)
                      &&item.status!='Inactive'?'tierMemeber':''">
                        <ng-container *ngIf="(item.plans.paidByCompany.length > 0 ||
                        item.plans.coveredByCompany.length > 0 || item.plans.paidByEmployee.length > 0)
                        &&item.status!='Inactive'; else noData">
                          <span style="font-size:14px;">
                            <a class="spanCopy" target="_blank" [href]="item.signupLink" [disabled]="true"><span
                                style="font-size:14px;">
                                <!-- {{lang.Sign_up_Link}} -->
                                Enrollment Link
                              </span></a>
                          </span>
                          <span style="font-size:10px;">
                            <button id="copyButton" style="border: none"
                              class="spanCopy1 btnSizes mt-1 ms-1 mb-2 ftsize12 cursor-pointer"
                              (click)="copyToClipboard(item.signupLink)" data-bs-toggle="tooltip"
                              data-bs-placement="top" title="Copy">
                              <a href style="
                              pointer-events: none;
                              font-family: sans-serif;
                              text-decoration: none !important;
                            ">
                                <img src="../../../assets/img/copy.svg" class="widHigSvgIcon" /></a>
                            </button>
                          </span>
                        </ng-container>
                      </td>
                      <td class="tierMember">

                        <span *ngIf="item.wallet==false">No</span>
                        <span *ngIf="item.wallet==true" id="tooltip">Yes
                          <table class="tooltiptext ignoreTable">


                            <tbody>
                              <tr class="ignoreTable">
                                <td>Wallet Amount</td>
                                <td>${{item.walletConfig.walletAmount}}</td>
                              </tr>
                              <tr class="ignoreTable" (click)="onWalletTypeClick(item)">
                                <td>Wallet Type</td>
                                <td>{{item.walletConfig.walletTypeDisplay}}</td>
                              </tr>
                              <tr class="ignoreTable">
                                <td>Carry Forward Amount</td>
                                <td>
                                  <span *ngIf="item.walletConfig.carryForwardUnusedAmount==true">Yes</span>
                                  <span *ngIf="item.walletConfig.carryForwardUnusedAmount==false">No</span>
                                </td>
                              </tr>
                              <tr class="ignoreTable" *ngIf="item.walletConfig.carryForwardUnusedAmount">
                                <td>Allocated</td>
                                <td>{{item.walletConfig.rolloverAllocationPeriodDisplay}}</td>
                              </tr>
                              <tr class="ignoreTable">
                                <td>Industry Category</td>
                                <td>{{item.walletConfig.industryCategory}}</td>
                              </tr>
                              <tr class="ignoreTable">
                                <!-- <td>Advisor Fee:{{item.walletConfig.advisorFeeStructure}}</td> -->
                                <td>Advisor Commission</td>
                                <td>{{item.walletConfig.advisorFeeStructure}}%</td>
                              </tr>
                              <tr class="ignoreTable">
                                <td>Balance SetUp</td>
                                <td>{{item.walletConfig.initialBalanceSetupDisplay}}</td>
                              </tr>
                              <tr class="ignoreTable">
                                <td>Coverage Percenatge</td>
                                <td>{{item.walletConfig.coveragePercentage}}%</td>
                              </tr>
                            </tbody>
                          </table>
                        </span>
                      </td>
                      <td>{{item.status}}</td>
                      <td>
                        <!-- <i class="fa fa-eye" style="font-size:14px;color:blue"></i>&nbsp; -->
                        <i class="fa fa-pencil" style="font-size:14px;color:green;cursor:pointer" title="Edit Tier"
                          (click)="editTier(item)"></i>&nbsp;
                        <i class="fa fa-trash" style="font-size:14px;color:red;cursor:pointer" title="Delete Tier"
                          (click)="deleteTier(item)"></i>&nbsp;
                        <i class="fa fa-history" style="font-size:14px;color:blueviolet;cursor:pointer"
                          title="Tier History" (click)="showHistory(item)"></i>
                      </td>
                    </tr>

                  </tbody>
                </table>
                <div class="row" style="margin-bottom:5px" *ngIf="clientregform.get('walletConfig')?.value === true">
                  <div class="col-12 col-md-12">
                    <div class="form-group">
                      <h6 class="admintitle">
                        General Information for GroupBenefitz Wallet
                      </h6>
                    </div>
                    <form [formGroup]="bankingInfoForm">
                      <div class="row">
                        <div class="col-12 col-md-4">
                          <div class="form-group">
                            <label for="Corporation" class="Corporation">Industry Category<span
                                style="color: red">*</span></label>
                            <select class="form-control" id="country" placeholder="Industry Category"
                              formControlName="bankindustryCategory" [(ngModel)]="walletIndustryCategory">
                              <option value="" [disabled]="true">Select</option>
                              <option *ngFor="let item of tierWalletConfig.industryCatagories" [value]="item.name">
                                {{item.name}}
                              </option>

                            </select>
                            <div *ngIf="
                            bank['bankindustryCategory'].touched &&
                            bank['bankindustryCategory'].invalid
                          " class="help-block text-danger">
                              <div *ngIf="
                              bank['bankindustryCategory'].errors &&
                              bank['bankindustryCategory'].errors['required']
                            ">
                                Please select Industry Category
                              </div>
                            </div>

                          </div>
                        </div>
                        <div class="col-12 col-md-4">
                          <div class="form-group">
                            <label for="Corporation" class="Corporation">Advisor Commission<span
                                style="color: red">*</span></label>
                            <div class="input-group">
                              <span class="input-group-text" style="line-height: 1.1 !important">%</span>
                              <input type="number" class="form-control checking-field" id="nameofcorporation"
                                placeholder="Advsior Commission" (input)="checkAdvisorCommision()"
                                formControlName="bankadvsiorFee" [(ngModel)]="walletAdvsiorFeeStructure" min="0"
                                max="15" />
                            </div>
                            <div *ngIf="
                              bank['bankadvsiorFee'].touched &&
                              bank['bankadvsiorFee'].invalid
                            " class="help-block text-danger">
                              <div *ngIf="
                                bank['bankadvsiorFee'].errors &&
                                bank['bankadvsiorFee'].errors['required']
                              ">
                                Please enter Advisor Commission
                              </div>
                              <div *ngIf="bank.get('bankadvsiorFee')?.errors?.max">
                                Value cannot be more than 15.
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <h6 class="admintitle mt-3">
                        PAD for Wallet payments
                        <!-- (May be different for subscriptions) -->
                        <i class="bi bi-info-circle" aria-hidden="true" title="May be different for subscriptions"></i>
                      </h6>

                      <div class="row">
                        <div class="col-12 col-md-3">
                          <div class="form-group">
                            <label for="Corporation" class="Corporation">Bank Code</label>
                            <input class="form-control checking-field" id="banknumber" placeholder="Bank Code"
                              name="banknumber" autocomplete="off" formControlName="bankCode" maxlength="3"
                              (input)="touchedmsg()" (keypress)="($event.charCode >= 48 && $event.charCode < 58)" />
                            <div *ngIf="
                              bank['bankCode'].touched &&
                              bank['bankCode'].invalid
                            " class="help-block text-danger">
                              <div *ngIf="
                              bank['bankCode'].errors &&
                              bank['bankCode'].errors['required']
                            ">
                                Please enter bank code
                              </div>
                            </div>

                          </div>
                        </div>
                        <div class="col-12 col-md-3">
                          <div class="form-group">
                            <label for="Corporation" class="Corporation">Transit Number</label>
                            <input class="form-control checking-field" id="branch" placeholder={{lang.Transit}}
                              name="branch" formControlName="BankTransit" autocomplete="off" maxlength="5"
                              (input)="touchedmsg()" (keypress)="($event.charCode >= 48 && $event.charCode < 58)" />
                            <div *ngIf="
                              bank['BankTransit'].touched &&
                              bank['BankTransit'].invalid
                            " class="help-block text-danger">
                              <div *ngIf="
                                bank['BankTransit'].errors &&
                                bank['BankTransit'].errors['required']
                              ">
                                Please enter bank transit number
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="col-12 col-md-3">
                          <div class="form-group">
                            <label for="Corporation" class="Corporation">Account Number</label>
                            <input class="form-control checking-field" id="accountnumber" placeholder="Account Number"
                              autocomplete="off" name="accountnumber" formControlName="accounNum" maxlength="12"
                              (input)="touchedmsg()" (keypress)="($event.charCode >= 48 && $event.charCode < 58)" />
                            <div
                              *ngIf="
                                                                                                                                                                                bank['accounNum'].touched &&
                                                                                                                                                                                bank['accounNum'].invalid
                                                                                                                                                                              "
                              class="help-block text-danger">
                              <div
                                *ngIf="
                                                                                                                                                                                  bank['accounNum'].errors &&
                                                                                                                                                                                  bank['accounNum'].errors['required']
                                                                                                                                                                                ">
                                Please enter account number
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="col-12 col-md-3">
                          <button class="saveAndNext" id="basicformSubmit1stScreen" type="button"
                            style="margin-top:25px" (click)="submitBankInfo()">
                            Verify
                          </button>
                        </div>
                      </div>
                    </form>
                    <!-- <div class="row" style="margin-top:5px">
                                  <div class="col-12 col-md-3">
                                    <button class="saveAndNext" id="basicformSubmit1stScreen" type="button" (click)="submitBankInfo()">
                                      Verify
                                    </button>
                                  </div>
                                </div> -->
                  </div>
                </div>
              </div>
            </div>


            <div class="d-flex justify-content-between" style="padding-bottom: 25px">
              <button class="saveAndNext" id="" type="button" (click)="gotobasicInfo()">
                <i aria-hidden="true" class="fa fa-long-arrow-left"></i>&nbsp;&nbsp;{{lang.Previous}}
              </button>

              <button class="saveAndNext" id="" type="button" (click)="gotoEmployeeScreen()">
                Next&nbsp;&nbsp;<i aria-hidden="true" class="fa fa-long-arrow-right"></i>
              </button>
            </div>
          </div>
        </div>

        <!-- Plans Screen  -->

        <div class="row" *ngIf="plansInfo">
          <!-- <ng-container *ngIf="showTierandWalletConfig"> -->
          <ng-container *ngIf="showTierConfig">
            <div class="col-12 col-md-12 d-flex justify-content-between"
              style="background: #142a49!important; font-size:14px;margin-top: 5px;">
              <h6 class="admintitle my-auto">
                Tier Configuration&nbsp;&nbsp;
              </h6>


            </div>
            <form [formGroup]="addTierForm">
              <div class="row">
                <div class="col-12 col-md-2">
                  <div class="form-group">
                    <label for="Corporation" class="Corporation">Tier Name<span style="color: red">*</span></label>

                    <input type="text" class="form-control checking-field" formControlName="tierName"
                      id="nameofcorporation" placeholder="Tier Name" [(ngModel)]="tierName" />

                    <div *ngIf="
                                            tier['tierName'].touched &&
                                            tier['tierName'].invalid
                                          " class="help-block text-danger">
                      <div *ngIf="
                                              tier['tierName'].errors &&
                                              tier['tierName'].errors['required']
                                            ">
                        Please enter tier name
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-12 col-md-2">
                  <div class="form-group">
                    <label for="Corporation" class="Corporation">Description<span style="color: red">*</span></label>

                    <input type="text" class="form-control checking-field" formControlName="tierDescription"
                      id="nameofcorporation" placeholder="Tier Description" [(ngModel)]="tierDescription">

                    <div *ngIf="
                                                                                              tier['tierDescription'].touched &&
                                                                                              tier['tierDescription'].invalid
                                                                                            "
                      class="help-block text-danger">
                      <div *ngIf="
                                                                                                tier['tierDescription'].errors &&
                                                                                                tier['tierDescription'].errors['required']
                                                                                              ">
                        Please enter tier description
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-12 col-md-1">
                  <div class="form-group">
                    <label for="Corporation" class="Corporation">Status<span style="color: red">*</span></label>
                    <select class="form-control" id="country" placeholder="Country" formControlName="tierStatus"
                      [(ngModel)]="tierStatus">
                      <option value="" [disabled]="true">Select</option>
                      <option value="Active">Active</option>
                      <option value="Inactive">In Active</option>

                    </select>
                    <div *ngIf="
                        tier['tierStatus'].touched &&
                        tier['tierStatus'].invalid
                      " class="help-block text-danger">
                      <div *ngIf="
                        tier['tierStatus'].errors &&
                        tier['tierStatus'].errors['required']
                      ">
                        Please select tier status
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-12 col-md-1">
                  <div class="form-group">
                    <label for="Corporation" class="Corporation">Effective Date<span style="color: red">*</span></label>



                    <select class="form-control" id="Effective Date" placeholder="Select"
                      formControlName="tierEffectiveDate" [(ngModel)]="tierEffectiveDate">
                      <option value="" [disabled]="true">{{lang.Select}}</option>
                      <option *ngFor="let name of enrollmentDates" [value]="name" [label]="name">
                        {{ name }}
                      </option>
                    </select>
                    <div *ngIf="
                        tier['tierEffectiveDate'].touched &&
                        tier['tierEffectiveDate'].invalid
                      " class="help-block text-danger">
                      <div *ngIf="
                          tier['tierEffectiveDate'].errors &&
                          tier['tierEffectiveDate'].errors['required']
                        ">
                        Please select Effective Date
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-12 col-md-2">
                  <div class="form-group">
                    <label for="Corporation" class="Corporation">Length of Service<span
                        style="color: red">*</span></label>

                    <select class="form-control" id="country" placeholder="Length of Service"
                      [(ngModel)]="tierTimeofService" formControlName="tierTimeOfService"
                      (change)="tiersServiceCheck($event)">
                      <option value="" [disabled]="true">Select</option>
                      <option value="true">Yes</option>
                      <option value="false">No</option>

                    </select>
                    <div *ngIf="
                                                                                                      tier['tierTimeOfService'].touched &&
                                                                                                      tier['tierTimeOfService'].invalid
                                                                                                    "
                      class="help-block text-danger">
                      <div *ngIf="
                                                                                                        tier['tierTimeOfService'].errors &&
                                                                                                        tier['tierTimeOfService'].errors['required']
                                                                                                      ">
                        Please select length of service
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-12 col-md-2" *ngIf="addTierForm.get('tierTimeOfService')?.value === 'true'">
                  <div class="form-group">
                    <label for="Corporation" class="Corporation">Min Length of Service<span
                        style="color: red">*</span></label>

                    <select class="form-control" id="country" placeholder="Min Length of Service"
                      formControlName="mintierTimeOfService" [(ngModel)]="tierMinTimeofService"
                      (change)="minServiceCheck($event)">
                      <option value="" [disabled]="true">Select</option>
                      <option value="0">New Joinee-0 Year</option>
                      <option value="1">1 year</option>
                      <option value="2">2 years</option>
                      <option value="3">3 years</option>
                      <option value="4">4 years</option>
                      <option value="5">5 years</option>
                      <option value="6">6 years</option>
                      <option value="7">7 years</option>
                      <option value="8">8 years</option>
                      <option value="9">9 years</option>
                      <option value="10">10 years</option>
                    </select>
                    <div
                      *ngIf="
                                                                                                                          tier['mintierTimeOfService'].touched &&
                                                                                                                          tier['mintierTimeOfService'].invalid
                                                                                                                        "
                      class="help-block text-danger">
                      <div
                        *ngIf="
                                                                                                                            tier['mintierTimeOfService'].errors &&
                                                                                                                            tier['mintierTimeOfService'].errors['required']
                                                                                                                          ">
                        Please select Min length of service
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-12 col-md-2" *ngIf="addTierForm.get('tierTimeOfService')?.value === 'true'">
                  <div class="form-group">
                    <label for="Corporation" class="Corporation">Max Length of Service<span
                        style="color: red">*</span></label>

                    <select class="form-control" id="country" placeholder="Max Tier of Service"
                      formControlName="maxtierTimeOfService" [(ngModel)]="tierMaxTimeofService"
                      (change)="maxServiceCheck($event)">
                      <option value="" [disabled]="true">Select</option>
                      <option value="1">1 year</option>
                      <option value="2">2 years</option>
                      <option value="3">3 years</option>
                      <option value="4">4 years</option>
                      <option value="5">5 years</option>
                      <option value="6">6 years</option>
                      <option value="7">7 years</option>
                      <option value="8">8 years</option>
                      <option value="9">9 years</option>
                      <option value="10">10 years</option>

                    </select>
                    <div
                      *ngIf="
                                                                                                                                            tier['maxtierTimeOfService'].touched &&
                                                                                                                                            tier['maxtierTimeOfService'].invalid
                                                                                                                                          "
                      class="help-block text-danger">
                      <div
                        *ngIf="
                                                                                                                                              tier['maxtierTimeOfService'].errors &&
                                                                                                                                              tier['maxtierTimeOfService'].errors['required']
                                                                                                                                            ">
                        Please select Max length of service
                      </div>
                    </div>
                  </div>
                </div>

              </div>



            </form>
          </ng-container>
          <ng-container *ngIf="showWalletConfig">
            <div class="col-12 col-md-12 d-flex justify-content-between"
              style="background-color: #142a49!important; font-size:14px;margin-top: 5px;">
              <h6 class="admintitle my-auto">
                Wallet Configuration&nbsp;&nbsp;
              </h6>


            </div>
            <form [formGroup]="addWalletForm">
              <div class="row">

                <div class="col-12 col-md-2">
                  <div class="form-group">
                    <label for="Corporation" class="Corporation">Wallet Amount<span style="color: red">*</span></label>
                    <div class="input-group">
                      <span class="input-group-text" style="line-height: 1.1 !important">$</span>
                      <input type="text" class="form-control" id="nameofcorporation" formControlName="walletAmount"
                        (input)="clearIfStartsWithZero()" placeholder="1,000" [(ngModel)]="walletAmount"
                        (ngModelChange)="formatAmount()" />
                    </div>
                    <div *ngIf="wallet['walletAmount'].touched && wallet['walletAmount'].invalid"
                      class="help-block text-danger">
                      <div *ngIf="wallet['walletAmount'].errors?.required">
                        Please enter wallet Amount
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-12 col-md-2">
                  <div class="form-group">
                    <label for="Corporation" class="Corporation">Carry Forward Amount<span
                        style="color: red">*</span></label>

                    <select class="form-control" id="country" placeholder="Carry Forword Amount"
                      [(ngModel)]="walletCarryForwordAmount" formControlName="carryForwordAmount"
                      (change)="checkAllocationTier($event)">
                      <option value="" [disabled]="true">Select</option>
                      <option value="true">Yes</option>
                      <option value="false">No</option>

                    </select>
                    <div *ngIf="wallet['carryForwordAmount'].touched && wallet['carryForwordAmount'].invalid"
                      class="help-block text-danger">
                      <div *ngIf="wallet['carryForwordAmount'].errors?.required">
                        Please Select Carry Forward Amount
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-12 col-md-2">
                  <div class="form-group">
                    <label for="Corporation" class="Corporation"> Allocation<span style="color: red">*</span></label>

                    <select class="form-control" id="country" placeholder="Allocation" formControlName="allocation"
                      [(ngModel)]="walletAllocation" (change)="checkAllocation($event)">
                      <option value="" [disabled]="true">Select</option>

                      <option *ngFor="let item of tierWalletConfig.rollOverAllocationTypes" [value]="item.value">
                        {{item.label}}
                      </option>


                    </select>

                    <div *ngIf="wallet['allocation'].touched && wallet['allocation'].invalid"
                      class="help-block text-danger">
                      <div *ngIf="wallet['allocation'].errors?.required">
                        Please select Allocation
                      </div>
                    </div>
                  </div>
                </div>
                <!-- <div class="col-12 col-md-2">
                  <div class="form-group">
                    <label for="Corporation" class="Corporation">Industry Category<span
                        style="color: red">*</span></label>

                    <select class="form-control" id="country" placeholder="Industry Category"
                      formControlName="industryCategory" [(ngModel)]="walletIndustryCategory">
                      <option value="" [disabled]="true">Select</option>
                      <option *ngFor="let item of tierWalletConfig.industryCatagories" [value]="item.name">
                        {{item.name}}
                      </option>

                    </select>
                    <div *ngIf="wallet['industryCategory'].touched && wallet['industryCategory'].invalid"
                      class="help-block text-danger">
                      <div *ngIf="wallet['industryCategory'].errors?.required">
                        Please select Industry Category
                      </div>
                    </div>
                  </div>
                </div> -->
                <div class="col-12 col-md-2">
                  <div class="form-group">
                    <label for="Corporation" class="Corporation">Intial Balance Setup<span
                        style="color: red">*</span></label>

                    <select class="form-control" id="country" placeholder="Intial Balance Setup"
                      formControlName="intialBalanceSetup" [(ngModel)]="walletIntialBalanceSetup">
                      <option value="" [disabled]="true">Select</option>
                      <!-- <option *ngFor="let item of tierWalletConfig.initialBalanceSetup" [value]="item.value"> -->
                      <option *ngFor="let item of tierWalletConfig.initialBalanceSetup" [value]="item.value">
                        {{item.label}}
                      </option>

                    </select>
                    <div *ngIf="wallet['intialBalanceSetup'].touched && wallet['intialBalanceSetup'].invalid"
                      class="help-block text-danger">
                      <div *ngIf="wallet['intialBalanceSetup'].errors?.required">
                        Please select Initial Balance Setup
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-12 col-md-2">
                  <div class="form-group">
                    <label for="Corporation" class="Corporation">Coverage Percentage<span
                        style="color: red">*</span></label>

                    <select class="form-control" id="country" placeholder="Country"
                      formControlName="coveragePerecentage" [(ngModel)]="walletCoveragePercentage">
                      <option value="" [disabled]="true">Select</option>

                      <option value="100">100%</option>
                      <option value="95">95%</option>
                      <option value="90">90%</option>
                      <option value="85">85%</option>
                      <option value="80">80%</option>
                      <option value="75">75%</option>
                      <option value="70">70%</option>
                      <option value="65">65%</option>
                      <option value="60">60%</option>
                      <option value="55">55%</option>
                      <option value="50">50%</option>


                    </select>
                    <div *ngIf="wallet['coveragePerecentage'].touched && wallet['coveragePerecentage'].invalid"
                      class="help-block text-danger">
                      <div *ngIf="wallet['coveragePerecentage'].errors?.required">
                        Please select Coverage Percentage
                      </div>
                    </div>
                  </div>

                </div>
                <!-- <div class="col-12 col-md-2">
  <div class="form-group">
    <label for="Corporation" class="Corporation">Advisor Commission<span style="color: red">*</span></label>
    <div class="input-group">
      <span class="input-group-text" style="line-height: 1.1 !important">%</span>
      <input type="text" class="form-control checking-field" id="nameofcorporation" placeholder="Advsior Commission" (input)="checkAdvisorCommision()"
        formControlName="advsiorFee" [(ngModel)]="walletAdvsiorFeeStructure" />
    </div>
    <div *ngIf="wallet['advsiorFee'].touched && wallet['advsiorFee'].invalid" class="help-block text-danger">
      <div *ngIf="wallet['advsiorFee'].errors?.required">
        Please enter Advisor Commission
      </div>
    </div>
  </div>
</div> -->

                <div class="col-12 col-md-2">
                  <div class="form-group">
                    <label for="Corporation" class="Corporation">Wallet Type
                      <span style="color: red">*</span></label>

                    <!-- <select class="form-control" id="country" placeholder="Wallet Type" formControlName=Wallet Type1
      [(ngModel)]=Wallet Type1> -->
                <div class="d-flex">
                    <select class="form-control" id="country" placeholder="Wallet Type" formControlName="walletType"
                      [(ngModel)]="walletType" (change)="onWalletTypeSelected($event)">
                      <option value="" [disabled]="true">Select</option>
                      <option *ngFor="let item of tierWalletConfig.walletTypes" [value]="item.value">
                        {{ item.label }}{{item.value}}
                      </option>
                    </select>
                    <button
                      *ngIf="walletType === 'MYWSA'"
                      class="btn btn-sm btn-outline-secondary ms-2"
                      type="button"
                      (click)="openEditWSA()">
                      <!-- (click)="updateWSAForm(item, i)"> -->
                      <i class="bi bi-pencil-square"></i>
                    </button>
                    </div>



                    <div *ngIf="wallet['walletType'].touched && wallet['walletType'].invalid"
                      class="help-block text-danger">
                      <div *ngIf="wallet['walletType'].errors?.required">
                        Please select wallet Type
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </form>
          </ng-container>

          <!-- <p>showAddTier:{{showAddTier}}</p>
          <p>isAddTier:{{isAddTier}}</p> -->
          <ng-container *ngIf="showAddTier">
            <!-- common-plans -->
            <app-common-plans #commonPlans [viewPlan]="false" [isCorporate]="true" [bulkPlansData]="balkPlans"
              [plansData]="plansBlock1" [paidByCompany]="[]" [coveredByCompany]=" []" [paidByEmployee]=" []"
              [bulkplans]=" []" [mode]="isAddTier ? 'add' : 'edit'"
              [multiSelectProviancenames]="multiSelectProviancenames" (submitTriggered)="plansSumitInfo()"
              [addWalletForm]="addWalletForm" [addTierForm]="addTierForm" [clientregform]="clientregform"
              [crateTierid]="crateTierid"></app-common-plans>


            <!-- </ng-container> -->
            <!-- below should be disabled when using the common module of plans above -->
            <div class="linescrollbar form-container" style="margin-top:10px" *ngIf="false">
              <div class="row pb-2">
                <div class="col-12 col-md-12">
                  <div class="form-group">

                    <h6 class="admintitle">{{lang.Corporate_Level_Group_Plans}}
                      <!-- &nbsp;&nbsp; -->
                    </h6>
                  </div>
                </div>
              </div>
              <!-- Block1 With No Tier -->
              <!-- bulk plans -->
              <div class="row">
                <div class="packageWrapper block3packagewrapper plansscreenbulk"
                  *ngFor="let package of balkPlans; let i = index">
                  <div class="planheadingwrap" style="padding-left: 0px;">
                    <!-- && package && package?.id !== 2 -->
                    <!-- <div class=" planheadingwrap" *ngIf="package"></div> -->
                    <div class="d-flex position-relative">
                      <h6 *ngIf="package?.groups?.length >= 1" class="planheading panel-title ps-3"
                        [attr.data-bs-target]="'#collapsethreeBulk' + package?.id" data-bs-toggle="collapse"
                        aria-expanded="true" aria-controls="collapsethreeBulk{{ package?.id }}">
                        {{ package?.name }}
                      </h6>
                      <!-- <h6 class="planheading" *ngIf="package?.groups?.length >  1">
                      <h6 class="planheading" *ngIf="package?.groups?.length >  1">
                        {{ package?.name }}
                      </h6> -->
                      <div class="position-absolute" style="top: 18px;left: 10px;bottom: -39px;">
                        <div *ngIf="role==='ADMINISTRATOR' && package?.groups?.length >= 1"
                          title="{{getTextForTooltip1(package?.published,package?.restrictedAccess)}}"
                          [ngStyle]=" {'border-color' : getColorForPlans1(package?.published,package?.restrictedAccess) }"
                          class="outer my-auto col-2" data-bs-toggle="">
                          <span class="inner"
                            [ngStyle]="{ 'background': getColorForPlans1(package?.published,package?.restrictedAccess) }"></span>
                        </div>
                      </div>

                    </div>

                  </div>

                  <div class="form-group package" style="margin-top:-2px">
                    <!-- &&package && package?.id !== 2 -->
                    <div class="package-groups1" *ngFor="let group of package?.groups; let j = index" title="">
                      <div class="price" *ngIf="group && group != null">
                        <div class="header overflow-ellipsis1 panel-title"
                          [attr.data-bs-target]="'#collapsethreeBulk' + group.id" data-bs-toggle="collapse"
                          aria-expanded="true" aria-controls="collapsethreeBulk{{ group.id }}" title="{{ group.name }}"
                          *ngIf="
                          group &&
                          group.subGroups &&
                          group.subGroups.length > 0 &&
                          package?.groups?.length >  1
                        ">
                          {{ group.name }}
                        </div>
                      </div>
                      <div class="planbody" *ngIf="
                        group && group.subGroups && group.subGroups.length > 0
                      ">
                        <div *ngFor="let subgroup of group.subGroups; let k = index">
                          <div *ngIf="subgroup" id="collapsethreeBulk{{
                            package?.groups?.length >  1
                              ? subgroup.parentId
                              : package?.id
                          }}" class="accordion-collapse collapse show">
                            <div style="display: flex;" class="position-relative">
                              <div class="featuutrebody1 row justify-content-center align-items-center"
                                [style.background-color]="
                                subgroup.backgroundColor
                                  ? subgroup.backgroundColor
                                  : defaultColor
                              " *ngIf="subgroup">
                                <div class="col-1">
                                  <div *ngIf="role==='ADMINISTRATOR' && package?.groups?.length >= 1"
                                    title="{{getTextForTooltip(subgroup.published?.data[0],subgroup.restricted)}}"
                                    [ngStyle]=" {'border-color' : getColorForPlans(subgroup.published?.data[0],subgroup.restricted) }"
                                    class="outer my-auto col-2" data-bs-toggle="">
                                    <span class="inner"
                                      [ngStyle]="{ 'background': getColorForPlans(subgroup.published?.data[0],subgroup.restricted,subgroup.name) }"></span>
                                  </div>
                                </div>
                                <span class="col-10">{{ subgroup.name }}</span>

                                <input type="checkbox" id="plancheckboxbulk{{ subgroup.id }}" class=" col-1 plancheckboxbulk{{
                                  package?.id
                                }} plancv largerCheckbox" attr.data="{{ package?.allowMultiple }}##{{
                                  subgroup.disallowedPlanLevels
                                }}##{{ package?.id }}##{{ subgroup.parentId }}##{{
                                  subgroup.id
                                }}##{{ package?.name }}##{{ subgroup.name }}##{{
                                  subgroup
                                }}##{{ subgroup.ordering }}" (change)="
                                onCheckboxChangeBulkPlns(
                                    $event,
                                    package?.allowMultiple,
                                    subgroup.disallowedPlanLevels,
                                    package?.id,
                                    subgroup?.id,
                                    package?.name,
                                    subgroup.name,
                                    subgroup,
                                    subgroup.ordering,
                                    group.id,
                                    group.name,
                                    i,
                                    j,
                                    k
                                  )
                                " />


                              </div>

                              <!-- <div>{{checkboxCheck[subgroup.id]}}{{subgroup.id}}</div> -->

                              <div id="checkbox-{{subgroup.id}}" *ngIf="checkboxCheck[subgroup.id]==true"
                                class="countblock">&nbsp;

                                <label for="Corporation" class="Corporation">Head Count:</label>

                                <input type="number" class="headcountbox" [(ngModel)]="showHeadCount[subgroup.id]"
                                  class="headerCount" (keypress)="preventNegative($event)"
                                  (input)="preventNonNumeric($event)"
                                  (change)="updateTotal(j,$event,subgroup,subgroup.settings?.requiredCustomersCount)">&nbsp;
                                <label for="Corporation" class="Corporation"
                                  *ngIf="!showHeadCount[subgroup.id] || showHeadCount[subgroup.id] <=0"
                                  style="color:red">
                                  {{lang.Please_enter_head_count_for}}</label>
                                &nbsp;

                                <span class="text-left"
                                  *ngIf="checkboxCheck[subgroup.id] && showinputboxvalue[subgroup.id] && (showHeadCount[subgroup.id] || showHeadCount[subgroup.id] >0)">
                                  <label for="DownloadButton" id="uploadButtonExcel" title="Download Template"
                                    data-taggle="tooltip"
                                    (click)="exportAsXLSX(subgroup.id,subgroup.settings.memberDetailsKeysDB)"
                                    class="Cursorpointer">
                                    <img src="../../../assets/img/download-template.png"
                                      style="width:100px;height:30px">
                                  </label>&nbsp;
                                  <label for="uploadButton-{{subgroup.id}}" id="uploadButtonExcel-{{subgroup.id}}"
                                    title="Upload Employee/Entity List" data-taggle="tooltip" class="Cursorpointer">
                                    <img src="../../../assets/img/upload-employee-list.png"
                                      style="width:100px;height:30px">
                                    <input id="uploadButton-{{subgroup.id}}" #myFileInput style="display: none"
                                      type="file"
                                      (input)="onFileChangeExcel($event,subgroup.id,subgroup.settings.memberDetailsKeysDB)" />
                                  </label> &nbsp;
                                  <i class="fa fa-eye" title="view" aria-hidden="true" data-bs-toggle="modal"
                                    (click)="editEmployees(subgroup.id)"></i>

                                </span>
                              </div>

                              <!-- new process of updating bulk plan head count -->
                              <!-- <div id="checkbox-{{subgroup.id}}" *ngIf="checkboxCheck[subgroup.id]==true && !isPlanInBulkplans(subgroup.id)" class="countblock">&nbsp;

                                <label for="Corporation" class="Corporation">Head Count:</label>

                                <input type="number" class="headcountbox" [(ngModel)]="showHeadCount[subgroup.id]"
                                  class="headerCount" (keypress)="preventNegative($event)" (input)="preventNonNumeric($event)"
                                  (change)="updateTotal(j,$event,subgroup,subgroup.settings?.requiredCustomersCount)">&nbsp;
                                <label for="Corporation" class="Corporation"
                                  *ngIf="!showHeadCount[subgroup.id] || showHeadCount[subgroup.id] <=0" style="color:red">
                                  {{lang.Please_enter_head_count_for}} {{subgroup.name}}</label>
                                &nbsp;

                                <span class="text-left"
                                  *ngIf="checkboxCheck[subgroup.id] && showinputboxvalue[subgroup.id] && (showHeadCount[subgroup.id] || showHeadCount[subgroup.id] >0)">
                                  <label for="DownloadButton" id="uploadButtonExcel" title="Download Template" data-taggle="tooltip"
                                    (click)="exportAsXLSX(subgroup.id,subgroup.settings.memberDetailsKeysDB)" class="Cursorpointer">
                                    <img src="../../../assets/img/download-template.png" style="width:100px;height:30px">
                                  </label>&nbsp;
                                  <label for="uploadButton-{{subgroup.id}}" id="uploadButtonExcel-{{subgroup.id}}"
                                    title="Upload Employee/Entity List" data-taggle="tooltip" class="Cursorpointer">
                                    <img src="../../../assets/img/upload-employee-list.png" style="width:100px;height:30px">
                                    <input id="uploadButton-{{subgroup.id}}" #myFileInput style="display: none" type="file"
                                      (input)="onFileChangeExcel($event,subgroup.id,subgroup.settings.memberDetailsKeysDB)" />
                                  </label> &nbsp;
                                  <i class="fa fa-eye" title="view" aria-hidden="true" data-bs-toggle="modal"
                                    (click)="editEmployees(subgroup.id,'edit')"></i>

                                </span>
                              </div>

                              <div *ngIf="isPlanInBulkplans(subgroup.id)" class='mx-2'>
                                <div id="checkbox-{{subgroup.id}}" *ngIf="checkboxCheck[subgroup.id] == true" class="countblock">
                                  <div *ngFor="let plan of getPlansByPlanLevel(subgroup.id), let index = i" class="d-flex align-items-center">
                                    <label for="Corporation" class="Corporation">Head Count:</label>
                                    <label>{{ plan.quantity }}</label>&nbsp;
                                    <label *ngIf="plan.terminationDate" class="d-flex align-items-center">
                                      | Termination Date : {{plan.terminationDate?.slice(0,10)}}&nbsp;
                                        <i
                                          style="color:rgb(56, 76, 159)"
                                          class="bi bi-pencil-fill"
                                          data-bs-target="#edit-headcount"
                                          data-bs-toggle="modal"
                                          (click)="updateBulkHeadCount(plan)"
                                          ></i>&nbsp;&nbsp;
                                          <i
                                          style="color:red"
                                          class="bi bi-x-lg"
                                          data-bs-target="#terminate-bulkplan"
                                          data-bs-toggle="modal"
                                          (click)="terminateBulkPlan(plan)"
                                        ></i>
                                    </label>
                                    <label *ngIf="!plan.terminationDate">| Activation Date : {{plan.activationDate?.slice(0,10)}}&nbsp;
                                        <i
                                          style="color:rgb(56, 76, 159)"
                                          class="bi bi-pencil-fill"
                                          data-bs-target="#edit-headcount"
                                          data-bs-toggle="modal"
                                          (click)="updateBulkHeadCount(plan,i)"
                                          ></i>&nbsp;&nbsp;
                                          <i
                                          style="color:red"
                                          class="bi bi-x-lg"
                                          data-bs-target="#terminate-bulkplan"
                                          data-bs-toggle="modal"
                                          (click)="terminateBulkPlan(plan,i)"
                                        ></i>
                                    </label>
                                  </div>
                                </div>
                              </div> -->



                              <!-- <div class="countblock" *ngIf="package?.id==2">&nbsp;
                                <label for="Corporation" class="Corporation" *ngIf="showinputbox==k">Head Count:</label>

                                <input type="text" class="headcountbox" *ngIf="showinputbox==k"
                                  [(ngModel)]="showEmployeeValue" class="headerCount"
                                  (change)="updateTotal(j,$event)">&nbsp;
                                <label for="Corporation" class="Corporation" *ngIf="showinputbox==k && headCountmiss"
                                  style="color:red">Please enter
                                  head count</label>
                                &nbsp;

                                <span class="text-left"
                                  *ngIf="subgroup.name=='Complete Wellness' && showinputboxvalue==20 && showEmployeeValue">
                                  <label for="DownloadButton" id="uploadButtonExcel" title="Download Template"
                                    data-taggle="tooltip" (click)="exportAsXLSX()" class="Cursorpointer">
                                    <img src="../../../assets/img/download-template.png" style="width:100px;height:30px">
                                  </label>&nbsp;
                                  <label for="uploadButton" id="uploadButtonExcel" title="Upload Employee/Entity List"
                                    data-taggle="tooltip" class="Cursorpointer">
                                    <img src="../../../assets/img/upload-employee-list.png"
                                      style="width:100px;height:30px">
                                    <input id="uploadButton" #myFileInput style="display: none" type="file"
                                      (input)="onFileChangeExcel($event)" />
                                  </label> &nbsp;
                                  <i class="fa fa-eye" title="view" aria-hidden="true" data-bs-toggle="modal"
                                    data-bs-target="#showBulkEmployeelist"></i>
                                </span>
                              </div>

                              <div class="countblock" *ngIf="package?.id==11">&nbsp;
                                <label for="Corporation" class="Corporation" *ngIf="showinputbox1==k">Head Count:</label>

                                <input type="text" class="headcountbox" *ngIf="showinputbox1==k"
                                  [(ngModel)]="showEmployeeValue1" class="headerCount"
                                  (change)="updateTotal1(j,$event)">&nbsp;
                                <label for="Corporation" class="Corporation" *ngIf="showinputbox1==k && headCountmiss1"
                                  style="color:red">Please enter
                                  head count</label>
                                &nbsp;

                                <span class="text-left"
                                  *ngIf="subgroup.name=='Personal Protection' && showinputboxvalue1==34 && showEmployeeValue1">
                                  <label for="DownloadButton" id="uploadButtonExcel" title="Download Template"
                                    data-taggle="tooltip" (click)="exportAsXLSXWaddel()" class="Cursorpointer">
                                    <img src="../../../assets/img/download-template.png" style="width:100px;height:30px">
                                  </label>&nbsp;
                                  <label for="uploadButtonwaddell" id="uploadButtonExcelwaddell"
                                    title="Upload Employee/Entity List" data-taggle="tooltip" class="Cursorpointer">
                                    <img src="../../../assets/img/upload-employee-list.png"
                                      style="width:100px;height:30px">
                                    <input id="uploadButtonwaddell" #myFileInputwaddel style="display: none" type="file"
                                      (input)="onFileChangeExcelWaddel($event)" />
                                  </label> &nbsp;
                                  <i class="fa fa-eye" title="view" aria-hidden="true" data-bs-toggle="modal"
                                    data-bs-target="#showBulkEmployeelistwaddell"></i>
                                </span>
                              </div> -->
                            </div>
                          </div>


                          <!-- <textarea type="text" class="tierconfig"> Employee</textarea> -->
                        </div>

                      </div>

                    </div>
                  </div>

                </div>

              </div>

              <div class="row">
                <div class="col-12 col-md-12">
                  <div class="form-group">
                    <span class="coreplans" *ngIf="showtierbasicplans">{{lang.Template}}
                      <select (change)="coreplantemplate($event)" [(ngModel)]="coreplantemplateValue">
                        <option [value]="null">{{lang.Select}}</option>
                        <option value="starter">{{lang.Starter}}</option>
                        <option value="standard">{{lang.Standard}}</option>
                        <option value="executive">{{lang.Executive}}</option>
                        <option value="custom">{{lang.Custom}}</option>
                      </select>
                    </span>
                    <h6 class="admintitle">
                      {{lang.Core_Plans_Premium_paid_100_by_employer}}&nbsp;&nbsp;
                      <!--  -->
                    </h6>
                  </div>
                </div>
              </div>

              <!-- *ngIf="showtierbasicplans" -->
              <!-- Block1 With No Tier -->
              <div class="row">
                <div class="col-12 col-md-12 pb-2">
                  <span class="enabledplans1">
                    <!-- Enabled?<input class="" type="radio" name="upgradeplans" id="upgradeplanstrue" #upgradeplanstrue value="true"
                    (click)="upgradeplans($event)" />
                  <label class="form-check-label" for="workinghoursno" class="upgradeplans">&nbsp;Yes</label>&nbsp;&nbsp;
                  <input class="" type="radio" name="upgradeplans" id="upgradeplansfalse" #upgradeplansfalse value="false"
                    (click)="upgradeplans($event)" checked />
                  <label class="form-check-label" for="workinghoursno" class="upgradeplans">&nbsp;No</label>
                -->
                  </span>

                  <!-- <h6 class="admintitle">
                  Core Plans (Premium paid 100% by employer).&nbsp;&nbsp;
                </h6> -->
                </div>

                <div class="packageWrapper plansscreen" *ngFor="let package of plansBlock1; let i = index">
                  <div class="planheadingwrap" style="padding-left: 6px;">
                    <!-- *ngIf="!(package?.id == hidementalplans || package?.id == hidewaddellplans)" -->
                    <div class="d-flex position-relative">
                      <h6 *ngIf="package?.groups?.length >= 1 && showPackageName(package?.groups,'core')"
                        class="planheading ps-3" id="plancheckcollapseone{{ package?.id }}" aria-expanded="true"
                        aria-controls="collapseone{{ package?.id }}"
                        [attr.data-bs-target]="'#collapseone' + package?.id" data-bs-toggle="collapse"
                        style="justify-content: space-around;" (click)="toggleCollapsee(package?.id)" id="parent1">
                        {{ package?.name }}<span>{{ isCollapsed[package?.id] ? '+' : '-' }}</span>
                      </h6>
                      <!-- <h6 class="planheading" *ngIf="package?.groups?.length >  1">
                        {{ package?.name }}
                      </h6> -->
                      <div class="position-absolute" style="top: 18px;left: 10px;bottom: -39px;">
                        <div
                          *ngIf="role==='ADMINISTRATOR' && package?.groups?.length >= 1 && showPackageName(package?.groups,'core')"
                          title="{{getTextForTooltip1(package?.published,package?.restrictedAccess)}}"
                          [ngStyle]=" {'border-color' : getColorForPlans1(package?.published,package?.restrictedAccess) }"
                          class="outer my-auto col-2" data-bs-toggle="">
                          <span class="inner"
                            [ngStyle]="{ 'background': getColorForPlans1(package?.published,package?.restrictedAccess) }"></span>
                        </div>
                      </div>
                      <div class="form-group package" *ngIf="!isCollapsed[package?.id]">
                        <!-- *ngIf="!(package?.id == hidementalplans || package?.id == hidewaddellplans)" -->
                        <div class="package-groups1" *ngFor="let group of package?.groups; let j = index" title="">
                          <div class="price" id="myGroup">
                            <div *ngIf="package?.groups?.length >  1 && showPackageName(package?.groups,'core')"
                              class="header overflow-ellipsis1 panel-title" [style.background-color]="
                                group.backgroundColor
                                  ? group.backgroundColor
                                  : defaultColor
                              " id="plancheckcollapseone{{ group.id }}"
                              [attr.data-bs-target]="'#collapseone' + group.id" data-bs-toggle="collapse"
                              aria-expanded="true" aria-controls="collapseone{{ group.id }}" title="{{ group.name }}">
                              {{ group.name }}
                            </div>
                          </div>
                          <div class="planbody" *ngIf="group.subGroups && group.subGroups.length > 0 ">
                            <div *ngFor="let subgroup of group.subGroups; let k = index">
                              <!-- <div>collapseone{{
                                package?.groups?.length > 1
                                ? subgroup.parentId
                                : package?.id
                                }}{{package?.groups.length}}</div> -->
                              <div *ngIf="subgroup && subgroup?.settings?.core" id="collapseone{{
                                  package?.groups?.length >  1
                                    ? subgroup.parentId
                                    : package?.id
                                }}" class="accordion-collapse collapse show">
                                <div class="featuutrebody" [style.background-color]="
                                    subgroup.backgroundColor
                                      ? subgroup.backgroundColor
                                      : defaultColor
                                  ">
                                  <!-- <span>&#x2713; {{ subgroup.name }}</span> -->
                                  <div class="row justify-content-center align-items-center">
                                    <div class="col-1">
                                      <div *ngIf="role==='ADMINISTRATOR' && package?.groups?.length >= 1"
                                        title="{{getTextForTooltip(subgroup.published?.data[0],subgroup.restricted)}}"
                                        [ngStyle]=" {'border-color' : getColorForPlans(subgroup.published?.data[0],subgroup.restricted) }"
                                        class="outer my-auto col-2" data-bs-toggle="">
                                        <span class="inner"
                                          [ngStyle]="{ 'background': getColorForPlans(subgroup.published?.data[0],subgroup.restricted,subgroup.name) }"></span>
                                      </div>
                                    </div>
                                    <span class="col-9"> {{ subgroup.name }}</span>
                                    <input type="checkbox" [checked]="subgroup.checked" id="plancheck{{ subgroup.id }}"
                                      class="col-1 plancheckbox{{
                                        package?.id
                                      }} plancv largerCheckbox block1" attr.data="{{ package?.allowMultiple }}##{{
                                        subgroup.disallowedPlanLevels
                                      }}##{{ package?.id }}##{{
                                        subgroup.parentId
                                      }}##{{ subgroup.id }}##{{ package?.name }}##{{
                                        subgroup.namego
                                      }}##{{ subgroup }}##{{ subgroup.ordering }}##{{
                                        i
                                      }}##{{ j }}##{{ k }}" (change)="
                                        onCheckboxChange1(
                                          $event,
                                          package?.allowMultiple,
                                          subgroup.disallowedPlanLevels,
                                          package?.id,
                                          subgroup.id,
                                          package?.name,
                                          subgroup.name,
                                          subgroup,
                                          subgroup.ordering,
                                          group.id,
                                          group.name,
                                          i,
                                          j,
                                          k
                                        )
                                      " />
                                  </div>
                                  <!-- <div class="executiveplansselection" *ngIf="subgroup.coverage=='Exec'"> -->

                                  <div class="executiveplansselection"
                                    *ngIf="subgroup.id == '17' || subgroup.id == '18' || subgroup.id == '28'">
                                    <label class="radio-inline executiveplans">
                                      <input type="checkbox" name="executiveplans{{ subgroup.id }}"
                                        id="executiveplanssingle{{ subgroup.id }}" style="vertical-align: bottom"
                                        (click)="
                                          executiveplansCoverage(
                                            $event,
                                            i,
                                            j,
                                            k,
                                            subgroup.id
                                          )
                                        " />
                                      {{lang.Single}}
                                    </label>
                                    <label class="radio-inline executiveplans">
                                      <input type="checkbox" name="executiveplans{{ subgroup.id }}"
                                        id="executiveplanscouple{{ subgroup.id }}" style="vertical-align: bottom"
                                        (click)="
                                          executiveplansCoverage(
                                            $event,
                                            i,
                                            j,
                                            k,
                                            subgroup.id
                                          )
                                        " />
                                      {{lang.Couple}}
                                    </label>
                                    <label class="radio-inline executiveplans">
                                      <input type="checkbox" name="executiveplans{{ subgroup.id }}"
                                        id="executiveplansfamily{{ subgroup.id }}" style="vertical-align: bottom"
                                        (click)="
                                          executiveplansCoverage(
                                            $event,
                                            i,
                                            j,
                                            k,
                                            subgroup.id
                                          )
                                        " />
                                      {{lang.Family}}
                                    </label>
                                  </div>


                                </div>
                                <ng-container *ngIf="role==='ADMINISTRATOR'">
                                  <div class="planCoverage"
                                    *ngIf="subgroup.checked && plansCoveragecheckboxCheck[subgroup.id]">
                                    <!-- <ul class="tiersConfigul">
                                      <li>Configure Tier</li>
                                    </ul> -->
                                    <div class="d-flex align-items-center">
                                      <select class="form-control" id="Province" placeholder="Province"
                                        [(ngModel)]="getPlanCoverage[subgroup.id]">
                                        <option value="" [disabled]="true" selected>{{lang.Select}}</option>
                                        <option *ngFor="let coverage of companyPaidCoveragePlanLevels[subgroup.id]"
                                          [value]="coverage.value">
                                          {{ coverage.label }}&nbsp;<i class="fa fa-info-circle" aria-hidden="true"
                                            title="{{coverage.description}}"></i>
                                        </option>
                                      </select>
                                    </div>
                                  </div>
                                </ng-container>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                  </div>

                </div>

                <!-- <div class="row">
                  <div class="offset-md-10 col-md-2">
                    <button class="btn btn-primary" type="button" data-bs-toggle="modal" data-bs-target="#tierConfigure"
                      *ngIf="showtieradvplans" style="float: right" (click)="configuretiers()">
                      Configure&nbsp;&nbsp;<i aria-hidden="true" class="fa fa-long-arrow-right"></i>
                    </button>
                  </div>
                </div> -->
              </div>

              <!-- Block2 With No Tier -->
              <div class="row" style="width: 100%;">
                <div class="row header-title m-2 d-flex justify-content-between header-title">
                  <div class="my-auto mx-2" style="width:auto;">
                    {{lang.Upgrade_Plans_Premium_difference_paid_by_employee_through_payroll_deduction}}&nbsp;&nbsp;
                    <!--  -->
                  </div>
                  <div class="my-auto mx-4" style="width:auto;">{{lang.Enabled}}
                    <input class="" type="radio" name="upgradeplans" id="upgradeplanstrue" #upgradeplanstrue
                      value="true" (click)="upgradeplans($event)" />
                    <label class="form-check-label" for="workinghoursno"
                      class="upgradeplans">&nbsp;{{lang.Yes}}</label>&nbsp;&nbsp;
                    <input class="" type="radio" name="upgradeplans" id="upgradeplansfalse" #upgradeplansfalse
                      value="false" (click)="upgradeplans($event)" checked />
                    <label class="form-check-label" for="workinghoursno" class="upgradeplans">&nbsp;{{lang.No}}</label>
                  </div>

                </div>
                <!-- <div class="col-12 col-md-12 pb-2">
                  <span class="enabledplans1">Enabled?
                    <input class="" type="radio" name="upgradeplans" id="upgradeplanstrue" #upgradeplanstrue value="true"
                      (click)="upgradeplans($event)" />
                    <label class="form-check-label" for="workinghoursno"
                      class="upgradeplans">&nbsp;Yes</label>&nbsp;&nbsp;
                    <input class="" type="radio" name="upgradeplans" id="upgradeplansfalse" #upgradeplansfalse
                      value="false" (click)="upgradeplans($event)" checked />
                    <label class="form-check-label" for="workinghoursno" class="upgradeplans">&nbsp;No</label>
                  </span>

                  <h6 class="admintitle">
                    Upgrade Plans (Premium difference paid by employee through
                    payroll deduction).&nbsp;&nbsp;
                  </h6>
                </div> -->
                <div class="row" *ngIf="upgradeplansselection">
                  <div class="packageWrapper block2packagewrapper plansscreen2"
                    *ngFor="let package of plansresblack2; let i = index">
                    <div class="planheadingwrap" style="padding-left: 6px;">
                      <!-- *ngIf="package && package?.id !== 3 && package?.id !== hidewaddellplans" -->
                      <div class="d-flex position-relative">
                        <h6 *ngIf="package?.groups?.length >= 1 && showPackageName(package?.groups,'upgrade')"
                          class="planheading" [attr.data-bs-target]="'#collapsetwo' + package?.id"
                          data-bs-toggle="collapse" aria-expanded="true" aria-controls="collapsetwo{{ package?.id }}"
                          style="justify-content: space-around;" (click)="toggleCollapseeTwo(package?.id)" id="parent2">
                          {{ package?.name }}<span>{{ isCollapsedTwo[package?.id] ? '+' : '-' }}</span>
                        </h6>
                        <!-- <h6 class="planheading" *ngIf="package?.groups?.length >  1">
                          {{ package?.name }}
                        </h6> -->
                        <div class="position-absolute" style="top: 18px;left: 10px;bottom: -39px;">
                          <div
                            *ngIf="role==='ADMINISTRATOR' && package?.groups?.length >= 1 && showPackageName(package?.groups,'upgrade')"
                            title="{{getTextForTooltip1(package?.published,package?.restrictedAccess)}}"
                            [ngStyle]=" {'border-color' : getColorForPlans1(package?.published,package?.restrictedAccess) }"
                            class="outer my-auto col-2" data-bs-toggle="">
                            <span class="inner"
                              [ngStyle]="{ 'background': getColorForPlans1(package?.published,package?.restrictedAccess) }"></span>
                          </div>
                        </div>
                        <div class="form-group package" *ngIf="!isCollapsedTwo[package?.id]">
                          <!-- *ngIf="package && package?.id !== 3 && package?.id !== hidewaddellplans" -->
                          <div class="package-groups1" *ngFor="let group of package?.groups; let j = index" title="">
                            <div class="price"
                              *ngIf="group && group != null  && showPackageName(package?.groups,'upgrade')">
                              <div class="header overflow-ellipsis1 panel-title" [style.background-color]="
                                  group.backgroundColor
                                    ? group.backgroundColor
                                    : defaultColor
                                " [attr.data-bs-target]="'#collapsetwo' + group.id" data-bs-toggle="collapse"
                                aria-expanded="true" aria-controls="collapsetwo{{ group.id }}" title="{{ group.name }}"
                                *ngIf="
                                  group &&
                                  group.subGroups &&
                                  group.subGroups.length > 0 &&
                                  package?.groups?.length >  1
                                ">
                                {{ group.name }}
                              </div>
                            </div>

                            <div class="planbody" *ngIf="
                                group && group.subGroups && group.subGroups.length > 0
                              ">
                              <div *ngFor="
                                  let subgroup of group.subGroups;
                                  let k = index
                                ">
                                <!-- {{subgroup?.settings?.upgrade}} -->

                                <div *ngIf="subgroup && subgroup?.settings?.upgrade" id="collapsetwo{{
                                    package?.groups?.length >  1
                                      ? subgroup.parentId
                                      : package?.id
                                  }}" class="accordion-collapse collapse show">
                                  <div class="featuutrebody row justify-content-center align-items-center"
                                    [style.background-color]="
                                      subgroup.backgroundColor
                                        ? subgroup.backgroundColor
                                        : defaultColor
                                    " *ngIf="subgroup">
                                    <div class="col-2">
                                      <div *ngIf="role==='ADMINISTRATOR' && package?.groups?.length >= 1"
                                        title="{{getTextForTooltip(subgroup.published?.data[0],subgroup.restricted)}}"
                                        [ngStyle]=" {'border-color' : getColorForPlans(subgroup.published?.data[0],subgroup.restricted) }"
                                        class="outer my-auto col-2" data-bs-toggle="">
                                        <span class="inner"
                                          [ngStyle]="{ 'background': getColorForPlans(subgroup.published?.data[0],subgroup.restricted,subgroup.name) }"></span>
                                      </div>
                                    </div>
                                    <span class="col-9">{{ subgroup.name }}</span>
                                    <input class="col-1" type="checkbox" id="plancheck2Upgrade{{ subgroup.id }}" class="plancheckbox2{{
                                        package?.id
                                      }} plancheckbox2{{
                                        subgroup.id
                                      }} plancv largerCheckbox block2" attr.data="{{ package?.allowMultiple }}##{{
                                        subgroup.disallowedPlanLevels
                                      }}##{{ package?.id }}##{{
                                        subgroup.parentId
                                      }}##{{ subgroup.id }}##{{ package?.name }}##{{
                                        subgroup.name
                                      }}##{{ subgroup }}##{{ subgroup.ordering }}##{{
                                        i
                                      }}##{{ j }}##{{ k }}" (change)="
                                        onCheckboxChange2(
                                          $event,
                                          package?.allowMultiple,
                                          subgroup.disallowedPlanLevels,
                                          package?.id,
                                          subgroup.id,
                                          package?.name,
                                          subgroup.name,
                                          subgroup,
                                          subgroup.ordering,
                                          group.id,
                                          group.name,
                                          i,
                                          j,
                                          k
                                        )
                                      " />

                                    <div class="executiveplansselection" *ngIf="
                                        subgroup.coverage == '' && (subgroup.id == '17' || subgroup.id == '18' || subgroup.id == '28')
                                      ">
                                      <label class="radio-inline executiveplans">
                                        <input type="checkbox" name="executiveplansblock2{{ subgroup.id }}" id="executiveplansblock2single{{
                                            subgroup.id
                                          }}" style="vertical-align: bottom" (click)="
                                            executiveplansCoverage2(
                                              $event,
                                              i,
                                              j,
                                              k,
                                              subgroup.id
                                            )
                                          " />
                                        {{lang.Single}}
                                      </label>
                                      <label class="radio-inline executiveplans">
                                        <input type="checkbox" name="executiveplansblock2{{ subgroup.id }}" id="executiveplansblock2couple{{
                                            subgroup.id
                                          }}" style="vertical-align: bottom" (click)="
                                            executiveplansCoverage2(
                                              $event,
                                              i,
                                              j,
                                              k,
                                              subgroup.id
                                            )
                                          " />
                                        {{lang.Couple}}
                                      </label>
                                      <label class="radio-inline executiveplans">
                                        <input type="checkbox" name="executiveplansblock2{{ subgroup.id }}" id="executiveplansblock2family{{
                                            subgroup.id
                                          }}" style="vertical-align: bottom" (click)="
                                            executiveplansCoverage2(
                                              $event,
                                              i,
                                              j,
                                              k,
                                              subgroup.id
                                            )
                                          " />
                                        {{lang.Family}}
                                      </label>
                                    </div>

                                    <div class="executiveplansselection" *ngIf="
                                        subgroup.coverage == '001' && (subgroup.id == '17' || subgroup.id == '18' || subgroup.id == '28')
                                      ">
                                      <label class="radio-inline executiveplans">
                                        <input type="checkbox" name="executiveplansblock2{{ subgroup.id }}" id="executiveplansblock2couple{{
                                            subgroup.id
                                          }}" style="vertical-align: bottom" (click)="
                                            executiveplansCoverage2(
                                              $event,
                                              i,
                                              j,
                                              k,
                                              subgroup.id
                                            )
                                          " />
                                        {{lang.Couple}}
                                      </label>
                                      <label class="radio-inline executiveplans">
                                        <input type="checkbox" name="executiveplansblock2{{ subgroup.id }}" id="executiveplansblock2family{{
                                            subgroup.id
                                          }}" style="vertical-align: bottom" (click)="
                                            executiveplansCoverage2(
                                              $event,
                                              i,
                                              j,
                                              k,
                                              subgroup.id
                                            )
                                          " />
                                        {{lang.Family}}
                                      </label>
                                    </div>
                                    <div class="executiveplansselection" *ngIf="
                                        subgroup.coverage == '010' && (subgroup.id == '17' || subgroup.id == '18' || subgroup.id == '28')
                                      ">
                                      <label class="radio-inline executiveplans">
                                        <input type="checkbox" name="executiveplansblock2{{ subgroup.id }}" id="executiveplansblock2family{{
                                            subgroup.id
                                          }}" style="vertical-align: bottom" (click)="
                                            executiveplansCoverage2(
                                              $event,
                                              i,
                                              j,
                                              k,
                                              subgroup.id
                                            )
                                          " />
                                        {{lang.Family}}
                                      </label>
                                    </div>
                                    <div class="executiveplansselection" *ngIf="
                                        subgroup.coverage == '011' && (subgroup.id == '17' || subgroup.id == '18' || subgroup.id == '28')
                                      ">
                                      <label class="radio-inline executiveplans">
                                        <input type="checkbox" name="executiveplansblock2{{ subgroup.id }}" id="executiveplansblock2family{{
                                            subgroup.id
                                          }}" style="vertical-align: bottom" (click)="
                                            executiveplansCoverage2(
                                              $event,
                                              i,
                                              j,
                                              k,
                                              subgroup.id
                                            )
                                          " />
                                        {{lang.Family}}
                                      </label>
                                    </div>
                                  </div>
                                </div>
                                <!-- <textarea type="text" class="tierconfig"> Employee</textarea> -->
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <!-- <div class="planheadingwrap" *ngIf="package"></div> package && package?.id !== 2 -->
                      <!-- <h6 class="planheading">{{ package?.name }}<span *ngIf="package?.groups.length<=1" class="panel-title" [attr.data-bs-target]="'#collapsetwo'+package?.id" data-bs-toggle="collapse"   aria-expanded="true" aria-controls="collapsetwo{{package?.id}}"></span></h6> -->
                    </div>

                  </div>
                </div>
              </div>
              <!-- Block3 With No Tier -->
              <div class="row mt-2" style="width: 100%;">
                <div class="row header-title m-2 d-flex justify-content-between">
                  <div class="my-auto mx-2" style="width: auto;">
                    {{lang.Voluntary_Plans_Premium_paid_100_by_employee_directly}}.&nbsp;&nbsp;
                    <!--  -->
                  </div>
                  <div class="my-auto mx-4" style="width: auto;">{{lang.Enabled}}
                    <input class="" type="radio" name="employeepurchase" id="employeepurchasetrue" #employeepurchasetrue
                      value="true" (click)="planpurchase($event)" />
                    <label class="form-check-label" for="employeepurchasetrue"
                      class="employeepurchase">&nbsp;{{lang.Yes}}</label>&nbsp;&nbsp;
                    <input class="" type="radio" name="employeepurchase" id="employeepurchasefalse"
                      #employeepurchasefalse value="false" (click)="planpurchase($event)" checked />
                    <label class="form-check-label" for="employeepurchasefalse"
                      class="employeepurchase">&nbsp;{{lang.No}}</label>
                  </div>
                </div>


                <div class="row" *ngIf="employeeplanpurchase">
                  <div class="packageWrapper block3packagewrapper plansscreen3"
                    *ngFor="let package of plansresblack3; let i = index">
                    <div class="planheadingwrap" style="padding-left: 6px;">
                      <div class="d-flex position-relative">
                        <h6 *ngIf="package?.groups?.length >= 1 && showPackageName(package?.groups,'voluntary')"
                          class="planheading" [attr.data-bs-target]="'#collapsethree' + package?.id"
                          data-bs-toggle="collapse" aria-expanded="true" aria-controls="collapsethree{{ package?.id }}"
                          style="justify-content: space-around;" (click)="toggleCollapseeThree(package?.id)"
                          id="parent3">
                          {{ package?.name }}<span>{{ isCollapsedThree[package?.id] ? '+' : '-' }}</span>
                        </h6>
                        <!-- <h6 class="planheading" *ngIf="package?.groups?.length >  1">
                          {{ package?.name }}
                        </h6> -->
                        <div class="position-absolute" style="top: 18px;left: 10px;bottom: -39px;">
                          <div
                            *ngIf="role==='ADMINISTRATOR' && package?.groups?.length >= 1 && showPackageName(package?.groups,'voluntary')"
                            title="{{getTextForTooltip1(package?.published,package?.restrictedAccess)}}"
                            [ngStyle]=" {'border-color' : getColorForPlans1(package?.published,package?.restrictedAccess) }"
                            class="outer my-auto col-2" data-bs-toggle="">
                            <span class="inner"
                              [ngStyle]="{ 'background': getColorForPlans1(package?.published,package?.restrictedAccess) }"></span>
                          </div>
                        </div>
                        <div class="form-group package" *ngIf="!isCollapsedThree[package?.id]">
                          <!-- *ngIf="
                          package &&
                          package?.id !== 1 &&
                          package &&
                          package?.id !== 4 &&
                          package &&
                          package?.id !== 2 && package?.id !== hidewaddellplans" -->
                          <!-- &&package && package?.id !== 2 -->
                          <div class="package-groups1" *ngFor="let group of package?.groups; let j = index" title="">
                            <div class="price"
                              *ngIf="group && group != null  && showPackageName(package?.groups,'voluntary')">
                              <div class="header overflow-ellipsis1 panel-title"
                                [attr.data-bs-target]="'#collapsethree' + group.id" data-bs-toggle="collapse"
                                aria-expanded="true" aria-controls="collapsethree{{ group.id }}"
                                title="{{ group.name }}" *ngIf="
                                  group &&
                                  group.subGroups &&
                                  group.subGroups.length > 0 &&
                                  package?.groups?.length >  1
                                ">
                                {{ group.name }}
                              </div>
                            </div>
                            <div class="planbody" *ngIf="
                                group && group.subGroups && group.subGroups.length > 0
                              ">
                              <div *ngFor="
                                  let subgroup of group.subGroups;
                                  let k = index
                                ">
                                <div *ngIf="subgroup &&  subgroup?.settings?.voluntary" id="collapsethree{{
                                    package?.groups?.length >  1
                                      ? subgroup.parentId
                                      : package?.id
                                  }}" class="accordion-collapse collapse show">
                                  <div class="featuutrebody row justify-content-center align-items-center"
                                    [style.background-color]="
                                      subgroup.backgroundColor
                                        ? subgroup.backgroundColor
                                        : defaultColor
                                    " *ngIf="subgroup">
                                    <div class="col-3">
                                      <div *ngIf="role==='ADMINISTRATOR' && package?.groups?.length >= 1"
                                        title="{{getTextForTooltip(subgroup.published?.data[0],subgroup.restricted)}}"
                                        [ngStyle]=" {'border-color' : getColorForPlans(subgroup.published?.data[0],subgroup.restricted) }"
                                        class="outer my-auto col-2" data-bs-toggle="">
                                        <span class="inner"
                                          [ngStyle]="{ 'background': getColorForPlans(subgroup.published?.data[0],subgroup.restricted,subgroup.name) }"></span>
                                      </div>
                                    </div>
                                    <span class="col-8">{{ subgroup.name }}</span>
                                    <input type="checkbox" id="plancheck3Voluntry{{ subgroup.id }}" class=" col-1 plancheckbox3{{
                                        package?.id
                                      }} plancv largerCheckbox" attr.data="{{ package?.allowMultiple }}##{{
                                        subgroup.disallowedPlanLevels
                                      }}##{{ package?.id }}##{{
                                        subgroup.parentId
                                      }}##{{ subgroup.id }}##{{ package?.name }}##{{
                                        subgroup.name
                                      }}##{{ subgroup }}##{{ subgroup.ordering }}" (change)="
                                        onCheckboxChange3(
                                          $event,
                                          package?.allowMultiple,
                                          subgroup.disallowedPlanLevels,
                                          package?.id,
                                          subgroup.id,
                                          package?.name,
                                          subgroup.name,
                                          subgroup,
                                          subgroup.ordering,
                                          group.id,
                                          group.name,
                                          i,
                                          j,
                                          k
                                        )
                                      " />
                                    <ng-container>
                                      <div *ngIf="
                                          subgroup.coverage == '' && (subgroup.id == '17' || subgroup.id == '18' || subgroup.id == '28')
                                        ">
                                        <form class="executiveplansselection">
                                          <label class="radio-inline executiveplans">
                                            <input type="checkbox" name="executiveplansblock3{{
                                                subgroup.id
                                              }}" id="executiveplansblock3single{{
                                                subgroup.id
                                              }}" style="vertical-align: bottom" (click)="
                                                executiveplansCoverage3(
                                                  $event,
                                                  i,
                                                  j,
                                                  k,
                                                  subgroup.id
                                                )
                                              " />
                                            {{lang.Single}}
                                          </label>
                                          <label class="radio-inline executiveplans">
                                            <input type="checkbox" name="executiveplansblock3{{
                                                subgroup.id
                                              }}" id="executiveplansblock3couple{{
                                                subgroup.id
                                              }}" style="vertical-align: bottom" (click)="
                                                executiveplansCoverage3(
                                                  $event,
                                                  i,
                                                  j,
                                                  k,
                                                  subgroup.id
                                                )
                                              " />
                                            {{lang.Couple}}
                                          </label>
                                          <label class="radio-inline executiveplans">
                                            <input type="checkbox" name="executiveplansblock3{{
                                                subgroup.id
                                              }}" id="executiveplansblock3family{{
                                                subgroup.id
                                              }}" style="vertical-align: bottom" (click)="
                                                executiveplansCoverage3(
                                                  $event,
                                                  i,
                                                  j,
                                                  k,
                                                  subgroup.id
                                                )
                                              " />
                                            {{lang.Family}}
                                          </label>
                                        </form>
                                      </div>
                                      <div *ngIf="
                                          subgroup.coverage == 'Family' &&
                                          (subgroup.id == '17' || subgroup.id == '18' || subgroup.id == '28')
                                        ">

                                      </div>

                                      <div *ngIf="
                                          subgroup.coverage == '001' &&
                                          (subgroup.id == '17' || subgroup.id == '18' || subgroup.id == '28')
                                        ">
                                        <form class="executiveplansselection">
                                          <!-- <label class="radio-inline executiveplans">
                              <input type="radio" name="executiveplans" style="vertical-align: bottom;" value="Family" (click)="executiveplansCoverage3($event,i,j,k)"> Single
                            </label> -->
                                          <label class="radio-inline executiveplans">
                                            <input type="checkbox" name="executiveplansblock3{{
                                                subgroup.id
                                              }}" id="executiveplansblock3couple{{
                                                subgroup.id
                                              }}" style="vertical-align: bottom" (click)="
                                                executiveplansCoverage3(
                                                  $event,
                                                  i,
                                                  j,
                                                  k,
                                                  subgroup.id
                                                )
                                              " />
                                            {{lang.Couple}}
                                          </label>
                                          <label class="radio-inline executiveplans">
                                            <input type="checkbox" name="executiveplansblock3{{
                                                subgroup.id
                                              }}" id="executiveplansblock3family{{
                                                subgroup.id
                                              }}" style="vertical-align: bottom" (click)="
                                                executiveplansCoverage3(
                                                  $event,
                                                  i,
                                                  j,
                                                  k,
                                                  subgroup.id
                                                )
                                              " />
                                            {{lang.Family}}
                                          </label>
                                        </form>
                                      </div>
                                      <div *ngIf="
                                          subgroup.coverage == '010' &&
                                          (subgroup.id == '17' || subgroup.id == '18' || subgroup.id == '28')

                                        ">
                                        <form class="executiveplansselection">
                                          <label class="radio-inline executiveplans">
                                            <input type="checkbox" name="executiveplansblock3{{
                                                subgroup.id
                                              }}" id="executiveplansblock3family{{
                                                subgroup.id
                                              }}" style="vertical-align: bottom" (click)="
                                                executiveplansCoverage3(
                                                  $event,
                                                  i,
                                                  j,
                                                  k,
                                                  subgroup.id
                                                )
                                              " />
                                            {{lang.Family}}
                                          </label>
                                          <!-- <label class="radio-inline executiveplans">
                              <input type="radio" name="executiveplans" style="vertical-align: bottom;" value="Couple" (click)="executiveplansCoverage3($event,i,j,k)"> Couple
                            </label> -->
                                        </form>
                                      </div>
                                      <div *ngIf="
                                          subgroup.coverage == '011' &&
                                          (subgroup.id == '17' || subgroup.id == '18'|| subgroup.id == '28')

                                        ">
                                        <form class="executiveplansselection">
                                          <label class="radio-inline executiveplans">
                                            <input type="checkbox" name="executiveplansblock3{{
                                                subgroup.id
                                              }}" id="executiveplansblock3family{{
                                                subgroup.id
                                              }}" style="vertical-align: bottom" (click)="
                                                executiveplansCoverage3(
                                                  $event,
                                                  i,
                                                  j,
                                                  k,
                                                  subgroup.id
                                                )
                                              " />
                                            {{lang.Family}}
                                          </label>
                                          <!-- <label class="radio-inline executiveplans">
                          <input type="radio" name="executiveplans" style="vertical-align: bottom;" value="Couple" (click)="executiveplansCoverage3($event,i,j,k)"> Couple
                        </label> -->
                                        </form>
                                      </div>
                                    </ng-container>
                                  </div>
                                </div>
                                <!-- <textarea type="text" class="tierconfig"> Employee</textarea> -->
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                  </div>
                </div>
              </div>
              <!-- Block1 With With Tier -->
              <div class="row" *ngIf="showtieradvplans1">
                <div class="packageWrapper plansscreen" *ngFor="let package of plansBlock1Tiers; let i = index">
                  <div class="planheadingwrap" style="padding-left: 6px;">
                    <h6 *ngIf="package?.groups.length <= 1" class="planheading panel-title"
                      [attr.data-bs-target]="'#collapseadvone' + package?.id" data-bs-toggle="collapse"
                      aria-expanded="true" aria-controls="collapseadvone{{ package?.id }}">
                      {{ package?.name }}
                    </h6>
                    <!-- <h6 class="planheading" *ngIf="package?.groups?.length >  1">
                      {{ package?.name }}
                    </h6> -->
                  </div>

                  <div class="form-group package">
                    <div class="package-groups1" *ngFor="let group of package?.groups; let j = index" title="">
                      <div class="price" id="myGroup">
                        <div class="header overflow-ellipsis1 panel-title"
                          [attr.data-bs-target]="'#collapseadvone' + group.id" data-bs-toggle="collapse"
                          aria-expanded="true" aria-controls="collapseone{{ group.id }}" title="{{ group.name }}"
                          *ngIf="package?.groups?.length >  1">
                          {{ group.name }}
                        </div>
                      </div>

                      <div class="planbody" *ngIf="group.subGroups && group.subGroups.length > 0">
                        <div *ngFor="let subgroup of group.subGroups; let k = index" id="collapseadvone{{
                            package?.groups?.length >  1
                              ? subgroup.parentId
                              : package?.id
                          }}" class="accordion-collapse collapse show">
                          <div class="featuutrebody" [style.background-color]="
                              subgroup.backgroundColor
                                ? subgroup.backgroundColor
                                : defaultColor
                            ">
                            <span>{{ subgroup.name }}</span>
                            <input type="checkbox" id="plancheck{{ subgroup.id }}" class="plancheckbox{{
                                package?.id
                              }} plancv largerCheckbox block1tiers" attr.data="{{ package?.allowMultiple }}##{{
                                subgroup.disallowedPlanLevels
                              }}##{{ package?.id }}##{{ subgroup.parentId }}##{{
                                subgroup.id
                              }}##{{ package?.name }}##{{ subgroup.name }}##{{
                                subgroup
                              }}##{{ subgroup.ordering }}##{{ i }}##{{ j }}##{{
                                k
                              }}" (change)="
                                onCheckboxChange1Tier(
                                  $event,
                                  package?.allowMultiple,
                                  subgroup.disallowedPlanLevels,
                                  package?.id,
                                  subgroup.id,
                                  package?.name,
                                  subgroup.name,
                                  subgroup,
                                  subgroup.ordering,
                                  group.id,
                                  group.name,
                                  i,
                                  j,
                                  k,
                                  subgroup.backgroundColor
                                )
                              " />
                            <ng-container>
                              <!-- <div  *ngIf="subgroup.coverage=='default' && group.id=='15' && subgroup.checked"> -->


                              <div class="executiveplansselection" *ngIf="(subgroup.id == '17' || subgroup.id == '18')">
                                <label class="radio-inline executiveplans">
                                  <input type="checkbox" name="executiveplans{{ subgroup.id }}"
                                    id="executiveplansTiersingle{{ subgroup.id }}" style="vertical-align: bottom"
                                    (click)="
                                      executiveplansCoverageTier1(
                                        $event,
                                        i,
                                        j,
                                        k,
                                        subgroup.id
                                      )
                                    " />
                                  Single
                                </label>
                                <label class="radio-inline executiveplans">
                                  <input type="checkbox" name="executiveplans{{ subgroup.id }}"
                                    id="executiveplansTiercouple{{ subgroup.id }}" style="vertical-align: bottom"
                                    (click)="
                                      executiveplansCoverageTier1(
                                        $event,
                                        i,
                                        j,
                                        k,
                                        subgroup.id
                                      )
                                    " />
                                  Couple
                                </label>
                                <label class="radio-inline executiveplans">
                                  <input type="checkbox" name="executiveplans{{ subgroup.id }}"
                                    id="executiveplansTierfamily{{ subgroup.id }}" style="vertical-align: bottom"
                                    (click)="
                                      executiveplansCoverageTier1(
                                        $event,
                                        i,
                                        j,
                                        k,
                                        subgroup.id
                                      )
                                    " />
                                  Family
                                </label>
                              </div>
                            </ng-container>
                          </div>

                          <ng-container>
                            <div class="tierconfig" *ngIf="
                                subgroup.tiers.length == 0 && subgroup.checked
                              ">
                              <ul class="tiersConfigul">
                                <li>Configure Tier</li>
                              </ul>
                            </div>
                          </ng-container>

                          <ng-container *ngIf="
                              subgroup.tiers &&
                              subgroup.tiers.length != null &&
                              subgroup.tiers != ''
                            ">
                            <div class="tierconfig">
                              <ul *ngFor="let tier of subgroup.tiers">
                                <li>{{ tier.name }}</li>
                              </ul>
                            </div>
                          </ng-container>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="form-group col-10"></div>
                  <div class="form-group col-2">
                    <button class="btn btn-primary" type="button" data-bs-toggle="modal" data-bs-target="#tierConfigure"
                      *ngIf="showtieradvplans" style="float: right" (click)="configuretiers()">
                      Configure&nbsp;&nbsp;<i aria-hidden="true" class="fa fa-long-arrow-right"></i>
                    </button>
                  </div>
                </div>
              </div>
              <!-- Block2 With With Tier -->
              <div class="row" *ngIf="showtieradvplans1">
                <div class="form-group col-12">
                  <span class="enabledplans1">Enabled?
                    <input class="" type="radio" name="upgradeplanstiers" id="upgradeplanstierstrue"
                      #upgradeplanstierstrue value="true" (click)="upgradeplansTiers($event)" />
                    <label class="form-check-label" for="upgradeplanstiersyes"
                      class="upgradeplans">&nbsp;Yes</label>&nbsp;&nbsp;
                    <input class="" type="radio" name="upgradeplanstiers" id="upgradeplanstiersfalse"
                      #upgradeplanstiersfalse value="false" (click)="upgradeplansTiers($event)" checked />
                    <label class="form-check-label" for="upgradeplanstiersno" class="upgradeplans">&nbsp;No</label>
                  </span>

                  <h6 class="admintitle">
                    Upgrade Plans (Premium difference paid by employee through
                    payroll deduction).&nbsp;&nbsp;
                  </h6>
                </div>
                <div class="row" *ngIf="upgradeplansselectiontiers">
                  <div class="packageWrapper block2packagewrapper plansscreen2"
                    *ngFor="let package of plansresblack2Tiers; let i = index">
                    <div class="planheadingwrap" *ngIf="package" style="padding-left: 6px;">
                      <!-- <div class="planheadingwrap" *ngIf="package"></div> -->
                      <h6 *ngIf="package?.groups.length <= 1" class="planheading panel-title"
                        [attr.data-bs-target]="'#collapseadvtwo' + package?.id" data-bs-toggle="collapse"
                        aria-expanded="true" aria-controls="collapseadvtwo{{ package?.id }}">
                        {{ package?.name }}
                      </h6>
                      <!-- <h6 class="planheading" *ngIf="package?.groups?.length >  1">
                        {{ package?.name }}
                      </h6> -->
                      <!-- <h6 class="planheading">{{ package?.name }}<span *ngIf="package?.groups.length<=1" class="panel-title" [attr.data-bs-target]="'#collapseadvtwo'+package?.id" data-bs-toggle="collapse"   aria-expanded="true" aria-controls="collapseadvtwo{{package?.id}}"></span></h6> -->
                    </div>
                    <div class="form-group package" *ngIf="package">
                      <div class="package-groups1" *ngFor="let group of package?.groups; let j = index" title="">
                        <div class="price" *ngIf="group && group != null">
                          <div class="header overflow-ellipsis1 panel-title"
                            [attr.data-bs-target]="'#collapseadvtwo' + group.id" data-bs-toggle="collapse"
                            aria-expanded="true" aria-controls="collapseadvtwo{{ group.id }}" title="{{ group.name }}"
                            *ngIf="
                              group &&
                              group.subGroups &&
                              group.subGroups.length &&
                              package?.groups?.length >  1 > 0
                            ">
                            {{ group.name }}
                          </div>
                        </div>

                        <div class="planbody" *ngIf="
                            group && group.subGroups && group.subGroups.length > 0
                          ">
                          <div *ngFor="
                              let subgroup of group.subGroups;
                              let k = index
                            ">
                            <div *ngIf="subgroup" id="collapseadvtwo{{
                                package?.groups?.length >  1
                                  ? subgroup.parentId
                                  : package?.id
                              }}" class="accordion-collapse collapse show">
                              <div class="featuutrebody" [style.background-color]="
                                  subgroup.backgroundColor
                                    ? subgroup.backgroundColor
                                    : defaultColor
                                " *ngIf="subgroup">
                                <span>{{ subgroup.name }}</span>
                                <input type="checkbox" id="plancheck2Upgrade{{ subgroup.id }}" class="plancheckbox2{{
                                    package?.id
                                  }} plancheckbox2{{
                                    subgroup.id
                                  }} plancv largerCheckbox block2tiers" attr.data="{{ package?.allowMultiple }}##{{
                                    subgroup.disallowedPlanLevels
                                  }}##{{ package?.id }}##{{
                                    subgroup.parentId
                                  }}##{{ subgroup.id }}##{{ package?.name }}##{{
                                    subgroup.name
                                  }}##{{ subgroup }}##{{ subgroup.ordering }}##{{
                                    i
                                  }}##{{ j }}##{{ k }}" (change)="
                                    onCheckboxChange2Tier(
                                      $event,
                                      package?.allowMultiple,
                                      subgroup.disallowedPlanLevels,
                                      package?.id,
                                      subgroup.id,
                                      package?.name,
                                      subgroup.name,
                                      subgroup,
                                      subgroup.ordering,
                                      group.id,
                                      group.name,
                                      i,
                                      j,
                                      k,
                                      subgroup.backgroundColor
                                    )
                                  " />
                                <ng-container>
                                  <div class="executiveplansselection" *ngIf="
                                      subgroup.coverage == '' && (subgroup.id == '17' || subgroup.id == '18')
                                    ">
                                    <label class="radio-inline executiveplans">
                                      <input type="checkbox" name="executiveplansblock2Tiers{{
                                          subgroup.id
                                        }}" id="executiveplansblock2Tiersingle{{
                                          subgroup.id
                                        }}" style="vertical-align: bottom" (click)="
                                          executiveplansCoverageTier2(
                                            $event,
                                            i,
                                            j,
                                            k,
                                            subgroup.id
                                          )
                                        " />
                                      Single
                                    </label>
                                    <label class="radio-inline executiveplans">
                                      <input type="checkbox" name="executiveplansblock2Tiers{{
                                          subgroup.id
                                        }}" id="executiveplansblock2Tiercouple{{
                                          subgroup.id
                                        }}" style="vertical-align: bottom" (click)="
                                          executiveplansCoverageTier2(
                                            $event,
                                            i,
                                            j,
                                            k,
                                            subgroup.id
                                          )
                                        " />
                                      Couple
                                    </label>
                                    <label class="radio-inline executiveplans">
                                      <input type="checkbox" name="executiveplansblock2Tiers{{
                                          subgroup.id
                                        }}" id="executiveplansblock2Tierfamily{{
                                          subgroup.id
                                        }}" style="vertical-align: bottom" (click)="
                                          executiveplansCoverageTier2(
                                            $event,
                                            i,
                                            j,
                                            k,
                                            subgroup.id
                                          )
                                        " />
                                      Family
                                    </label>
                                  </div>

                                  <div class="executiveplansselection" *ngIf="
                                      subgroup.coverage == 'Single' &&
                                      (subgroup.id == '17' || subgroup.id == '18')
                                    ">
                                    <label class="radio-inline executiveplans">
                                      <input type="checkbox" name="executiveplansblock2Tiers{{
                                          subgroup.id
                                        }}" id="executiveplansblock2Tiercouple{{
                                          subgroup.id
                                        }}" style="vertical-align: bottom" (click)="
                                          executiveplansCoverageTier2(
                                            $event,
                                            i,
                                            j,
                                            k,
                                            subgroup.id
                                          )
                                        " />
                                      Couple
                                    </label>
                                    <label class="radio-inline executiveplans">
                                      <input type="checkbox" name="executiveplansblock2Tiers{{
                                          subgroup.id
                                        }}" id="executiveplansblock2Tierfamily{{
                                          subgroup.id
                                        }}" style="vertical-align: bottom" (click)="
                                          executiveplansCoverageTier2(
                                            $event,
                                            i,
                                            j,
                                            k,
                                            subgroup.id
                                          )
                                        " />
                                      Family
                                    </label>
                                  </div>
                                  <div class="executiveplansselection" *ngIf="
                                      subgroup.coverage == 'Couple' &&
                                      (subgroup.id == '17' || subgroup.id == '18')
                                    ">
                                    <label class="radio-inline executiveplans">
                                      <input type="checkbox" name="executiveplansblock2Tiers{{
                                          subgroup.id
                                        }}" id="executiveplansblock2Tierfamily{{
                                          subgroup.id
                                        }}" style="vertical-align: bottom" (click)="
                                          executiveplansCoverageTier2(
                                            $event,
                                            i,
                                            j,
                                            k,
                                            subgroup.id
                                          )
                                        " />
                                      Family
                                    </label>
                                  </div>
                                </ng-container>
                              </div>
                              <ng-container>
                                <div class="tierconfig" *ngIf="
                                    subgroup.tiers.length == 0 && subgroup.checked
                                  ">
                                  <ul class="tiersConfigul">
                                    <li>Configure Tier</li>
                                  </ul>
                                </div>
                              </ng-container>

                              <ng-container *ngIf="
                                  subgroup.tiers &&
                                  subgroup.tiers.length != null &&
                                  subgroup.tiers != ''
                                ">
                                <div class="tierconfig">
                                  <ul *ngFor="let tier of subgroup.tiers">
                                    <li>{{ tier.name }}</li>
                                  </ul>
                                </div>
                              </ng-container>
                            </div>
                            <!-- <textarea type="text" class="tierconfig"> Employee</textarea> -->
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="form-group col-10"></div>
                  <div class="form-group col-2">
                    <button class="btn btn-primary" type="button" data-bs-toggle="modal"
                      data-bs-target="#tierConfigureBlock2" *ngIf="upgradeplansselectiontiers" style="float: right"
                      (click)="configuretiers()">
                      Configure&nbsp;&nbsp;<i aria-hidden="true" class="fa fa-long-arrow-right"></i>
                    </button>
                  </div>
                </div>
              </div>
              <!-- Block3 With With Tier -->
              <div class="row" *ngIf="showtieradvplans1">
                <div class="form-group col-12">
                  <span class="enabledplans1">Enabled?
                    <input class="" type="radio" name="employeepurchaseTiers" id="employeepurchaseTierstrue"
                      #employeepurchaseTierstrue value="true" (click)="planpurchaseTiers($event)" />
                    <label class="form-check-label" for="employeepurchasetierstrue"
                      class="employeepurchase">&nbsp;Yes</label>&nbsp;&nbsp;
                    <input class="" type="radio" name="employeepurchaseTiers" id="employeepurchaseTiersfalse"
                      #employeepurchaseTiersfalse value="false" (click)="planpurchaseTiers($event)" checked />
                    <label class="form-check-label" for="employeepurchasetiersfalse"
                      class="employeepurchase">&nbsp;No</label>
                  </span>
                  <h6 class="admintitle">
                    Voluntary Plans (Premium paid 100% by employee
                    directly).&nbsp;&nbsp;
                  </h6>
                </div>

                <div class="row" *ngIf="employeeplanpurchasetiers">
                  <div class="packageWrapper block3packagewrapper plansscreen3"
                    *ngFor="let package of plansresblack3Tiers; let i = index">
                    <div class="planheadingwrap" style="padding-left: 6px;" *ngIf="
                        package &&
                        package?.id !== 1 &&
                        package &&
                        package?.id !== 4 &&
                        package &&
                        package?.id !== 5
                      ">
                      <!-- <div class="planheadingwrap" *ngIf="package"></div> -->
                      <h6 *ngIf="package?.groups.length <= 1" class="planheading panel-title"
                        [attr.data-bs-target]="'#collapseadvthree' + package?.id" data-bs-toggle="collapse"
                        aria-expanded="true" aria-controls="collapseadvthree{{ package?.id }}">
                        {{ package?.name }}
                      </h6>
                      <!-- <h6 class="planheading" *ngIf="package?.groups?.length >  1">
                        {{ package?.name }}
                      </h6> -->
                      <!-- <h6 class="planheading">{{ package?.name }}<span *ngIf="package?.groups.length<=1" class="panel-title" [attr.data-bs-target]="'#collapseadvtwo'+package?.id" data-bs-toggle="collapse"   aria-expanded="true" aria-controls="collapseadvtwo{{package?.id}}"></span></h6> -->
                    </div>
                    <div class="form-group package" *ngIf="
                        package &&
                        package?.id !== 1 &&
                        package &&
                        package?.id !== 4 &&
                        package &&
                        package?.id !== 5
                      ">
                      <div class="package-groups1" *ngFor="let group of package?.groups; let j = index" title="">
                        <div class="price" *ngIf="group && group != null">
                          <div class="header overflow-ellipsis1 panel-title"
                            [attr.data-bs-target]="'#collapseadvthree' + group.id" data-bs-toggle="collapse"
                            aria-expanded="true" aria-controls="collapseadvthree{{ group.id }}" title="{{ group.name }}"
                            *ngIf="
                              group &&
                              group.subGroups &&
                              group.subGroups.length &&
                              package?.groups?.length >  1 > 0
                            ">
                            {{ group.name }}
                          </div>
                        </div>

                        <div class="planbody" *ngIf="
                            group && group.subGroups && group.subGroups.length > 0
                          ">
                          <div *ngFor="
                              let subgroup of group.subGroups;
                              let k = index
                            ">
                            <div *ngIf="subgroup" id="collapseadvthree{{
                                package?.groups?.length >  1
                                  ? subgroup.parentId
                                  : package?.id
                              }}" class="accordion-collapse collapse show">
                              <div class="featuutrebody" [style.background-color]="
                                  subgroup.backgroundColor
                                    ? subgroup.backgroundColor
                                    : defaultColor
                                " *ngIf="subgroup">
                                <span>{{ subgroup.name }}</span>
                                <input type="checkbox" id="plancheck3Voluntry{{ subgroup.id }}" class="plancheckbox3{{
                                    package?.id
                                  }} plancv largerCheckbox block3tiers" attr.data="{{ package?.allowMultiple }}##{{
                                    subgroup.disallowedPlanLevels
                                  }}##{{ package?.id }}##{{
                                    subgroup.parentId
                                  }}##{{ subgroup.id }}##{{ package?.name }}##{{
                                    subgroup.name
                                  }}##{{ subgroup }}##{{ subgroup.ordering }}##{{
                                    i
                                  }}##{{ j }}##{{ k }}" (change)="
                                    onCheckboxChange3Tier(
                                      $event,
                                      package?.allowMultiple,
                                      subgroup.disallowedPlanLevels,
                                      package?.id,
                                      subgroup.id,
                                      package?.name,
                                      subgroup.name,
                                      subgroup,
                                      subgroup.ordering,
                                      group.id,
                                      group.name,
                                      i,
                                      j,
                                      k,
                                      subgroup.backgroundColor
                                    )
                                  " />
                                <ng-container>
                                  <div class="executiveplansselection" *ngIf="
                                      subgroup.coverage == '' && (subgroup.id == '17' || subgroup.id == '18')
                                    ">
                                    <label class="radio-inline executiveplans">
                                      <input type="checkbox" name="executiveplansblock3Tiers{{
                                          subgroup.id
                                        }}" id="executiveplansblock3Tiersingle{{
                                          subgroup.id
                                        }}" style="vertical-align: bottom" (click)="
                                          executiveplansCoverageTier3(
                                            $event,
                                            i,
                                            j,
                                            k,
                                            subgroup.id
                                          )
                                        " />
                                      Single
                                    </label>
                                    <label class="radio-inline executiveplans">
                                      <input type="checkbox" name="executiveplansblock3Tiers{{
                                          subgroup.id
                                        }}" id="executiveplansblock3Tiercouple{{
                                          subgroup.id
                                        }}" style="vertical-align: bottom" (click)="
                                          executiveplansCoverageTier3(
                                            $event,
                                            i,
                                            j,
                                            k,
                                            subgroup.id
                                          )
                                        " />
                                      Couple
                                    </label>
                                    <label class="radio-inline executiveplans">
                                      <input type="checkbox" name="executiveplansblock3Tiers{{
                                          subgroup.id
                                        }}" id="executiveplansblock3Tierfamily{{
                                          subgroup.id
                                        }}" style="vertical-align: bottom" (click)="
                                          executiveplansCoverageTier3(
                                            $event,
                                            i,
                                            j,
                                            k,
                                            subgroup.id
                                          )
                                        " />
                                      Family
                                    </label>
                                  </div>

                                  <div class="executiveplansselection" *ngIf="
                                      subgroup.coverage == 'Single' &&
                                      (subgroup.id == '17' || subgroup.id == '18')
                                    ">
                                    <label class="radio-inline executiveplans">
                                      <input type="checkbox" name="executiveplansblock3Tiers{{
                                          subgroup.id
                                        }}" id="executiveplansblock3Tiercouple{{
                                          subgroup.id
                                        }}" style="vertical-align: bottom" (click)="
                                          executiveplansCoverageTier3(
                                            $event,
                                            i,
                                            j,
                                            k,
                                            subgroup.id
                                          )
                                        " />
                                      Couple
                                    </label>
                                    <label class="radio-inline executiveplans">
                                      <input type="checkbox" name="executiveplansblock3Tiers{{
                                          subgroup.id
                                        }}" id="executiveplansblock3Tierfamily{{
                                          subgroup.id
                                        }}" style="vertical-align: bottom" (click)="
                                          executiveplansCoverageTier3(
                                            $event,
                                            i,
                                            j,
                                            k,
                                            subgroup.id
                                          )
                                        " />
                                      Family
                                    </label>
                                  </div>
                                  <div class="executiveplansselection" *ngIf="
                                      subgroup.coverage == 'Couple' &&
                                      (subgroup.id == '17' || subgroup.id == '18')
                                    ">
                                    <label class="radio-inline executiveplans">
                                      <input type="checkbox" name="executiveplansblock3Tiers{{
                                          subgroup.id
                                        }}" id="executiveplansblock3Tierfamily{{
                                          subgroup.id
                                        }}" style="vertical-align: bottom" (click)="
                                          executiveplansCoverageTier3(
                                            $event,
                                            i,
                                            j,
                                            k,
                                            subgroup.id
                                          )
                                        " />
                                      Family
                                    </label>
                                  </div>
                                </ng-container>
                              </div>
                              <ng-container>
                                <div class="tierconfig" *ngIf="
                                    subgroup.tiers.length == 0 && subgroup.checked
                                  ">
                                  <ul class="tiersConfigul">
                                    <li>Configure Tier</li>
                                  </ul>
                                </div>
                              </ng-container>

                              <ng-container *ngIf="
                                  subgroup.tiers &&
                                  subgroup.tiers.length != null &&
                                  subgroup.tiers != ''
                                ">
                                <div class="tierconfig">
                                  <ul *ngFor="let tier of subgroup.tiers">
                                    <li>{{ tier.name }}</li>
                                  </ul>
                                </div>
                              </ng-container>
                            </div>
                            <!-- <textarea type="text" class="tierconfig"> Employee</textarea> -->
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="form-group col-10"></div>
                  <div class="form-group col-2">
                    <button class="btn btn-primary" type="button" data-bs-toggle="modal"
                      data-bs-target="#tierConfigureBlock3" *ngIf="employeeplanpurchasetiers" style="float: right"
                      (click)="configuretiers()">
                      Configure&nbsp;&nbsp;<i aria-hidden="true" class="fa fa-long-arrow-right"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <!-- Plans screen footerpage -->

            <div class="d-flex justify-content-between" style="padding-bottom: 25px">
              <button class="saveAndNext" id="" type="button" (click)="gotobasicInfo()">
                <i aria-hidden="true" class="fa fa-long-arrow-left"></i>&nbsp;&nbsp;{{lang.Previous}}
              </button>

              <!-- <button class="saveAndNext" id="" type="button" [disabled]="plansButtonDisable" (click)="submitplansInfo()">
                {{lang.Save_Next}}&nbsp;&nbsp;<i aria-hidden="true" class="fa fa-long-arrow-right"></i>
              </button> -->
              <button class="saveAndNext" id="" type="button" [disabled]="plansButtonDisable"
                (click)="commonPlans.submitplansInfo()">
                {{lang.Save_Next}}&nbsp;&nbsp;<i aria-hidden="true" class="fa fa-long-arrow-right"></i>
              </button>
            </div>
          </ng-container>

        </div>

        <!-- No wallet and No Tier -->
        <div class="row" *ngIf="nowalletnotierInfo">
          <div class="col-sm-12">
            <form class="plansform form-container">
              <div class="row">
                <div class="form-group col-6">
                  <h6 class="admintitle">
                    GroupBenefitz Wallet<sup>TM</sup>&nbsp;&nbsp;
                  </h6>

                  <div style="text-align: center">
                    <strong>{{ corporationclient }}</strong> opted for a Group
                    Benefits Wallet
                  </div>

                  <div style="text-align: center">No</div>
                </div>
                <div class="form-group col-6">
                  <h6 class="admintitle">
                    Multi-Tiered Health Benefits Options:&nbsp;&nbsp;
                  </h6>

                  <div style="text-align: center">
                    <strong>{{ corporationclient }}</strong> has opted for
                    Tiered Health Benefits?
                  </div>

                  <div style="text-align: center">No</div>
                </div>
              </div>

              <!-- <div class="row">
                <div class="form-group col-10">
                  <button class="btn btn-primary" type="button" (click)="gotonotiernwalletInfo()" style="float: left">
                    <i aria-hidden="true" class="fa fa-long-arrow-left"></i>&nbsp;&nbsp;Previous
                  </button>
                </div>
                <div class="form-group col-2">

                  <button class="btn btn-primary" type="button" (click)="gotoEmployeeDetails()">
                    Save & Next&nbsp;&nbsp;<i aria-hidden="true" class="fa fa-long-arrow-right"></i>
                  </button>
                </div>
              </div> -->

              <div class="d-flex justify-content-between" style="padding-top: 10px">
                <button class="saveAndNext" id="" type="button" (click)="gotonotiernwalletInfo()">
                  <i aria-hidden="true" class="fa fa-long-arrow-left"></i>&nbsp;&nbsp;Previous
                </button>
                <button class="saveAndNext" id="" type="button" (click)="gotoEmployeeDetails()">
                  Save & Next&nbsp;&nbsp;<i aria-hidden="true" class="fa fa-long-arrow-right"></i>
                </button>
              </div>
            </form>
          </div>
        </div>

        <!-- with wallet screen -->
        <!-- <app-wallet-config (gotoplansPage)="gotoplanspagefromwallet()" (showEmployeePage)="showemployeepage($event)"
          [languageData]="languageData" [defaultAmountdata]="defaultAmount" *ngIf="wallettierInfo"></app-wallet-config> -->
        <!-- Add Employees Screen -->
        <app-employee (gotoplansorwallet)="gotoPlansorWallet($event)" (showDataGraph)="showdatagrpah($event)"
          [employeeWorkingProviance]="employeeWorkingProviance" [employeeData]="addedEmployeelist"
          [languageData]="languageData" [headcount]="showEmployeeValue"
          [corporateSignupConfigData]="corporateSignupConfigData" [bulkPlans]="bulkplans"
          *ngIf="EmployeeInfo"></app-employee>

        <!-- Data Graph and summary Screen adminform-->
        <div class="row" *ngIf="datagraphInfo">
          <div class="col-sm-12">
            <form class="plansform linescrollbar form-container">
              <div class="row">
                <div class="form-group col-12">
                  <h6 class="admintitle">
                    {{lang.Setup_Status}}&nbsp;&nbsp;
                  </h6>
                </div>

                <div class="row">
                  <app-chart-guage [MaxEmployee]="maxEmployeeCount" [MinEmployee]="lengthofemployee"
                    [status]="applicationStatus"></app-chart-guage>
                </div>

                <div class="row"></div>
                <!-- <div class="row" style="margin-top: 40px">
                  <div class="col-4" *ngIf="setupWallet">
                    <span>{{lang.GroupBenefitz_Wallet}}<sup>TM</sup>&nbsp;&nbsp;</span>

                    <div>
                      <b>{{ walletData }}</b>
                    </div>
                    <div>
                      <b>{{ selectedWalletConfig }}</b>
                    </div>
                    <div *ngIf="walletData === 'Selected'">
                      <div *ngFor="let item of finalTiersforGraph">
                        <ul class="tiersConfigul12" style="padding: 0px">
                          <li>
                            <b>{{ item.Tier }}:${{ item.walletAmount }}</b>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div class="col-4 ps-4" *ngIf="setUplevelofCoverage">
                    <span>{{lang.Classification_Tiers}}&nbsp;&nbsp;</span>

                    <div>
                      <b>{{ TierData }}</b>
                    </div>

                    <div *ngFor="let item of TierlistforGrapsh">
                      <ul class="tiersConfigul12" style="padding: 0px">
                        <li>
                          <b>{{ item.planLevelName }}:{{ item.tierId }}</b>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div class="col-4">
                  </div>
                </div> -->
              </div>

              <!-- <div class="row">
                <div class="form-group col-10"></div>
                <div class="form-group col-2">
                  <button class="btn btn-primary" type="button" (click)="submitformlink()">
                    Send to Company Administrator&nbsp;&nbsp;
                  </button>
                </div>
              </div> -->
            </form>
            <div class="d-flex justify-content-between" style="padding-top: 10px">
              <button class="saveAndNext" id="" type="button" (click)="gotoEmployeeInfo()">
                <i aria-hidden="true" class="fa fa-long-arrow-left"></i>&nbsp;&nbsp;{{lang.Previous}}
              </button>

              <button class="saveAndNext" id="" type="button" (click)="submitformlink()">
                <!-- {{lang.Send_to_Company_Administrator}}&nbsp;&nbsp; -->
                Next&nbsp;&nbsp;
              </button>
              <!-- <button class="saveAndNext" id="" type="button" (click)="gotodashboard()">
                {{lang.Dashboard}}
              </button> -->
            </div>
            <!-- <div class="row">
            <div id="container1">
              <button class="btn btn-primary" id="leftButton" type="button" (click)="gotoEmployeeInfo()"><i aria-hidden="true" class="fa fa-long-arrow-left"></i>&nbsp;&nbsp;Previous</button>
          </div>
          </div> -->
            <!-- <div class="row">
              <div class="text-white text-left">
                <button class="btn btn-primary" id="backbuttonForm" type="button" (click)="gotoEmployeeInfo()"
                  style="float: left">
                  <i aria-hidden="true" class="fa fa-long-arrow-left"></i>&nbsp;&nbsp;Previous
                </button>
              </div>
              <div class="text-white text-right">
              </div>
            </div> -->
          </div>
        </div>
      </div>

      <!-- <div class="col-md-2 actionspage">

        <h6 class="actionsrequired">Welcome {{ adminName | titlecase }}</h6>
      </div> -->
    </div>
  </section>
</main>
<!-- <footer id="footer" class="footer">
  <div class="copyright">
    Version IB:3.0.0 © 2024 :
    <a class="text-reset fw-bold" href="https://www.groupbenefitz.ca/" target="-blank">
      The GroupBenefitz Platform Inc.</a>
  </div>
</footer> -->
<!-- Model For Add Group Contact -->
<div class="modal fade" data-bs-backdrop="static" id="basicModal1" tabindex="-1">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h6 class="modal-title">{{lang.Add_Group_contact}}</h6>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <form class="onbordingform" [formGroup]="adminform" (ngSubmit)="addadmin()">
          <div class="input-wrapper row">
            <div class="form-group col-6">
              <label for="Corporation" class="Corporation">{{lang.First_Name}}<span style="color: red">*</span></label>

              <input type="text" class="form-control checking-field" id="adminfirstname" placeholder={{lang.First_Name}}
                (keypress)="alphabatesOnly($event)" formControlName="adminfirstname" />

              <div *ngIf="
                  f['adminfirstname'].touched && f['adminfirstname'].invalid
                " class="help-block text-danger">
                <div *ngIf="
                    f['adminfirstname'].errors &&
                    f['adminfirstname'].errors['required']
                  ">
                  {{lang.Please_enter_first_name}}
                </div>
                <div *ngIf="
                    f['adminfirstname'].errors &&
                    f['adminfirstname'].errors['minlength']
                  ">
                  {{lang.First_name_should_be_3_characters}}
                </div>
                <div *ngIf="
                    f['adminfirstname'].errors &&
                    f['adminfirstname'].errors['maxlength']
                  ">
                  {{lang.First_name_must_not_exceed_20_characters}}
                </div>
                <div *ngIf="
                    f['adminfirstname'].errors &&
                    f['adminfirstname'].errors['pattern']
                  ">
                  {{lang.First_Name_Shouldn_t_allow_numbers_special_characters_and_blank_spaces}}

                </div>
              </div>
              <!-- <div *ngIf="submittedadmin && f['adminfirstname'].errors" class="invalid-feedback">
                <div *ngIf="f['adminfirstname'].errors['required']">First Name is required</div>
                <div *ngIf="f['adminfirstname'].errors['minlength']">
                  First Name must be at least 3 characters
                </div>
                <div *ngIf="f['adminfirstname'].errors['maxlength']">
                  First Name must not exceed 20 characters
                </div>
              </div> -->
            </div>
            <div class="form-group col-6">
              <label for="Corporation" class="Corporation">{{lang.Last_Name}}<span style="color: red">*</span></label>

              <input type="text" class="form-control checking-field" id="adminlastname"
                (keypress)="alphabatesOnly($event)" placeholder={{lang.Last_Name}} formControlName="adminlastname" />

              <div *ngIf="f['adminlastname'].touched && f['adminlastname'].invalid" class="help-block text-danger">
                <div *ngIf="
                    f['adminlastname'].errors &&
                    f['adminlastname'].errors['required']
                  ">
                  {{lang.Please_enter_Last_name}}
                </div>
                <div *ngIf="
                    f['adminlastname'].errors &&
                    f['adminlastname'].errors['minlength']
                  ">
                  {{lang.Last_name_should_be_2_characters}}
                </div>
                <div *ngIf="
                    f['adminlastname'].errors &&
                    f['adminlastname'].errors['maxlength']
                  ">
                  {{lang.Last_name_must_not_exceed_20_characters}}
                </div>
                <div *ngIf="
                    f['adminlastname'].errors &&
                    f['adminlastname'].errors['pattern']
                  ">
                  {{lang.Last_Name_Shouldn_t_allow_numbers_special_characters_and_blank_spaces}}

                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="form-group col-6">
              <label for="Corporation" class="Corporation">{{lang.Phone_Number}}<span
                  style="color: red">*</span></label>

              <input type="tel" class="form-control checking-field" id="adminphone" placeholder={{lang.Phone_Number}}
                (keypress)="numberOnly($event)" (change)="phoneFormat($event)" formControlName="adminphone" />

              <div *ngIf="f['adminphone'].touched && f['adminphone'].invalid" class="help-block text-danger">
                <div *ngIf="
                    f['adminphone'].errors && f['adminphone'].errors['required']
                  ">
                  {{lang.Please_enter_phone_number}}
                </div>
                <!-- <div *ngIf="f['adminphone'].errors && f['adminphone'].errors['pattern']">Please enter valid phone number</div> -->
                <div *ngIf="
                    f['adminphone'].errors &&
                    f['adminphone'].errors['minlength']
                  ">
                  {{lang.Phone_number_minimum_of_10_digits}}
                </div>
                <div *ngIf="
                    f['adminphone'].errors &&
                    f['adminphone'].errors['maxlength']
                  ">
                  {{lang.Phone_number_maximum_of_10_digits}}
                </div>
              </div>
            </div>
            <div class="form-group col-6">
              <label for="Corporation" class="Corporation">{{lang.Email}}<span style="color: red">*</span></label>

              <input type="text" class="form-control checking-field" id="email" placeholder={{lang.Email}}
                formControlName="adminemail" (input)="textChangeToLowerCase(f, 'adminemail')" />
              <div *ngIf="f['adminemail'].touched && f['adminemail'].invalid" class="help-block text-danger">
                <div *ngIf="
                    f['adminemail'].errors && f['adminemail'].errors['required']
                  ">
                  {{lang.Please_enter_email}}
                </div>
                <div *ngIf="
                    f['adminemail'].errors && f['adminemail'].errors['pattern']
                  ">
                  {{lang.Please_enter_valid_email}}
                </div>
              </div>
              <!-- <div class="help-block text-danger">
                <div *ngIf="emailAlreadyexist">Email Already Exist</div>
              </div> -->
            </div>
          </div>
          <div class="row">
            <div class="form-group col-6">
              <label for="Corporation" class="Corporation">{{lang.Role}}<span style="color: red">*</span></label>

              <select (change)="othersField($event)" class="form-control" id="lengthofService" formControlName="role">
                <option [value]="null" disabled>{{lang.Select}}</option>
                <option value="CORPORATE_ACCOUNTANT">{{lang.Accountant}}</option>
                <option value="CORPORATE_EXECUTIVE">{{lang.Executive}}</option>
                <option value="CORPORATE_PLAN_ADMINISTRATOR">
                  {{lang.Plan_Administrator}}
                </option>
                <option value="CORPORATE_ADMIN">
                  {{lang.System_Administrator}}
                </option>
                <option value="CORPORATE_WELLNESS_CHAMPION">
                  {{lang.Wellness_Champion}}
                </option>
                <option value="CORPORATE_OTHERS">{{lang.Others}}</option>
              </select>

              <div *ngIf="f['role'].touched && f['role'].invalid" class="help-block text-danger">
                <div *ngIf="f['role'].errors && f['role'].errors['required']">
                  {{lang.Please_select_role}}
                </div>
              </div>
            </div>
            <div class="col-12 col-md-6" *ngIf="showOtherField">
              <div class="form-group">
                <label for="Corporation" class="Corporation">{{lang.Other}}</label>
                <input type="text" class="form-control checking-field" id="roleName" placeholder="Others"
                  formControlName="roleName" />
                <div class="help-desk text-danger">
                  <div *ngIf="
                      f['roleName'].errors && f['roleName'].errors['required']
                    ">
                    {{lang.Please_select_role}}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" id="closeaddadmin" data-bs-dismiss="modal" #closemodel
          (click)="hidegrpadmindetails()">
          {{lang.Close}}
        </button>
        <button type="button" class="btn btn-primary" [disabled]="adminform.invalid" (click)="addadmin()">
          {{lang.Save}}
        </button>
      </div>
      <!-- <button class="btn btn-primary"  type="submit">Submit</button> -->
    </div>
  </div>
</div>

<!-- Model For Edit Group Contact -->
<div class="modal fade" id="basicModaledit" data-backdrop="static" tabindex="-1">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h6 class="modal-title">{{lang.Edit_group_contact}}</h6>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <form class="onbordingform" [formGroup]="adminform" (ngSubmit)="addadmin()">
          <div class="input-wrapper row">
            <div class="form-group col-6">
              <label for="Corporation" class="Corporation">{{lang.First_Name}}<span style="color: red">*</span></label>

              <input type="text" class="form-control checking-field text-capitalize" id="adminfirstname"
                placeholder={{lang.First_Name}} (keypress)="alphabatesOnly($event)" formControlName="adminfirstname"
                (click)="changeToFirstlatterUpperCase('adminfirstname')" />

              <div *ngIf="
                  f['adminfirstname'].touched && f['adminfirstname'].invalid
                " class="help-block text-danger">
                <div *ngIf="
                    f['adminfirstname'].errors &&
                    f['adminfirstname'].errors['required']
                  ">
                  {{lang.Please_enter_first_name}}
                </div>
                <div *ngIf="
                    f['adminfirstname'].errors &&
                    f['adminfirstname'].errors['minlength']
                  ">
                  {{lang.First_name_should_be_3_characters}}
                </div>
                <div *ngIf="
                    f['adminfirstname'].errors &&
                    f['adminfirstname'].errors['maxlength']
                  ">
                  {{lang.First_name_must_not_exceed_20_characters}}
                </div>
                <div *ngIf="
                    f['adminfirstname'].errors &&
                    f['adminfirstname'].errors['pattern']
                  ">
                  {{lang.First_Name_Shouldn_t_allow_numbers_special_characters_and_blank_spaces}}
                </div>
              </div>
            </div>
            <div class="form-group col-6">
              <label for="Corporation" class="Corporation">{{lang.Last_Name}}<span style="color: red">*</span></label>

              <input type="text" class="form-control checking-field text-capitalize" id="adminlastname"
                placeholder={{lang.Last_Name}} (keypress)="alphabatesOnly($event)" formControlName="adminlastname"
                [(ngModel)]="editadminlastname" />

              <div *ngIf="f['adminlastname'].touched && f['adminlastname'].invalid" class="help-block text-danger">
                <div *ngIf="
                    f['adminlastname'].errors &&
                    f['adminlastname'].errors['required']
                  ">
                  {{lang.Please_enter_Last_name}}
                </div>
                <div *ngIf="
                    f['adminlastname'].errors &&
                    f['adminlastname'].errors['minlength']
                  ">
                  {{lang.Last_name_should_be_2_characters}}
                </div>
                <div *ngIf="
                    f['adminlastname'].errors &&
                    f['adminlastname'].errors['maxlength']
                  ">
                  {{lang.Last_name_must_not_exceed_20_characters}}
                </div>
                <div *ngIf="
                    f['adminlastname'].errors &&
                    f['adminlastname'].errors['pattern']
                  ">
                  {{lang.Last_Name_Shouldn_t_allow_numbers_special_characters_and_blank_spaces}}

                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="form-group col-6">
              <label for="Corporation" class="Corporation">{{lang.Phone_Number}}<span
                  style="color: red">*</span></label>

              <input type="text" class="form-control checking-field" id="adminphone" placeholder={{lang.Phone_Number}}
                (keypress)="numberOnly($event)" (change)="phoneFormat($event)" formControlName="adminphone"
                [(ngModel)]="editadminphone" />

              <div *ngIf="f['adminphone'].touched && f['adminphone'].invalid" class="help-block text-danger">
                <div *ngIf="
                    f['adminphone'].errors && f['adminphone'].errors['required']
                  ">
                  {{lang.Please_enter_phone_number}}
                </div>
                <div *ngIf="
                    f['adminphone'].errors &&
                    f['adminphone'].errors['minlength']
                  ">
                  {{lang.Phone_number_minimum_of_10_digits}}
                </div>
                <div *ngIf="
                    f['adminphone'].errors &&
                    f['adminphone'].errors['maxlength']
                  ">
                  {{lang.Phone_number_maximum_of_10_digits}}
                </div>
              </div>
            </div>
            <div class="form-group col-6">
              <label for="Corporation" class="Corporation">{{lang.Email}}<span style="color: red">*</span></label>

              <input type="text" class="form-control checking-field" id="email" placeholder={{lang.Email}}
                formControlName="adminemail" [(ngModel)]="editadminemail"
                (input)="textChangeToLowerCase(f, 'adminemail')" />
              <div *ngIf="f['adminemail'].touched && f['adminemail'].invalid" class="help-block text-danger">
                <div *ngIf="
                    f['adminemail'].errors && f['adminemail'].errors['required']
                  ">
                  {{lang.Please_enter_email}}
                </div>
                <div *ngIf="
                    f['adminemail'].errors && f['adminemail'].errors['pattern']
                  ">
                  {{lang.Please_enter_valid_email}}
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="form-group col-6">
              <label for="Corporation" class="Corporation">{{lang.Role}}<span style="color: red">*</span></label>

              <select (change)="othersField($event)" class="form-control" id="lengthofService" formControlName="role"
                name="adminrole" [(ngModel)]="editadminrole">
                <option [value]="null" disabled>Select</option>
                <!-- <option value="CORPORATE_ADMIN">Admin</option> -->
                <option value="CORPORATE_ACCOUNTANT">{{lang.Accountant}}</option>
                <option value="CORPORATE_EXECUTIVE">{{lang.Executive}}</option>
                <option value="CORPORATE_PLAN_ADMINISTRATOR">
                  {{lang.Plan_Administrator}}
                </option>
                <option value="CORPORATE_ADMIN">
                  {{lang.System_Administrator}}
                </option>
                <option value="CORPORATE_WELLNESS_CHAMPION">
                  {{lang.Wellness_Champion}}
                </option>
                <option value="CORPORATE_OTHERS">{{lang.Others}}</option>
              </select>

              <div *ngIf="f['role'].touched && f['role'].invalid" class="help-block text-danger">
                <div *ngIf="f['role'].errors && f['role'].errors['required']">
                  {{lang.Please_select_role}}
                </div>
              </div>
            </div>
            <div class="col-12 col-md-4" *ngIf="showOtherField">
              <div class="form-group">
                <label for="Corporation" class="Corporation">{{lang.Other}}</label>
                <input type="text" class="form-control checking-field" id="roleName" formControlName="roleName" />
              </div>
            </div>
          </div>
        </form>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" (click)="hidegrpadmindetails()">
          {{lang.Close}}
        </button>
        <button type="button" class="btn btn-primary" [disabled]="adminform.invalid" (click)="editadminSubmit()">
          {{lang.Save}}
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Model For Tier Configuration for Block1 -->
<div class="modal fade" id="tierConfigure" tabindex="-1">
  <div class="modal-dialog model-lg modal-dialog-centered" style="width: 1250px">
    <div class="modal-content">
      <!-- <div class="modal-header">
           <h5 class="modal-title">Configure Tiers</h5>
           <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div> -->
      <div class="modal-body">
        <div id="carouselExampleFade" class="carousel slide carousel-fade" data-bs-interval="false">
          <div class="carousel-inner">
            <div class="carousel-item active" id="1">
              <form class="tierwalletInfo">
                <div class="row">
                  <div class="form-group col-12">
                    <!-- <h6 class="admintitle">Configure Tier GroupBenefitz Wallet<sup>TM</sup>Setup&nbsp;&nbsp;</h6> -->
                    <h6 class="configtiertable">
                      Configure Tier
                      <span *ngIf="showemptywalletConfig">GroupBenefitz Wallet<sup>TM</sup></span>
                      Setup&nbsp;&nbsp;
                    </h6>

                    <!-- <span style="color:black">Configure Tier GroupBenefitz Wallet<sup>TM</sup>Setup&nbsp;&nbsp;</span> -->
                    <h6 class="tiertable">
                      Tier Level
                      <span *ngIf="showemptywalletConfig">& Corresponding Wallet</span>
                      Setup&nbsp;&nbsp;<button class="addtierbutton" (click)="addRow()">
                        <strong>+&nbsp;Add</strong>
                      </button>

                      <!-- <h6 class="tiertable">Tier Level and Corresponding Wallet Setup&nbsp;&nbsp;<button  class="addtierbutton" (click)="addRow()" *ngIf="tiersLevelCheck"><strong>+&nbsp;Add</strong></button> -->

                      <!-- <span  class="enabledtierplans">
                        <input
                        class=""
                        type="radio"
                        name="tierlevels"
                        id="tierlevelstrue"
                        value="true"
                        (click)="tierslevel($event)"

                      />
                      <label class="form-check-label" for="tierlevelsfalse" class="walletConfigModel"
                        >&nbsp;Enable</label
                      >&nbsp;&nbsp;
                      <input
                      class=""
                      type="radio"
                      name="tierlevels"
                      id="tierlevelsfalse"
                      value="false"
                      (click)="tierslevel($event)" checked


                    />
                    <label class="form-check-label" for="tierlevelsfalse" class="walletConfigModel"
                      >&nbsp;Disable</label
                    >
                    </span> -->
                    </h6>

                    <table class="table table-striped table-bordered" style="width: 50%">
                      <thead>
                        <tr>
                          <th style="width: 5%"></th>
                          <!-- <th style="width: 10%;">S.NO</th> -->
                          <th style="width: 25%">Tier Name</th>
                          <th style="width: 20%" *ngIf="showemptywalletConfig">
                            Wallet Amount
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let dynamic of dynamicArray; let i = index">
                          <td>
                            <button class="fa fa-trash-o deletetier" (click)="deleteRowBlock1(i, dynamic)"></button>
                          </td>
                          <!-- <td >
                          <input  style="text-align: center;"  class="form-control1" name="{{dynamic.sno}}" [(ngModel)]="dynamic.sno" [ngModelOptions]="{standalone: true}"   type="text" />
                        </td> -->
                          <td>
                            <input class="form-control1" name="{{ dynamic.tierName }}" [(ngModel)]="dynamic.tierName"
                              [ngModelOptions]="{ standalone: true }" type="text" placeholder="Enter Tier Name" />
                          </td>
                          <td *ngIf="showemptywalletConfig">
                            <input class="form-control1 TierAmount" name="{{ dynamic.walletAmount }}"
                              [(ngModel)]="dynamic.walletAmount" [ngModelOptions]="{ standalone: true }" type="text"
                              placeholder="" />
                          </td>
                        </tr>
                        <tr>
                          <!-- <td>
                          <button class="fa fa-plus " (click)="addRow()">Add</button>
                        </td> -->
                        </tr>
                      </tbody>
                    </table>

                    <h6 class="tiertable">
                      Length of Service
                      <span *ngIf="showemptywalletConfig">& Corresponding Wallet</span>
                      Setup&nbsp;&nbsp;<button class="addtierbutton" (click)="addRowService()"
                        *ngIf="lengthofServiceCheck">
                        <strong>+&nbsp;Add</strong>
                      </button>

                      <span class="enabledtierplans">
                        <input class="" type="radio" name="lengthOfService" id="lengthOfServicetrue"
                          #lengthOfServicetrue value="true" (click)="lengthOfService($event)" />
                        <label class="form-check-label" for="lengthOfService"
                          class="walletConfigModel">&nbsp;Enable</label>&nbsp;&nbsp;
                        <input class="" type="radio" name="lengthOfService" id="lengthOfServicefalse"
                          #lengthOfServicefalse value="false" (click)="lengthOfService($event)" checked />
                        <label class="form-check-label" for="lengthOfService"
                          class="walletConfigModel">&nbsp;Disable</label>
                      </span>
                    </h6>
                    <table class="table table-striped table-bordered" *ngIf="lengthofServiceCheck" style="width: 80%">
                      <thead>
                        <tr>
                          <th width="5%"></th>
                          <!-- <th width="10%">S.no</th> -->
                          <th width="25%">Tier Name</th>
                          <th width="15%">From</th>
                          <th width="15%">To</th>
                          <th width="15%"></th>
                          <th width="20%" *ngIf="showemptywalletConfig">
                            Wallet Amount
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="
                            let dynamic of dynamicArrayService;
                            let i = index
                          ">
                          <td>
                            <button class="fa fa-trash-o deletetier"
                              (click)="deleteRowServiceBlock1(i, dynamic)"></button>
                          </td>
                          <!-- <td>
                            <input  style="text-align: center;"  class="form-control1" name="{{dynamic.sno}}" [(ngModel)]="dynamic.sno" [ngModelOptions]="{standalone: true}" (keypress)="numberOnly($event)"  type="text" />
                          </td> -->
                          <td>
                            <input class="form-control1" name="{{ dynamic.tierName }}" [(ngModel)]="dynamic.tierName"
                              [ngModelOptions]="{ standalone: true }" type="text" placeholder="Enter Tier Name" />
                          </td>
                          <td>
                            <input class="form-control1" name="{{ dynamic.from }}" [(ngModel)]="dynamic.from"
                              [ngModelOptions]="{ standalone: true }" (keypress)="numberOnly($event)" type="text"
                              placeholder="" />
                          </td>
                          <td>
                            <input class="form-control1" name="{{ dynamic.to }}" [(ngModel)]="dynamic.to"
                              [ngModelOptions]="{ standalone: true }" (keypress)="numberOnly($event)" type="text"
                              placeholder="" />
                          </td>
                          <td>
                            <select class="form-control1" id="lengthofService" name="{{ dynamic.period }}"
                              [(ngModel)]="dynamic.period" [ngModelOptions]="{ standalone: true }">
                              <option [value]="null" disabled>{{lang.Select}}</option>
                              <option value="years">Years</option>
                              <option value="months">Months</option>
                            </select>
                          </td>
                          <td *ngIf="showemptywalletConfig">
                            <input class="form-control1 TierAmount" name="{{ dynamic.walletAmount }}"
                              [(ngModel)]="dynamic.walletAmount" [ngModelOptions]="{ standalone: true }" type="text" />
                          </td>
                        </tr>
                        <tr>
                          <!-- <td>
                            <button class="fa fa-plus " (click)="addRow()">Add</button>
                          </td> -->
                        </tr>
                      </tbody>
                    </table>

                    <div *ngIf="showemptywalletConfig">
                      <h6 class="tiertable">
                        % of Annual income & Wallet Setup&nbsp;&nbsp;<button class="addtierbutton"
                          (click)="addRowAnnual()" *ngIf="annualincomeCheck">
                          <strong>+&nbsp;Add</strong>
                        </button>

                        <span class="enabledtierplans">
                          <input class="" type="radio" name="annualIncome" id="annualIncometrue" #annualIncometrue
                            value="true" (click)="annualIncome($event)" />
                          <label class="form-check-label" for="workinghoursno"
                            class="walletConfigModel">&nbsp;Enable</label>&nbsp;&nbsp;
                          <input class="" type="radio" name="annualIncome" id="annualIncomefalse" #annualIncomefalse
                            value="false" (click)="annualIncome($event)" checked />
                          <label class="form-check-label" for="workinghoursno"
                            class="walletConfigModel">&nbsp;Disable</label>
                        </span>
                      </h6>
                      <table class="table table-striped table-bordered" *ngIf="annualincomeCheck" style="width: 80%">
                        <thead>
                          <tr>
                            <th width="5%"></th>
                            <!-- <th width="10%">S.no</th> -->
                            <th width="25%">Tier Name</th>
                            <th width="15%">%</th>
                            <th width="15%">From</th>
                            <th width="15%">To</th>
                            <th width="20%" *ngIf="showemptywalletConfig">
                              Wallet Amount
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr *ngFor="
                              let dynamic of dynamicArrayAnnualIncome;
                              let i = index
                            ">
                            <td>
                              <button class="fa fa-trash-o deletetier"
                                (click)="deleteRowAnnualBlock1(i, dynamic)"></button>
                            </td>
                            <!-- <td>
                              <input  style="text-align: center;"  class="form-control1" name="{{dynamic.sno}}" [(ngModel)]="dynamic.sno" [ngModelOptions]="{standalone: true}" (keypress)="numberOnly($event)"  type="text" />
                            </td> -->
                            <td>
                              <input class="form-control1" name="{{ dynamic.tierName }}" [(ngModel)]="dynamic.tierName"
                                [ngModelOptions]="{ standalone: true }" type="text" placeholder="Enter Tier Name" />
                            </td>
                            <td>
                              <input class="form-control1" name="{{ dynamic.percentage }}"
                                [(ngModel)]="dynamic.percentage" [ngModelOptions]="{ standalone: true }" type="text"
                                placeholder="" />
                            </td>

                            <td>
                              <input class="form-control1" name="{{ dynamic.from }}" [(ngModel)]="dynamic.from"
                                [ngModelOptions]="{ standalone: true }" type="text" placeholder="" />
                            </td>
                            <td>
                              <input class="form-control1" name="{{ dynamic.to }}" [(ngModel)]="dynamic.to"
                                [ngModelOptions]="{ standalone: true }" type="text" placeholder="" />
                            </td>
                            <td *ngIf="showemptywalletConfig">
                              <input class="form-control1 TierAmount" name="{{ dynamic.walletAmount }}"
                                [(ngModel)]="dynamic.walletAmount" [ngModelOptions]="{ standalone: true }"
                                type="text" />
                            </td>
                            <td style="display: none">
                              <input type="hidden" class="form-control1" name="{{ dynamic.annualIncome }}"
                                [(ngModel)]="dynamic.annualIncome" [ngModelOptions]="{ standalone: true }" type="number"
                                placeholder="" />
                            </td>
                          </tr>
                          <tr>
                            <!-- <td>
                              <button class="fa fa-plus " (click)="addRow()">Add</button>
                            </td> -->
                          </tr>
                        </tbody>
                      </table>
                    </div>

                    <div style="margin-top: 10px">
                      <!-- <button type="button" class="btn btn-danger tierClose">Close</button> -->
                      <button type="button" class="btn btn-primary tierSave" (click)="submitTierInfo()">
                        Save
                      </button>

                      <button type="button" style="margin-right: 5px" class="btn btn closemodel"
                        data-bs-dismiss="modal">
                        Close</button>&nbsp;&nbsp;
                    </div>
                  </div>
                </div>
              </form>
            </div>
            <div class="carousel-item" id="2">
              <form class="tierwalletInfo12">
                <div class="row">
                  <div class="form-group col-12">
                    <h6 class="configtiertable">
                      Configure Tiers, Assign Selected Plans to
                      Tiers&nbsp;&nbsp;
                    </h6>

                    <!-- <span style="color:black">Configure Tiers, Assign Selected Plans to Tiers&nbsp;&nbsp;</span> -->
                    <!-- <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button> -->

                    <!-- <h6 class="admintitle">Configure Tiers, Assign Selected Plans to Tiers&nbsp;&nbsp;</h6> -->
                  </div>
                </div>
                <div class="row">
                  <div class="form-group col-12" style="overflow: scroll" *ngIf="showtierbasicplans">
                    <ng-container *ngFor="let item of selectionTiers | keyvalue">
                      <div class="row plansscreen">
                        <div class="form-row">
                          <h6 class="tiergroupname">{{ item.key }}</h6>
                        </div>
                        <div class="form-group package">
                          <ng-container class="tierpackagegroups" *ngFor="let planLevel of item.value">
                            <div class="tiersubgroup">
                              <div>
                                <div class="container">
                                  <div class="tierplanselection">
                                    {{ planLevel.subGrpname }}
                                  </div>

                                  <div class="flex-item tierslection">
                                    <ng-multiselect-dropdown [placeholder]="'Select'" [settings]="dropdownSettings"
                                      [data]="configureTierList" (onSelect)="
                                        onItemSelect(
                                          $event,
                                          planLevel.packageid,
                                          planLevel.parentId,
                                          planLevel.subGroupId,
                                          planLevel.packageindex,
                                          planLevel.groupindex,
                                          planLevel.subgroupindex
                                        )
                                      " (onSelectAll)="
                                        onSelectAll(
                                          $event,
                                          planLevel.packageid,
                                          planLevel.parentId,
                                          planLevel.subGroupId,
                                          planLevel.packageindex,
                                          planLevel.groupindex,
                                          planLevel.subgroupindex
                                        )
                                      " (onDeSelect)="
                                        onItemDeSelect(
                                          $event,
                                          planLevel.packageid,
                                          planLevel.parentId,
                                          planLevel.subGroupId,
                                          planLevel.packageindex,
                                          planLevel.groupindex,
                                          planLevel.subgroupindex
                                        )
                                      " (onDeSelectAll)="
                                        onDeSelectAll(
                                          $event,
                                          planLevel.packageid,
                                          planLevel.parentId,
                                          planLevel.subGroupId,
                                          planLevel.packageindex,
                                          planLevel.groupindex,
                                          planLevel.subgroupindex
                                        )
                                      ">
                                    </ng-multiselect-dropdown>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </ng-container>
                        </div>
                      </div>
                    </ng-container>
                  </div>

                  <div class="form-group col-12" style="overflow: scroll; height: 450px" *ngIf="showtieradvplans">
                    <div *ngFor="
                        let item of selectedPackagePlansInfoTier | keyvalue
                      ">
                      <!-- *ngIf="item.value.length>0" -->

                      <div class="row plansscreen">
                        <div class="form-row">
                          <!-- <h6 class="tiergroupname">{{selectedPackagePlansInfoTiername[item.key]}}</h6> -->

                          <h6 class="tiergroupname" *ngIf="item.value.length > 0">
                            {{ item.key }}
                          </h6>
                        </div>
                        <div class="form-group packageadv" *ngFor="let planLevel of item.value">
                          <div class="row">
                            <div class="col-3">
                              <div class="tierplanselection" [style.background-color]="
                                  planLevel.backgroundColor
                                    ? planLevel.backgroundColor
                                    : defaultColor
                                ">
                                {{ planLevel.subGroupName }}
                              </div>
                            </div>

                            <div class="col-4">
                              <ng-multiselect-dropdown *ngIf="showinput" [placeholder]="'Select'" [closeOnSelect]="true"
                                [settings]="dropdownSettings" [data]="
                                  selectedPackagesavailableTiers2[
                                    planLevel.packageId
                                  ][planLevel.subGroupid] || configureTierList
                                " [(ngModel)]="
                                  selectedPackagesassignedTiers2[
                                    planLevel.packageId
                                  ][planLevel.subGroupid]
                                " name="tierselection" (onSelect)="
                                  onItemSelectTiers($event, planLevel)
                                " (onDeSelect)="
                                  onItemremoveTiers($event, planLevel)
                                " (click)="checkhere()">
                              </ng-multiselect-dropdown>

                              <ng-multiselect-dropdown *ngIf="showinput1" [placeholder]="'Select'"
                                [closeOnSelect]="true" [settings]="dropdownSettings" [data]="
                                  selectedPackagesavailableTiers21[
                                    planLevel.packageId
                                  ][planLevel.subGroupid] || configureTierList
                                " [(ngModel)]="
                                  selectedPackagesassignedTiers2[
                                    planLevel.packageId
                                  ][planLevel.subGroupid]
                                " name="tierselection" (onSelect)="
                                  onItemSelectTiers($event, planLevel)
                                " (onDeSelect)="
                                  onItemremoveTiers($event, planLevel)
                                " (click)="checkhere()">
                              </ng-multiselect-dropdown>
                            </div>
                            <div class="col-5"></div>

                            <!-- <div class="flex-item tierslection">
                      </div> -->
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div style="float: right; margin-bottom: 10px; margin-top: 10px">
                  <!-- <button type="button" class="btn btn-primary tierClose">Cancel</button> -->
                  <!-- <button type="button" class="btn btn-success tierconfigcancel">Cancel</button> -->

                  <!-- <button type="button" class="btn btn-dark" (click)="showSlectedPlansTiers()">Done</button> -->
                </div>
              </form>
              <div class="modal-footer">
                <button type="button" class="btn btn closemodel" data-bs-dismiss="modal">
                  Close
                </button>
                <button type="button" class="btn btn-primary" data-bs-dismiss="modal" (click)="showSlectedPlansTiers()">
                  Save
                </button>

                <!-- </div> -->
              </div>
            </div>
          </div>
          <!-- <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleFade" data-bs-slide="prev"> -->
          <span class="carousel-control-prev-icon carousel-control-prev" aria-hidden="true"
            data-bs-target="#carouselExampleFade" data-bs-slide="prev"></span>

          <!-- </button> -->
          <!-- <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleFade" data-bs-slide="next"> -->
          <span class="carousel-control-next-icon carousel-control-next" #nextpage aria-hidden="true"
            data-bs-target="#carouselExampleFade" data-bs-slide="next"></span>

          <!-- </button> -->
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Model For Tier Configuration for Block2 -->
<div class="modal fade" id="tierConfigureBlock2" tabindex="-1">
  <div class="modal-dialog model-lg modal-dialog-centered" style="width: 1250px">
    <div class="modal-content">
      <div class="modal-body">
        <div id="carouselExampleFadeBlock2" class="carousel slide carousel-fade" data-bs-interval="false">
          <div class="carousel-inner">
            <div class="carousel-item active">
              <form class="tierwalletInfo">
                <div class="row">
                  <div class="form-group col-12">
                    <!-- <h6 class="admintitle">Configure Tier GroupBenefitz Wallet<sup>TM</sup>Setup&nbsp;&nbsp;</h6> -->
                    <h6 class="configtiertable">
                      Configure Tier<span *ngIf="showemptywalletConfig">GroupBenefitz
                        Wallet<sup>TM</sup></span>Setup&nbsp;&nbsp;
                    </h6>

                    <!-- <span style="color:black">Configure Tier GroupBenefitz Wallet<sup>TM</sup>Setup&nbsp;&nbsp;</span> -->
                    <h6 class="tiertable">
                      Tier Level
                      <span *ngIf="showemptywalletConfig">& Corresponding Wallet</span>
                      Setup&nbsp;&nbsp;<button class="addtierbutton" (click)="addRow()">
                        <strong>+&nbsp;Add</strong>
                      </button>

                      <!-- <h6 class="tiertable">Tier Level and Corresponding Wallet Setup&nbsp;&nbsp;<button  class="addtierbutton" (click)="addRow()" *ngIf="tiersLevelCheck"><strong>+&nbsp;Add</strong></button> -->

                      <!-- <span  class="enabledtierplans">
                          <input
                          class=""
                          type="radio"
                          name="tierlevels"
                          id="tierlevelstrue"
                          value="true"
                          (click)="tierslevel($event)"

                        />
                        <label class="form-check-label" for="tierlevelsfalse" class="walletConfigModel"
                          >&nbsp;Enable</label
                        >&nbsp;&nbsp;
                        <input
                        class=""
                        type="radio"
                        name="tierlevels"
                        id="tierlevelsfalse"
                        value="false"
                        (click)="tierslevel($event)" checked


                      />
                      <label class="form-check-label" for="tierlevelsfalse" class="walletConfigModel"
                        >&nbsp;Disable</label
                      >
                      </span> -->
                    </h6>

                    <table class="table table-striped table-bordered" style="width: 50%">
                      <thead>
                        <tr>
                          <th style="width: 5%"></th>
                          <!-- <th style="width: 10%;">S.NO</th> -->
                          <th style="width: 25%">Tier Name</th>
                          <th style="width: 20%" *ngIf="showemptywalletConfig">
                            Wallet Amount
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let dynamic of dynamicArray; let i = index">
                          <td>
                            <button class="fa fa-trash-o deletetier" (click)="deleteRowBlock2(i, dynamic)"></button>
                          </td>
                          <!-- <td >
                            <input  style="text-align: center;"  class="form-control1" name="{{dynamic.sno}}" [(ngModel)]="dynamic.sno" [ngModelOptions]="{standalone: true}"   type="text" />
                          </td> -->
                          <td>
                            <input class="form-control1" name="{{ dynamic.tierName }}" [(ngModel)]="dynamic.tierName"
                              [ngModelOptions]="{ standalone: true }" type="text" placeholder="Enter Tier Name" />
                          </td>
                          <td *ngIf="showemptywalletConfig">
                            <input class="form-control1 TierAmount" name="{{ dynamic.walletAmount }}"
                              [(ngModel)]="dynamic.walletAmount" [ngModelOptions]="{ standalone: true }" type="text"
                              placeholder="" />
                          </td>
                        </tr>
                        <tr>
                          <!-- <td>
                            <button class="fa fa-plus " (click)="addRow()">Add</button>
                          </td> -->
                        </tr>
                      </tbody>
                    </table>

                    <h6 class="tiertable">
                      Length of Service
                      <span *ngIf="showemptywalletConfig">& Corresponding Wallet</span>
                      Setup&nbsp;&nbsp;<button class="addtierbutton" (click)="addRowService()"
                        *ngIf="lengthofServiceCheck">
                        <strong>+&nbsp;Add</strong>
                      </button>

                      <span class="enabledtierplans">
                        <input class="" type="radio" name="lengthOfService" id="lengthOfServicetrue" value="true"
                          (click)="lengthOfService($event)" />
                        <label class="form-check-label" for="lengthOfService"
                          class="walletConfigModel">&nbsp;Enable</label>&nbsp;&nbsp;
                        <input class="" type="radio" name="lengthOfService" id="lengthOfServicefalse" value="false"
                          (click)="lengthOfService($event)" checked />
                        <label class="form-check-label" for="lengthOfService"
                          class="walletConfigModel">&nbsp;Disable</label>
                      </span>
                    </h6>
                    <table class="table table-striped table-bordered" *ngIf="lengthofServiceCheck" style="width: 80%">
                      <thead>
                        <tr>
                          <th width="5%"></th>
                          <!-- <th width="10%">S.no</th> -->
                          <th width="25%">Tier Name</th>
                          <th width="15%">From</th>
                          <th width="15%">To</th>
                          <th width="15%"></th>
                          <th width="20%" *ngIf="showemptywalletConfig">
                            Wallet Amount
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="
                            let dynamic of dynamicArrayService;
                            let i = index
                          ">
                          <td>
                            <button class="fa fa-trash-o deletetier"
                              (click)="deleteRowServiceBlock2(i, dynamic)"></button>
                          </td>
                          <!-- <td>
                              <input  style="text-align: center;"  class="form-control1" name="{{dynamic.sno}}" [(ngModel)]="dynamic.sno" [ngModelOptions]="{standalone: true}" (keypress)="numberOnly($event)"  type="text" />
                            </td> -->
                          <td>
                            <input class="form-control1" name="{{ dynamic.tierName }}" [(ngModel)]="dynamic.tierName"
                              [ngModelOptions]="{ standalone: true }" type="text" placeholder="Enter Tier Name" />
                          </td>
                          <td>
                            <input class="form-control1" name="{{ dynamic.from }}" [(ngModel)]="dynamic.from"
                              [ngModelOptions]="{ standalone: true }" (keypress)="numberOnly($event)" type="text"
                              placeholder="" />
                          </td>
                          <td>
                            <input class="form-control1" name="{{ dynamic.to }}" [(ngModel)]="dynamic.to"
                              [ngModelOptions]="{ standalone: true }" (keypress)="numberOnly($event)" type="text"
                              placeholder="" />
                          </td>
                          <td>
                            <select class="form-control1" id="lengthofService" name="{{ dynamic.period }}"
                              [(ngModel)]="dynamic.period" [ngModelOptions]="{ standalone: true }">
                              <option [value]="null" disabled>Select</option>
                              <option value="years" [selected]="isSelected">
                                Years
                              </option>
                              <option value="months">Months</option>
                            </select>
                          </td>
                          <td *ngIf="showemptywalletConfig">
                            <input class="form-control1 TierAmount" name="{{ dynamic.walletAmount }}"
                              [(ngModel)]="dynamic.walletAmount" [ngModelOptions]="{ standalone: true }" type="text" />
                          </td>
                        </tr>
                        <tr>
                          <!-- <td>
                              <button class="fa fa-plus " (click)="addRow()">Add</button>
                            </td> -->
                        </tr>
                      </tbody>
                    </table>

                    <div *ngIf="showemptywalletConfig">
                      <h6 class="tiertable">
                        % of Annual income & Wallet Setup&nbsp;&nbsp;<button class="addtierbutton"
                          (click)="addRowAnnual()" *ngIf="annualincomeCheck">
                          <strong>+&nbsp;Add</strong>
                        </button>

                        <span class="enabledtierplans">
                          <input class="" type="radio" name="annualIncome" id="annualIncometrue" value="true"
                            (click)="annualIncome($event)" />
                          <label class="form-check-label" for="workinghoursno"
                            class="walletConfigModel">&nbsp;Enable</label>&nbsp;&nbsp;
                          <input class="" type="radio" name="annualIncome" id="annualIncomefalse" value="false"
                            (click)="annualIncome($event)" checked />
                          <label class="form-check-label" for="workinghoursno"
                            class="walletConfigModel">&nbsp;Disable</label>
                        </span>
                      </h6>
                      <table class="table table-striped table-bordered" *ngIf="annualincomeCheck" style="width: 80%">
                        <thead>
                          <tr>
                            <th width="5%"></th>
                            <!-- <th width="10%">S.no</th> -->
                            <th width="25%">Tier Name</th>
                            <th width="15%">%</th>
                            <th width="15%">From</th>
                            <th width="15%">To</th>
                            <th width="20%" *ngIf="showemptywalletConfig">
                              Wallet Amount
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr *ngFor="
                              let dynamic of dynamicArrayAnnualIncome;
                              let i = index
                            ">
                            <td>
                              <button class="fa fa-trash-o deletetier"
                                (click)="deleteRowAnnualBlock2(i, dynamic)"></button>
                            </td>
                            <!-- <td>
                                <input  style="text-align: center;"  class="form-control1" name="{{dynamic.sno}}" [(ngModel)]="dynamic.sno" [ngModelOptions]="{standalone: true}" (keypress)="numberOnly($event)"  type="text" />
                              </td> -->
                            <td>
                              <input class="form-control1" name="{{ dynamic.tierName }}" [(ngModel)]="dynamic.tierName"
                                [ngModelOptions]="{ standalone: true }" type="text" placeholder="Enter Tier Name" />
                            </td>
                            <td>
                              <input class="form-control1" name="{{ dynamic.percentage }}"
                                [(ngModel)]="dynamic.percentage" [ngModelOptions]="{ standalone: true }" type="text"
                                placeholder="" />
                            </td>

                            <td>
                              <input class="form-control1" name="{{ dynamic.from }}" [(ngModel)]="dynamic.from"
                                [ngModelOptions]="{ standalone: true }" type="text" placeholder="" />
                            </td>
                            <td>
                              <input class="form-control1" name="{{ dynamic.to }}" [(ngModel)]="dynamic.to"
                                [ngModelOptions]="{ standalone: true }" type="text" placeholder="" />
                            </td>
                            <td *ngIf="showemptywalletConfig">
                              <input class="form-control1 TierAmount" name="{{ dynamic.walletAmount }}"
                                [(ngModel)]="dynamic.walletAmount" [ngModelOptions]="{ standalone: true }"
                                type="text" />
                            </td>
                            <td style="display: none">
                              <input type="hidden" class="form-control1" name="{{ dynamic.annualIncome }}"
                                [(ngModel)]="dynamic.annualIncome" [ngModelOptions]="{ standalone: true }" type="number"
                                placeholder="" />
                            </td>
                          </tr>
                          <tr>
                            <!-- <td>
                                <button class="fa fa-plus " (click)="addRow()">Add</button>
                              </td> -->
                          </tr>
                        </tbody>
                      </table>
                    </div>

                    <div style="margin-top: 10px">
                      <!-- <button type="button" class="btn btn-danger tierClose">Close</button> -->
                      <button type="button" class="btn btn-primary tierSave" (click)="submitTierInfo()">
                        Save
                      </button>

                      <button type="button" style="margin-right: 5px" class="btn btn closemodel"
                        data-bs-dismiss="modal">
                        Close</button>&nbsp;&nbsp;
                    </div>
                  </div>
                </div>
              </form>
            </div>
            <div class="carousel-item">
              <form class="tierwalletInfo12">
                <div class="row">
                  <div class="form-group col-12">
                    <h6 class="configtiertable">
                      Configure Tiers, Assign Selected Plans to
                      Tiers&nbsp;&nbsp;
                    </h6>
                  </div>
                </div>
                <div class="row">
                  <div class="form-group col-12" style="overflow: scroll" *ngIf="showtierbasicplans">
                    <ng-container *ngFor="let item of selectionTiers | keyvalue">
                      <div class="row plansscreen">
                        <div class="form-row">
                          <h6 class="tiergroupname">{{ item.key }}</h6>
                        </div>
                        <div class="form-group package">
                          <ng-container class="tierpackagegroups" *ngFor="let planLevel of item.value">
                            <div class="tiersubgroup">
                              <div>
                                <div class="container">
                                  <div class="tierplanselection">
                                    {{ planLevel.subGrpname }}
                                  </div>

                                  <div class="flex-item tierslection">
                                    <ng-multiselect-dropdown [placeholder]="'Select'" [settings]="dropdownSettings"
                                      [data]="configureTierList" (onSelect)="
                                        onItemSelect(
                                          $event,
                                          planLevel.packageid,
                                          planLevel.parentId,
                                          planLevel.subGroupId,
                                          planLevel.packageindex,
                                          planLevel.groupindex,
                                          planLevel.subgroupindex
                                        )
                                      " (onSelectAll)="
                                        onSelectAll(
                                          $event,
                                          planLevel.packageid,
                                          planLevel.parentId,
                                          planLevel.subGroupId,
                                          planLevel.packageindex,
                                          planLevel.groupindex,
                                          planLevel.subgroupindex
                                        )
                                      " (onDeSelect)="
                                        onItemDeSelect(
                                          $event,
                                          planLevel.packageid,
                                          planLevel.parentId,
                                          planLevel.subGroupId,
                                          planLevel.packageindex,
                                          planLevel.groupindex,
                                          planLevel.subgroupindex
                                        )
                                      " (onDeSelectAll)="
                                        onDeSelectAll(
                                          $event,
                                          planLevel.packageid,
                                          planLevel.parentId,
                                          planLevel.subGroupId,
                                          planLevel.packageindex,
                                          planLevel.groupindex,
                                          planLevel.subgroupindex
                                        )
                                      ">
                                    </ng-multiselect-dropdown>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </ng-container>
                        </div>
                      </div>
                    </ng-container>
                  </div>

                  <div class="form-group col-12" style="overflow: scroll; height: 450px" *ngIf="showtieradvplans">
                    <div *ngFor="
                        let item of selectedPackagePlansInfoTierBlock2
                          | keyvalue
                      ">
                      <!-- *ngIf="item.value.length>0" -->

                      <div class="row plansscreen">
                        <div class="form-row">
                          <!-- <h6 class="tiergroupname">{{selectedPackagePlansInfoTiername[item.key]}}</h6> -->

                          <h6 class="tiergroupname">{{ item.key }}</h6>
                        </div>
                        <div class="form-group packageadv" *ngFor="let planLevel of item.value">
                          <div class="row">
                            <div class="col-3">
                              <div class="tierplanselection" [style.background-color]="
                                  planLevel.backgroundColor
                                    ? planLevel.backgroundColor
                                    : defaultColor
                                ">
                                {{ planLevel.subGroupName }}
                              </div>
                            </div>

                            <div class="col-4">
                              <ng-multiselect-dropdown *ngIf="showinputBlock2" [placeholder]="'Select'"
                                [closeOnSelect]="true" name="tierselection" [settings]="dropdownSettings" [data]="
                                  selectedPackagesavailableTiers2Block2[
                                    planLevel.packageId
                                  ][planLevel.subGroupid] || configureTierList
                                " [(ngModel)]="
                                  selectedPackagesassignedTiers2Block2[
                                    planLevel.packageId
                                  ][planLevel.subGroupid]
                                " (onSelect)="
                                  onItemSelectTiersBlock2($event, planLevel)
                                " (onDeSelect)="
                                  onItemremoveTiersBlock2($event, planLevel)
                                ">
                              </ng-multiselect-dropdown>

                              <ng-multiselect-dropdown *ngIf="showinput1Block2" [placeholder]="'Select'"
                                [closeOnSelect]="true" name="tierselection" [settings]="dropdownSettings" [data]="
                                  selectedPackagesavailableTiers2Block21[
                                    planLevel.packageId
                                  ][planLevel.subGroupid] || configureTierList
                                " [(ngModel)]="
                                  selectedPackagesassignedTiers2Block21[
                                    planLevel.packageId
                                  ][planLevel.subGroupid]
                                " (onSelect)="
                                  onItemSelectTiersBlock2($event, planLevel)
                                " (onDeSelect)="
                                  onItemremoveTiersBlock2($event, planLevel)
                                ">
                              </ng-multiselect-dropdown>
                            </div>
                            <div class="col-5"></div>

                            <!-- <div class="flex-item tierslection">
                        </div> -->
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
              <div class="modal-footer">
                <button type="button" class="btn btn closemodel" data-bs-dismiss="modal">
                  Close
                </button>
                <button type="button" class="btn btn-primary" data-bs-dismiss="modal"
                  (click)="showSlectedPlansTiersBlock2()">
                  Save
                </button>

                <!-- </div> -->
              </div>
            </div>
          </div>
          <span class="carousel-control-prev-icon carousel-control-prev" aria-hidden="true"
            data-bs-target="#carouselExampleFadeBlock2" data-bs-slide="prev"></span>

          <span class="carousel-control-next-icon carousel-control-next" #nextpage aria-hidden="true"
            data-bs-target="#carouselExampleFadeBlock2" data-bs-slide="next"></span>

          <!-- </button> -->
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Model For Tier Configuration for Block3 -->
<div class="modal fade" id="tierConfigureBlock3" tabindex="-1">
  <div class="modal-dialog model-lg modal-dialog-centered" style="width: 1250px">
    <div class="modal-content">
      <div class="modal-body">
        <div id="carouselExampleFadeBlock3" class="carousel slide carousel-fade" data-bs-interval="false">
          <div class="carousel-inner">
            <div class="carousel-item active">
              <form class="tierwalletInfo">
                <div class="row">
                  <div class="form-group col-12">
                    <!-- <h6 class="admintitle">Configure Tier GroupBenefitz Wallet<sup>TM</sup>Setup&nbsp;&nbsp;</h6> -->
                    <h6 class="configtiertable">
                      Configure Tier<span *ngIf="showemptywalletConfig">GroupBenefitz
                        Wallet<sup>TM</sup></span>Setup&nbsp;&nbsp;
                    </h6>

                    <!-- <span style="color:black">Configure Tier GroupBenefitz Wallet<sup>TM</sup>Setup&nbsp;&nbsp;</span> -->
                    <h6 class="tiertable">
                      Tier Level
                      <span *ngIf="showemptywalletConfig">& Corresponding Wallet</span>
                      Setup&nbsp;&nbsp;<button class="addtierbutton" (click)="addRow()">
                        <strong>+&nbsp;Add</strong>
                      </button>
                    </h6>

                    <table class="table table-striped table-bordered" style="width: 50%">
                      <thead>
                        <tr>
                          <th style="width: 5%"></th>
                          <!-- <th style="width: 10%;">S.NO</th> -->
                          <th style="width: 25%">Tier Name</th>
                          <th style="width: 25%" *ngIf="showemptywalletConfig">
                            Wallet Amount
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let dynamic of dynamicArray; let i = index">
                          <td>
                            <button class="fa fa-trash-o deletetier" (click)="deleteRowBlock3(i, dynamic)"></button>
                          </td>
                          <!-- <td >
                              <input  style="text-align: center;"  class="form-control1" name="{{dynamic.sno}}" [(ngModel)]="dynamic.sno" [ngModelOptions]="{standalone: true}"   type="text" />
                            </td> -->
                          <td>
                            <input class="form-control1" name="{{ dynamic.tierName }}" [(ngModel)]="dynamic.tierName"
                              [ngModelOptions]="{ standalone: true }" type="text" placeholder="Enter Tier Name" />
                          </td>
                          <td *ngIf="showemptywalletConfig">
                            <input class="form-control1 TierAmount" name="{{ dynamic.walletAmount }}"
                              [(ngModel)]="dynamic.walletAmount" [ngModelOptions]="{ standalone: true }" type="text"
                              placeholder="" />
                          </td>
                        </tr>
                        <tr>
                          <!-- <td>
                              <button class="fa fa-plus " (click)="addRow()">Add</button>
                            </td> -->
                        </tr>
                      </tbody>
                    </table>

                    <h6 class="tiertable">
                      Length of Service
                      <span *ngIf="showemptywalletConfig">& Corresponding Wallet</span>
                      Setup&nbsp;&nbsp;<button class="addtierbutton" (click)="addRowService()"
                        *ngIf="lengthofServiceCheck">
                        <strong>+&nbsp;Add</strong>
                      </button>

                      <span class="enabledtierplans">
                        <input class="" type="radio" name="lengthOfService" id="lengthOfServicetrue" value="true"
                          (click)="lengthOfService($event)" />
                        <label class="form-check-label" for="lengthOfService"
                          class="walletConfigModel">&nbsp;Enable</label>&nbsp;&nbsp;
                        <input class="" type="radio" name="lengthOfService" id="lengthOfServicefalse" value="false"
                          (click)="lengthOfService($event)" checked />
                        <label class="form-check-label" for="lengthOfService"
                          class="walletConfigModel">&nbsp;Disable</label>
                      </span>
                    </h6>
                    <table class="table table-striped table-bordered" *ngIf="lengthofServiceCheck" style="width: 80%">
                      <thead>
                        <tr>
                          <th width="5%"></th>
                          <!-- <th width="10%">S.no</th> -->
                          <th width="25%">Tier Name</th>
                          <th width="15%">From</th>
                          <th width="15%">To</th>
                          <th width="15%"></th>
                          <th width="20%" *ngIf="showemptywalletConfig">
                            Wallet Amount
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="
                            let dynamic of dynamicArrayService;
                            let i = index
                          ">
                          <td>
                            <button class="fa fa-trash-o deletetier"
                              (click)="deleteRowServiceBlock3(i, dynamic)"></button>
                          </td>
                          <!-- <td>
                                <input  style="text-align: center;"  class="form-control1" name="{{dynamic.sno}}" [(ngModel)]="dynamic.sno" [ngModelOptions]="{standalone: true}" (keypress)="numberOnly($event)"  type="text" />
                              </td> -->
                          <td>
                            <input class="form-control1" name="{{ dynamic.tierName }}" [(ngModel)]="dynamic.tierName"
                              [ngModelOptions]="{ standalone: true }" type="text" placeholder="Enter Tier Name" />
                          </td>
                          <td>
                            <input class="form-control1" name="{{ dynamic.from }}" [(ngModel)]="dynamic.from"
                              [ngModelOptions]="{ standalone: true }" (keypress)="numberOnly($event)" type="text"
                              placeholder="" />
                          </td>
                          <td>
                            <input class="form-control1" name="{{ dynamic.to }}" [(ngModel)]="dynamic.to"
                              [ngModelOptions]="{ standalone: true }" (keypress)="numberOnly($event)" type="text"
                              placeholder="" />
                          </td>
                          <td>
                            <select class="form-control1" id="lengthofService" name="{{ dynamic.period }}"
                              [(ngModel)]="dynamic.period" [ngModelOptions]="{ standalone: true }">
                              <option [value]="null" disabled>Select</option>
                              <option value="years">Years</option>
                              <option value="months">Months</option>
                            </select>
                          </td>
                          <td *ngIf="showemptywalletConfig">
                            <input class="form-control1 TierAmount" name="{{ dynamic.walletAmount }}"
                              [(ngModel)]="dynamic.walletAmount" [ngModelOptions]="{ standalone: true }" type="text" />
                          </td>
                        </tr>
                        <tr>
                          <!-- <td>
                                <button class="fa fa-plus " (click)="addRow()">Add</button>
                              </td> -->
                        </tr>
                      </tbody>
                    </table>

                    <div *ngIf="showemptywalletConfig">
                      <h6 class="tiertable">
                        % of Annual income & Wallet Setup&nbsp;&nbsp;<button class="addtierbutton"
                          (click)="addRowAnnual()" *ngIf="annualincomeCheck">
                          <strong>+&nbsp;Add</strong>
                        </button>

                        <span class="enabledtierplans">
                          <input class="" type="radio" name="annualIncome" id="annualIncometrue" value="true"
                            (click)="annualIncome($event)" />
                          <label class="form-check-label" for="workinghoursno"
                            class="walletConfigModel">&nbsp;Enable</label>&nbsp;&nbsp;
                          <input class="" type="radio" name="annualIncome" id="annualIncomefalse" value="false"
                            (click)="annualIncome($event)" checked />
                          <label class="form-check-label" for="workinghoursno"
                            class="walletConfigModel">&nbsp;Disable</label>
                        </span>
                      </h6>
                      <table class="table table-striped table-bordered" *ngIf="annualincomeCheck" style="width: 80%">
                        <thead>
                          <tr>
                            <th width="5%"></th>
                            <!-- <th width="10%">S.no</th> -->
                            <th width="25%">Tier Name</th>
                            <th width="15%">%</th>
                            <th width="15%">From</th>
                            <th width="15%">To</th>
                            <th width="20%" *ngIf="showemptywalletConfig">
                              Wallet Amount
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr *ngFor="
                              let dynamic of dynamicArrayAnnualIncome;
                              let i = index
                            ">
                            <td>
                              <button class="fa fa-trash-o deletetier"
                                (click)="deleteRowAnnualBlock3(i, dynamic)"></button>
                            </td>
                            <!-- <td>
                                  <input  style="text-align: center;"  class="form-control1" name="{{dynamic.sno}}" [(ngModel)]="dynamic.sno" [ngModelOptions]="{standalone: true}" (keypress)="numberOnly($event)"  type="text" />
                                </td> -->
                            <td>
                              <input class="form-control1" name="{{ dynamic.tierName }}" [(ngModel)]="dynamic.tierName"
                                [ngModelOptions]="{ standalone: true }" type="text" placeholder="Enter Tier Name" />
                            </td>
                            <td>
                              <input class="form-control1" name="{{ dynamic.percentage }}"
                                [(ngModel)]="dynamic.percentage" [ngModelOptions]="{ standalone: true }" type="text"
                                placeholder="" />
                            </td>

                            <td>
                              <input class="form-control1" name="{{ dynamic.from }}" [(ngModel)]="dynamic.from"
                                [ngModelOptions]="{ standalone: true }" type="text" placeholder="" />
                            </td>
                            <td>
                              <input class="form-control1" name="{{ dynamic.to }}" [(ngModel)]="dynamic.to"
                                [ngModelOptions]="{ standalone: true }" type="text" placeholder="" />
                            </td>
                            <td *ngIf="showemptywalletConfig">
                              <input class="form-control1 TierAmount" name="{{ dynamic.walletAmount }}"
                                [(ngModel)]="dynamic.walletAmount" [ngModelOptions]="{ standalone: true }"
                                type="text" />
                            </td>
                            <td style="display: none">
                              <input type="hidden" class="form-control1" name="{{ dynamic.annualIncome }}"
                                [(ngModel)]="dynamic.annualIncome" [ngModelOptions]="{ standalone: true }" type="number"
                                placeholder="" />
                            </td>
                          </tr>
                          <tr>
                            <!-- <td>
                                  <button class="fa fa-plus " (click)="addRow()">Add</button>
                                </td> -->
                          </tr>
                        </tbody>
                      </table>
                    </div>

                    <div style="margin-top: 10px">
                      <!-- <button type="button" class="btn btn-danger tierClose">Close</button> -->
                      <button type="button" class="btn btn-primary tierSave" (click)="submitTierInfo()">
                        Save
                      </button>

                      <button type="button" style="margin-right: 5px" class="btn btn closemodel"
                        data-bs-dismiss="modal">
                        Close</button>&nbsp;&nbsp;
                    </div>
                  </div>
                </div>
              </form>
            </div>
            <div class="carousel-item">
              <form class="tierwalletInfo12">
                <div class="row">
                  <div class="form-group col-12">
                    <h6 class="configtiertable">
                      Configure Tiers, Assign Selected Plans to
                      Tiers&nbsp;&nbsp;
                    </h6>
                  </div>
                </div>
                <div class="row">
                  <div class="form-group col-12" style="overflow: scroll; height: 450px" *ngIf="showtieradvplans">
                    <div *ngFor="
                        let item of selectedPackagePlansInfoTierBlock3
                          | keyvalue
                      ">
                      <!-- *ngIf="item.value.length>0" -->

                      <div class="row plansscreen">
                        <div class="form-row">
                          <!-- <h6 class="tiergroupname">{{selectedPackagePlansInfoTiername[item.key]}}</h6> -->

                          <h6 class="tiergroupname" *ngIf="item.value.length > 0">
                            {{ item.key }}
                          </h6>
                        </div>
                        <div class="form-group packageadv" *ngFor="let planLevel of item.value">
                          <div class="row">
                            <div class="col-3">
                              <div class="tierplanselection" [style.background-color]="
                                  planLevel.backgroundColor
                                    ? planLevel.backgroundColor
                                    : defaultColor
                                ">
                                {{ planLevel.subGroupName }}
                              </div>
                            </div>

                            <div class="col-4">
                              <ng-multiselect-dropdown *ngIf="showinputBlock3" [placeholder]="'Select'"
                                [closeOnSelect]="true" name="tierselection" [settings]="dropdownSettings" [data]="
                                  selectedPackagesavailableTiers3Block3[
                                    planLevel.packageId
                                  ][planLevel.subGroupid] || configureTierList
                                " [(ngModel)]="
                                  selectedPackagesassignedTiers3Block3[
                                    planLevel.packageId
                                  ][planLevel.subGroupid]
                                " (onSelect)="
                                  onItemSelectTiersBlock3(
                                    $event,
                                    planLevel,
                                    planLevel
                                  )
                                " (onDeSelect)="
                                  onItemremoveTiersBlock3($event, planLevel)
                                ">
                              </ng-multiselect-dropdown>

                              <ng-multiselect-dropdown *ngIf="showinput1Block3" [placeholder]="'Select'"
                                [closeOnSelect]="true" name="tierselection" [settings]="dropdownSettings" [data]="
                                  selectedPackagesavailableTiers3Block3[
                                    planLevel.packageId
                                  ][planLevel.subGroupid] || configureTierList
                                " [(ngModel)]="
                                  selectedPackagesassignedTiers3Block3[
                                    planLevel.packageId
                                  ][planLevel.subGroupid]
                                " (onSelect)="
                                  onItemSelectTiersBlock3($event, planLevel)
                                " (onDeSelect)="
                                  onItemremoveTiersBlock3($event, planLevel)
                                ">
                              </ng-multiselect-dropdown>
                            </div>
                            <div class="col-5"></div>

                            <!-- <div class="flex-item tierslection">
                          </div> -->
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
              <div class="modal-footer">
                <button type="button" class="btn btn closemodel" data-bs-dismiss="modal">
                  Close
                </button>
                <button type="button" class="btn btn-primary" data-bs-dismiss="modal"
                  (click)="showSlectedPlansTiersBlock3()">
                  Save
                </button>

                <!-- </div> -->
              </div>
            </div>
          </div>
          <span class="carousel-control-prev-icon carousel-control-prev" aria-hidden="true"
            data-bs-target="#carouselExampleFadeBlock3" data-bs-slide="prev"></span>

          <span class="carousel-control-next-icon carousel-control-next" #nextpage aria-hidden="true"
            data-bs-target="#carouselExampleFadeBlock3" data-bs-slide="next"></span>

          <!-- </button> -->
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Model for Select Sub Domains -->

<div class="modal" id="subdomains-modal" tabindex="-1" role="dialog" aria-labelledby="modal-label"
  style="z-index: 1051 !important; display: none" style="margin-top: 100px">
  <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="rounded-top py-2 text-light text-center" style="background: #5d7c9b!important; font-size: 16px;">
        <!-- Please select one of the subdomain for your portal -->
        {{lang.Info}}
      </div>

      <div class="model-body" style="padding-left: 10px; overflow-y: scroll; max-height: 200px">
        {{lang.Select_a_subdomain_for_the_corporate_insurance_portal}}

        <div *ngFor="let item of SubDomains" class="d-flex mt-1 mb-2 gap-1">
          <input class="my-auto" [(ngModel)]="subdomainName" type="radio" [value]="item" />
          <label for="" class="text-capitalize my-auto" style="font-size: 14px">
            {{ item }}</label>
          <!-- {{ item }} -->
        </div>
      </div>

      <div class="modal-footer">
        <!-- <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button> -->
        <button type="button" class="btn btn-primary" [disabled]="subdomainName==undefined || subdomainName?.length==0" (click)="subDomainConfirm()">
          {{lang.Confirm}}
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Model for payroll Deduction -->
<div class="modal" id="payrolldeduction-modal" tabindex="-1" role="dialog" aria-labelledby="modal-label"
  style="z-index: 1051 !important; display: none" style="margin-top: 100px">
  <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header">
        Upgrade plans delta amount to be paid through
      </div>

      <div class="model-body" style="padding-left: 5px; overflow-y: scroll; max-height: 200px">
        <form class="onbordingform" [formGroup]="payrolldeductionoption">
          <div *ngFor="let item of payrolldeduction">
            <input type="radio" [value]="item.label" formControlName="payrolloption" />
            {{ item.display }}
          </div>
        </form>
      </div>

      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" (click)="payrolldeductionCancel()">
          Close
        </button>
        <button type="button" class="btn btn-primary" [disabled]="payrolldeductionoption.invalid"
          (click)="payrolldeductionConfirm()">
          Confirm
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Model for add at leat one group Contact -->
<div class="modal" data-backdrop="static" id="groupAmdinsaaa-modal" tabindex="-1" role="dialog"
  aria-labelledby="modal-label" style="z-index: 1051 !important; display: none" style="margin-top: 100px">
  <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header">Please Add at least One Group Contact</div>

      <div class="model-body">
        <form class="onbordingform" [formGroup]="adminform" (ngSubmit)="addGroupadmin()">
          <div class="input-wrapper row">
            <div class="form-group col-4">
              <label for="Corporation" class="Corporation">First Name<span style="color: red">*</span></label>

              <input type="text" class="form-control checking-field" id="adminfirstname" placeholder="First Name"
                (keypress)="alphabatesOnly($event)" formControlName="adminfirstname" />

              <div *ngIf="
                  f['adminfirstname'].touched && f['adminfirstname'].invalid
                " class="help-block text-danger">
                <div *ngIf="
                    f['adminfirstname'].errors &&
                    f['adminfirstname'].errors['required']
                  ">
                  Please enter first name
                </div>
                <div *ngIf="
                    f['adminfirstname'].errors &&
                    f['adminfirstname'].errors['minlength']
                  ">
                  First name should be 3 characters
                </div>
                <div *ngIf="
                    f['adminfirstname'].errors &&
                    f['adminfirstname'].errors['maxlength']
                  ">
                  First name must not exceed 20 characters
                </div>
                <div *ngIf="
                    f['adminfirstname'].errors &&
                    f['adminfirstname'].errors['pattern']
                  ">
                  First name Shouldn't allow numbers, special characters and
                  blank spaces
                </div>
              </div>
            </div>
            <div class="form-group col-4">
              <label for="Corporation" class="Corporation">Last Name<span style="color: red">*</span></label>

              <input type="text" class="form-control checking-field" id="adminlastname" placeholder="Last Name"
                (keypress)="alphabatesOnly($event)" formControlName="adminlastname" />

              <div *ngIf="f['adminlastname'].touched && f['adminlastname'].invalid" class="help-block text-danger">
                <div *ngIf="
                    f['adminlastname'].errors &&
                    f['adminlastname'].errors['required']
                  ">
                  Please enter Last name
                </div>
                <div *ngIf="
                    f['adminlastname'].errors &&
                    f['adminlastname'].errors['minlength']
                  ">
                  Last name should be 3 characters
                </div>
                <div *ngIf="
                    f['adminlastname'].errors &&
                    f['adminlastname'].errors['maxlength']
                  ">
                  Last name must not exceed 20 characters
                </div>
                <div *ngIf="
                    f['adminlastname'].errors &&
                    f['adminlastname'].errors['pattern']
                  ">
                  Last name Shouldn't allow numbers, special characters and
                  blank spaces
                </div>
              </div>
            </div>
            <div class="form-group col-4">
              <label for="Corporation" class="Corporation">Phone Number<span style="color: red">*</span></label>

              <input type="tel" class="form-control checking-field" id="adminphone" placeholder="Phone"
                (keypress)="numberOnly($event)" (change)="phoneFormat($event)" formControlName="adminphone" />

              <div *ngIf="f['adminphone'].touched && f['adminphone'].invalid" class="help-block text-danger">
                <div *ngIf="
                    f['adminphone'].errors && f['adminphone'].errors['required']
                  ">
                  Please enter phone number
                </div>
                <div *ngIf="
                    f['adminphone'].errors &&
                    f['adminphone'].errors['minlength']
                  ">
                  Phone number minimum of 10 digits
                </div>
                <div *ngIf="
                    f['adminphone'].errors &&
                    f['adminphone'].errors['maxlength']
                  ">
                  Phone number maximum of 10 digits
                </div>
                <!-- <div *ngIf="f['adminphone'].errors && f['adminphone'].errors['maxlength']">Phone number must not exceed 20 digits</div> -->
              </div>
            </div>
          </div>
          <div class="row">
            <div class="form-group col-4">
              <label for="Corporation" class="Corporation">Email<span style="color: red">*</span></label>

              <input type="text" class="form-control checking-field" id="email" placeholder="Email"
                formControlName="adminemail" (input)="textChangeToLowerCase(f, 'adminemail')" />
              <div *ngIf="f['adminemail'].touched && f['adminemail'].invalid" class="help-block text-danger">
                <div *ngIf="
                    f['adminemail'].errors && f['adminemail'].errors['required']
                  ">
                  Please enter email
                </div>
                <div *ngIf="
                    f['adminemail'].errors && f['adminemail'].errors['pattern']
                  ">
                  Please enter valid email
                </div>
              </div>
            </div>
            <div class="form-group col-4">
              <label for="Corporation" class="Corporation">Role<span style="color: red">*</span></label>

              <select (change)="othersField($event)" class="form-control" id="adminrole" formControlName="role"
                [(ngModel)]="selectedOption">
                <option [value]="null" disabled>Select</option>
                <!-- <option value="CORPORATE_ADMIN">Admin</option> -->
                <option value="CORPORATE_EXECUTIVE">Executive</option>
                <option value="CORPORATE_PLAN_ADMINISTRATOR">
                  Plan Administrator
                </option>
                <option value="CORPORATE_ADMIN">System Administrator</option>
                <option value="CORPORATE_WELLNESS_CHAMPION">
                  Wellness Champion
                </option>
                <option value="CORPORATE_OTHERS">Other</option>
              </select>

              <div *ngIf="f['role'].touched && f['role'].invalid" class="help-block text-danger">
                <div *ngIf="f['role'].errors && f['role'].errors['required']">
                  Please select role
                </div>
              </div>
            </div>
            <div class="col-12 col-md-4" *ngIf="showOtherField">
              <div class="form-group">
                <label for="Corporation" class="Corporation">Other<span style="color: red">*</span></label>
                <input type="text" class="form-control checking-field" id="roleName" formControlName="roleName" />
                <div *ngIf="f['roleName'].touched && f['roleName'].invalid" class="help-block text-danger">
                  <div *ngIf="
                      f['roleName'].errors && f['role'].hasError('required')
                    ">
                    Please enter other role
                  </div>
                </div>
              </div>
            </div>
            <div class="form-group col-4">
              <button [disabled]="adminform.invalid" type="submit" class="btn btn-primary">
                Save
              </button>
            </div>
          </div>
        </form>
      </div>
      <!--
    <div class="modal-footer">
      <button type="button" class="btn btn-primary" (click)="addGroupadmin()">Save</button>
    </div> -->
    </div>
  </div>
</div>
<!-- Model for add at leat one group Contact -->
<div class="modal fade" id="groupAmdins-modal" data-backdrop="static" tabindex="-1">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h6 class="modal-title">Please Add at least One Group Contact</h6>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <form class="onbordingform" [formGroup]="adminform" (ngSubmit)="addGroupadmin()">
          <div class="input-wrapper row">
            <div class="form-group col-6">
              <label for="Corporation" class="Corporation">First Name<span style="color: red">*</span></label>

              <input type="text" class="form-control checking-field" id="adminfirstname" placeholder="First Name"
                (keypress)="alphabatesOnly($event)" formControlName="adminfirstname" />

              <div *ngIf="
                  f['adminfirstname'].touched && f['adminfirstname'].invalid
                " class="help-block text-danger">
                <div *ngIf="
                    f['adminfirstname'].errors &&
                    f['adminfirstname'].errors['required']
                  ">
                  Please enter first name
                </div>
                <div *ngIf="
                    f['adminfirstname'].errors &&
                    f['adminfirstname'].errors['minlength']
                  ">
                  First name should be 3 characters
                </div>
                <div *ngIf="
                    f['adminfirstname'].errors &&
                    f['adminfirstname'].errors['maxlength']
                  ">
                  First name must not exceed 20 characters
                </div>
                <div *ngIf="
                    f['adminfirstname'].errors &&
                    f['adminfirstname'].errors['pattern']
                  ">
                  First name Shouldn't allow numbers, special characters and
                  blank spaces
                </div>
              </div>
              <!-- <div *ngIf="submittedadmin && f['adminfirstname'].errors" class="invalid-feedback">
                      <div *ngIf="f['adminfirstname'].errors['required']">First Name is required</div>
                      <div *ngIf="f['adminfirstname'].errors['minlength']">
                        First Name must be at least 3 characters
                      </div>
                      <div *ngIf="f['adminfirstname'].errors['maxlength']">
                        First Name must not exceed 20 characters
                      </div>
                    </div> -->
            </div>
            <div class="form-group col-6">
              <label for="Corporation" class="Corporation">Last Name<span style="color: red">*</span></label>

              <input type="text" class="form-control checking-field" id="adminlastname"
                (keypress)="alphabatesOnly($event)" placeholder="Last Name" formControlName="adminlastname" />

              <div *ngIf="f['adminlastname'].touched && f['adminlastname'].invalid" class="help-block text-danger">
                <div *ngIf="
                    f['adminlastname'].errors &&
                    f['adminlastname'].errors['required']
                  ">
                  Please enter Last name
                </div>
                <div *ngIf="
                    f['adminlastname'].errors &&
                    f['adminlastname'].errors['minlength']
                  ">
                  Last name should be 3 characters
                </div>
                <div *ngIf="
                    f['adminlastname'].errors &&
                    f['adminlastname'].errors['maxlength']
                  ">
                  Last name must not exceed 20 characters
                </div>
                <div *ngIf="
                    f['adminlastname'].errors &&
                    f['adminlastname'].errors['pattern']
                  ">
                  Last name Shouldn't allow numbers, special characters and
                  blank spaces
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="form-group col-6">
              <label for="Corporation" class="Corporation">Phone Number<span style="color: red">*</span></label>

              <input type="tel" class="form-control checking-field" id="adminphone" placeholder="Phone"
                (keypress)="numberOnly($event)" (change)="phoneFormat($event)" formControlName="adminphone" />

              <div *ngIf="f['adminphone'].touched && f['adminphone'].invalid" class="help-block text-danger">
                <div *ngIf="
                    f['adminphone'].errors && f['adminphone'].errors['required']
                  ">
                  Please enter phone number
                </div>
                <div *ngIf="
                    f['adminphone'].errors &&
                    f['adminphone'].errors['minlength']
                  ">
                  Phone number minimum of 10 digits
                </div>
                <div *ngIf="
                    f['adminphone'].errors &&
                    f['adminphone'].errors['maxlength']
                  ">
                  Phone number maximum of 10 digits
                </div>
                <!-- <div *ngIf="f['adminphone'].errors && f['adminphone'].errors['maxlength']">Phone number must not exceed 20 digits</div> -->
              </div>
            </div>
            <div class="form-group col-6">
              <label for="Corporation" class="Corporation">Email<span style="color: red">*</span></label>

              <input type="text" class="form-control checking-field" id="email" placeholder="Email"
                formControlName="adminemail" (input)="textChangeToLowerCase(f, 'adminemail')" />
              <div *ngIf="f['adminemail'].touched && f['adminemail'].invalid" class="help-block text-danger">
                <div *ngIf="
                    f['adminemail'].errors && f['adminemail'].errors['required']
                  ">
                  Please enter email
                </div>
                <div *ngIf="
                    f['adminemail'].errors && f['adminemail'].errors['pattern']
                  ">
                  Please enter valid email
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="form-group col-6">
              <label for="Corporation" class="Corporation">Role<span style="color: red">*</span></label>

              <select (change)="othersField($event)" class="form-control" id="lengthofService" formControlName="role"
                [(ngModel)]="selectedOption">
                <option [value]="null" disabled>Select</option>
                <!-- <option value="CORPORATE_ADMIN">Admin</option> -->
                <option value="CORPORATE_ACCOUNTANT">Accountant</option>
                <option value="CORPORATE_EXECUTIVE">Executive</option>
                <option value="CORPORATE_PLAN_ADMINISTRATOR">
                  Plan Administrator
                </option>
                <option value="CORPORATE_ADMIN">System Administrator</option>

                <option value="CORPORATE_WELLNESS_CHAMPION">
                  Wellness Champion
                </option>
                <option value="CORPORATE_OTHERS">Others</option>
                <!-- <option value="CORPORATE_OTHERS">Other</option> -->
              </select>

              <div *ngIf="f['role'].touched && f['role'].invalid" class="help-block text-danger">
                <div *ngIf="f['role'].errors && f['role'].errors['required']">
                  Please select role
                </div>
              </div>
            </div>
            <div class="col-12 col-md-6" *ngIf="showOtherField">
              <div class="form-group">
                <label for="Corporation" class="Corporation">Other<span style="color: red">*</span></label>
                <input type="text" class="form-control checking-field" id="roleName" formControlName="roleName" />
                <div *ngIf="f['roleName'].touched && f['roleName'].invalid" class="help-block text-danger">
                  <div *ngIf="
                      f['roleName'].errors && f['role'].hasError('required')
                    ">
                    Please enter other role
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" id="closeaddadmin" data-bs-dismiss="modal" #closemodel>
          Close
        </button>
        <button type="button" class="btn btn-primary" [disabled]="adminform.invalid" (click)="addGroupadmin()">
          Save
        </button>
      </div>
      <!-- <button class="btn btn-primary"  type="submit">Submit</button> -->
    </div>
  </div>
</div>

<div class="modal fade" id="bulkupload-modal" data-backdrop="static" tabindex="-1">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h6 class="modal-title">Are you sure want to add?</h6>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">

      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" tooltip="List will be replaced overwriting existing."
          id="closeaddadmin" data-bs-dismiss="modal" #closemodel>
          {{lang.No}}
        </button>
        <button type="button" class="btn btn-primary" tooltip="List will be appended with new only."
          data-bs-dismiss="modal" #closemodel (click)="addGroupadmin()">
          {{lang.Yes}}
        </button>
      </div>
      <!-- <button class="btn btn-primary"  type="submit">Submit</button> -->
    </div>
  </div>
</div>

<div class="modal fade" id="showBulkEmployeelist" data-backdrop="static" tabindex="-1">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h6 class="modal-title">{{lang.Employee_List}}</h6>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <table datatable [dtOptions]="dtOptions" id="bulkdattable" [dtTrigger]="dtTrigger">
          <!-- <th>S.no</th> -->
          <th>{{lang.First_Name}}</th>
          <th>{{lang.Last_Name}}</th>
          <th>{{lang.Email}}</th>
          <th>{{lang.Actions}}</th>
          <tr *ngFor="let item of filteredEmployeeList;let i=index">
            <ng-container *ngIf="item.bulkPlanLevelId==selectedSubGrpId;else nodata;">
              <!-- <td>{{i+1}}</td> -->
              <td>{{item.firstName}}</td>
              <td>{{item.lastName}}</td>
              <!-- <td [title]="
              item.email.length > 24
              ? item.email
              : ''
              ">{{
                item.email.length > 24
                ? item.email.slice(0, 6) +
                "..." +
                item.email.slice(-6)
                : item.email
                }}</td> -->
              <td *ngIf="item.email">{{
                item.email.length > 24
                ? item.email.slice(0, 6) +
                "..." +
                item.email.slice(-6)
                : item.email
                }}</td>
              <td style="display:flex">
                <!-- <a class="btn btn-default editpencil" title="Edit" data-toggle="tooltip"
                  (click)="editemployeeexcel(item,i,selectedSubGrpId)"><i class="bi bi-pencil-fill"></i></a>&nbsp;&nbsp; -->
                <a class="btn btn-default deleteicon" title="Delete" data-toggle="tooltip"
                  (click)="deleteemployeeexcel(item,i,selectedSubGrpId)"><i class="bi bi-trash-fill"></i></a>
              </td>

            </ng-container>
            <ng-template #nodata>
              <p>No Data Available</p>
            </ng-template>

          </tr>
        </table>

      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" tooltip="List will be replaced overwriting existing."
          id="closeaddadmin" data-bs-dismiss="modal" #closemodel>
          {{lang.Close}}
        </button>

      </div>
      <!-- <button class="btn btn-primary"  type="submit">Submit</button> -->
    </div>
  </div>
</div>

<div class="modal fade" id="showBulkEmployeelistwaddell" data-backdrop="static" tabindex="-1">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h6 class="modal-title">{{lang.Employee_List}}</h6>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <table datatable [dtOptions]="dtOptions" id="bulkdattable" [dtTrigger]="dtTrigger">
          <!-- <th>S.no</th> -->
          <th>{{lang.First_Name}}</th>
          <th>{{lang.Last_Name}}</th>
          <th>{{lang.Email}}</th>
          <th>{{lang.Actions}}</th>
          <tr *ngFor="let item of employeeList;let i=index">
            <ng-container *ngIf="item.bulkPlanLevelId==34">
              <!-- <td>{{i+1}}</td> -->
              <td>{{item.firstName}}</td>
              <td>{{item.lastName}}</td>
              <td *ngIf="item.email">{{
                item.email.length > 24
                ? item.email.slice(0, 6) +
                "..." +
                item.email.slice(-6)
                : item.email
                }}</td>
              <td style="display:flex">
                <!-- <a class="btn btn-default editpencil" title="Edit" data-toggle="tooltip"
                  (click)="editemployeeexcelwaddell(item,i)"><i class="bi bi-pencil-fill"></i></a>&nbsp;&nbsp; -->
                <a class="btn btn-default deleteicon" title="Delete" data-toggle="tooltip"
                  (click)="deleteemployeeexcelwaddell(item,i)"><i class="bi bi-trash-fill"></i></a>
              </td>
            </ng-container>

          </tr>
        </table>

      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" tooltip="List will be replaced overwriting existing."
          id="closeaddadmin" data-bs-dismiss="modal" #closemodel>
          {{lang.Close}}
        </button>

      </div>
      <!-- <button class="btn btn-primary"  type="submit">Submit</button> -->
    </div>
  </div>
</div>
<div class="modal fade" id="editEmployee-modal" tabindex="-1">
  <div class="modal-dialog model-md">
    <div class="modal-content">
      <div class="modal-header">
        <h6 class="modal-title">{{lang.Edit_Employee}}</h6>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <form class="" [formGroup]="addEmployeeformList">


          <div class="row">


            <div class="col-md-4 col-6">
              <div class="form-group">
                <label for="Corporation" class="Corporation">{{lang.First_Name}}<span
                    style="color: red">*</span></label>

                <input type="text" class="form-control checking-field" id="firstname"
                  (keypress)="alphabatesOnly($event)" placeholder={{lang.First_Name}}
                  formControlName="employeeFirstName" [(ngModel)]="editEmployeefirstname" />
                <div *ngIf="emp['employeeFirstName'].touched && emp['employeeFirstName'].invalid"
                  class="help-block text-danger">
                  <div *ngIf="emp['employeeFirstName'].errors && emp['employeeFirstName'].errors['required']">
                    {{lang.Please_enter_first_name}}
                  </div>
                  <div *ngIf="emp['employeeFirstName'].errors && emp['employeeFirstName'].errors['minlength']">
                    {{lang.First_name_should_be_3_characters}}</div>
                  <div *ngIf="emp['employeeFirstName'].errors && emp['employeeFirstName'].errors['maxlength']">
                    {{lang.First_name_must_not_exceed_20_characters}}</div>
                  <div *ngIf="emp['employeeFirstName'].errors && emp['employeeFirstName'].errors['pattern']">
                    {{lang.First_Name_Shouldn_t_allow_numbers_special_characters_and_blank_spaces}}
                  </div>
                </div>
              </div>
            </div>

            <div class="col-md-4 col-6">
              <div class="form-group">
                <label for="Corporation" class="Corporation">{{lang.Last_Name}}<span style="color: red">*</span></label>

                <input type="text" class="form-control checking-field" id="lastname" placeholder={{lang.Last_Name}}
                  (keypress)="alphabatesOnly($event)" formControlName="employeeLastName"
                  [(ngModel)]="editEmployeelastname" />
                <div *ngIf="emp['employeeLastName'].touched && emp['employeeLastName'].invalid"
                  class="help-block text-danger">
                  <div *ngIf="emp['employeeLastName'].errors && emp['employeeLastName'].errors['required']">
                    {{lang.Please_enter_Last_name}} </div>
                  <div *ngIf="emp['employeeLastName'].errors && emp['employeeLastName'].errors['minlength']">
                    {{lang.Last_name_should_be_2_characters}}</div>
                  <div *ngIf="emp['employeeLastName'].errors && emp['employeeLastName'].errors['maxlength']">
                    {{lang.Last_name_must_not_exceed_20_characters}}
                  </div>
                  <div *ngIf="emp['employeeLastName'].errors && emp['employeeLastName'].errors['pattern']">
                    {{lang.Last_Name_Shouldn_t_allow_numbers_special_characters_and_blank_spaces}}
                  </div>

                </div>
              </div>
            </div>
            <div class="col-md-4 col-6">
              <div class="form-group">
                <label for="Corporation" class="Corporation">{{lang.Email}}<span style="color: red">*</span></label>

                <input type="text" class="form-control checking-field" id="email" placeholder={{lang.Email}}
                  formControlName="employeeEmail" [(ngModel)]="editEmployeeemail"
                  (input)="textChangeToLowerCase1('employeeEmail')" />



                <div *ngIf="emp['employeeEmail'].touched && emp['employeeEmail'].invalid"
                  class="help-block text-danger">

                  <div class="text-red" *ngIf="emp['employeeEmail'].errors && emp['employeeEmail'].errors['required']">
                    {{lang.Please_enter_email}}
                  </div>
                  <div *ngIf="emp['employeeEmail'].errors && emp['employeeEmail'].errors['pattern']">

                    {{lang.Please_enter_valid_email}}</div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">

            <div class="col-md-4 col-6" *ngIf="editEmployeephone">
              <div class="form-group">
                <label for="Corporation" class="Corporation">{{lang.Phone_Number}}<span
                    style="color: red">*</span></label>

                <input type="text" class="form-control checking-field" id="phoneNumber" (keypress)="numberOnly($event)"
                  (change)="phoneFormat1($event)" placeholder={{lang.Phone_Number}} formControlName="employeePhoneno"
                  [(ngModel)]="editEmployeephone" />

                <div *ngIf="emp['employeePhoneno'].touched && emp['employeePhoneno'].invalid"
                  class="help-block text-danger">
                  <div *ngIf="
                                  emp['employeePhoneno'].errors && emp['employeePhoneno'].errors['required']
                                ">
                    {{lang.Please_enter_phone_number}}
                  </div>
                  <div *ngIf="
                                  emp['employeePhoneno'].errors &&
                                  emp['employeePhoneno'].errors['minlength']
                                ">
                    {{lang.Phone_number_minimum_of_10_digits}}
                  </div>
                  <div *ngIf="
                                  emp['employeePhoneno'].errors &&
                                  emp['employeePhoneno'].errors['maxlength']
                                ">
                    {{lang.Phone_number_maximum_of_10_digits}}
                  </div>
                </div>
              </div>
            </div>

            <div class="col-md-4 col-6" *ngIf="editEmployeeStreeAddress">
              <div class="form-group">
                <label for="Corporation" class="Corporation">{{lang.Street_Address}}<span
                    style="color: red">*</span></label>

                <input type="text" class="form-control checking-field" id="lastname" placeholder={{lang.Street_Address}}
                  formControlName="employeeStreetAddress" [(ngModel)]="editEmployeeStreeAddress" />
                <div *ngIf="emp['employeeStreetAddress'].touched && emp['employeeStreetAddress'].invalid"
                  class="help-block text-danger">
                  <div *ngIf="emp['employeeStreetAddress'].errors && emp['employeeStreetAddress'].errors['required']">
                    {{lang.Please_enter_street_address}}</div>
                </div>
              </div>
            </div>
            <div class="col-md-4 col-6" *ngIf="editEmployeeCity">
              <div class="form-group">
                <label for="Corporation" class="Corporation">{{lang.City}}<span style="color: red">*</span></label>

                <input type="text" class="form-control checking-field" id="city" (keypress)="alphabatesOnly($event)"
                  placeholder={{lang.City}} formControlName="employeeCity" [(ngModel)]="editEmployeeCity" />
                <div *ngIf="emp['employeeCity'].touched && emp['employeeCity'].invalid" class="help-block text-danger">
                  <div *ngIf="emp['employeeCity'].errors && emp['employeeCity'].errors['required']">
                    {{lang.Please_enter_city}}</div>


                </div>
              </div>
            </div>

            <div class="col-md-4 col-6" *ngIf="editemployeeCountry">
              <div class="form-group">
                <label for="Corporation" class="Corporation">{{lang.Country}}<span style="color: red">*</span></label>

                <select class="form-control" id="country" placeholder="country" formControlName="employeeCountry"
                  (change)="getprovincelist($event)" [(ngModel)]="editemployeeCountry">
                  <option [value]="null" disabled>{{lang.Select}}</option>
                  <option *ngFor="let country of countryList" [value]="country.name">
                    {{country.name}}
                  </option>
                </select>
                <div *ngIf="emp['employeeCountry'].touched && emp['employeeCountry'].invalid"
                  class="help-block text-danger">
                  <div *ngIf="emp['employeeCountry'].errors && emp['employeeCountry'].errors['required']">
                    {{lang.Please_select_country}}
                  </div>


                </div>
              </div>
            </div>

            <div class="col-md-4 col-6" *ngIf="editEmployeeProvicne">
              <div class="form-group">
                <label for="Corporation" class="Corporation">{{lang.Province}}<span style="color: red">*</span></label>

                <select class="form-control" id="Province" placeholder="Province" formControlName="employeeProvince"
                  (change)="provincelistwaddell($event)" [(ngModel)]="editEmployeeProvicne">
                  <option value="" [disabled]="true">{{lang.Select}}</option>
                  <option *ngFor="let name of configprovincereslist" [value]="name.shortName">
                    {{ name.shortName }}
                  </option>
                </select>
                <div *ngIf="emp['employeeProvince'].touched && emp['employeeProvince'].invalid"
                  class="help-block text-danger">
                  <div *ngIf="emp['employeeProvince'].errors && emp['employeeProvince'].errors['required']">
                    {{lang.Please_select_Province}}
                  </div>
                </div>
              </div>
            </div>

            <div class="col-md-4 col-6" *ngIf="editEmployeeposatlCode">
              <div class="form-group">
                <label for="Corporation" class="Corporation">{{lang.Postal_Code}}<span
                    style="color: red">*</span></label>


                <input type="text" class="form-control checking-field" id="postalcode" placeholder={{lang.Postal_Code}}
                  onkeyup="this.value = this.value.toUpperCase();" formControlName="employeePostalCode"
                  [(ngModel)]="editEmployeeposatlCode"
                  (input)="changeTextToUppercasewaddell('employeePostalCode', $event)" />
                <div *ngIf="emp['employeePostalCode'].touched && emp['employeePostalCode'].invalid"
                  class="help-block text-danger">
                  <div *ngIf="emp['employeePostalCode'].errors && emp['employeePostalCode'].errors['required']">
                    {{lang.Please_enter_postal_code}}
                  </div>
                  <div *ngIf="
                                  invalidpostalcodeprivincewaddell ||
                                  (emp['employeePostalCode'].touched &&
                                  emp['employeePostalCode'].hasError('invalidPostalCodewaddell'))
                                ">
                    {{lang.Please_enter_valid_postal_code}}
                  </div>

                </div>
              </div>
            </div>
          </div>
          <div class="row" [hidden]="true">
            <div class="col-md-4 col-6">
              <div class="form-group">
                <label for="Corporation" class="Corporation">{{lang.Employee_ID}}</label>

                <input type="text" class="form-control checking-field" id="Employee ID" placeholder={{lang.Employee_ID}}
                  formControlName="employeeId" [(ngModel)]="editEmployeeId"
                  (keypress)="alphaNumaricssWithHipen($event)" />
                <div *ngIf="emp['employeeId'].touched && emp['employeeId'].invalid" class="help-block text-danger">
                  <div *ngIf="emp['employeeId'].errors && emp['employeeId'].errors['required']">
                    {{lang.Please_enter_Employee_ID}}

                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-4 col-6">
              <div class="form-group">
                <label for="Corporation" class="Corporation">{{lang.Date_of_Hire}}</label>

                <input type="text" placeholder={{lang.Date_of_Hire}} class="form-control"
                  formControlName="employeeDateofhire" [(ngModel)]="editEmployeeDateofhire" bsDatepicker
                  [bsConfig]="{showWeekNumbers: false}" value="{{ editEmployeeDateofhire | date: 'MM-dd-YYYY'}}">

                <div *ngIf="emp['employeeDateofhire'].touched && emp['employeeDateofhire'].invalid"
                  class="help-block text-danger">
                  <div *ngIf="emp['employeeDateofhire'].errors && emp['employeeDateofhire'].errors['required']">
                    {{lang.Please_select_date_of_hire}}</div>
                  <div *ngIf="emp['employeeDateofhire'].errors && emp['employeeDateofhire'].errors['pattern']">
                    {{lang.Date_of_hire_Shouldn_t_allow_numbers_special_characters_and_blank_spaces}}</div>

                </div>
              </div>

            </div>

            <div class="col-md-4 col-6">
              <div class="form-group">
                <label for="Corporation" class="Corporation">{{lang.Country}}<span style="color: red">*</span></label>
                <select class="form-control" id="country" placeholder="country" formControlName="employeeCountry"
                  (change)="getprovincelist($event)" [(ngModel)]="editemployeeCountry">
                  <option [value]="null" disabled>{{lang.Select}}</option>
                  <option *ngFor="let country of countryList" [value]="country.name">
                    {{country.name}}
                  </option>
                </select>
                <div *ngIf="emp['employeeCountry'].touched && emp['employeeCountry'].invalid"
                  class="help-block text-danger">
                  <div *ngIf="emp['employeeCountry'].errors && emp['employeeCountry'].errors['required']">

                    {{lang.Please_select_country}}</div>

                </div>
              </div>
            </div>
          </div>
          <div class="row" [hidden]="true">
            <div class="col-md-4 col-6">
              <div class="form-group">
                <label for="Corporation" class="Corporation">{{lang.Province_of_Employment}}<span
                    style="color: red">*</span></label>
                <input class="form-control" id="Province" placeholder={{lang.Province_of_Employment}}
                  formControlName="employeeResidence" (change)="provincelist($event)"
                  [(ngModel)]="editEmployeeResidenetIn">

                <!-- <option *ngFor="let name of employeeWorkingProviance" [value]="name.shortName">
                    {{ name.shortName }}
                  </option> -->

                <div *ngIf="emp['employeeResidence'].touched && emp['employeeResidence'].invalid"
                  class="help-block text-danger">
                  <div *ngIf="emp['employeeResidence'].errors && emp['employeeResidence'].errors['required']">
                    {{lang.Please_select_Province}}</div>

                </div>
              </div>
            </div>
            <div class="col-md-4 col-6">
              <div class="form-group">
                <label for="Corporation" class="Corporation">{{lang.Job_Title}}</label>

                <input type="text" class="form-control checking-field" id="Occupation" placeholder={{lang.Job_Title}}
                  (keypress)="alphabatesOnly($event)" (input)="titleCase($event.target.value)"
                  formControlName="employeeOccupation" [(ngModel)]="editEmployeeOccupation" />
                <div *ngIf="emp['employeeOccupation'].touched && emp['employeeOccupation'].invalid"
                  class="help-block text-danger">
                  <div *ngIf="emp['employeeOccupation'].errors && emp['employeeOccupation'].errors['required']">
                    {{lang.Please_enter_occupation}}</div>
                  <div *ngIf="emp['employeeOccupation'].errors && emp['employeeOccupation'].errors['pattern']">
                    {{lang.Job_title_not_allow_numbers_special_characters_and_blank_spaces}}</div>

                </div>
              </div>
            </div>

            <div class="col-md-4 col-6">
              <div class="form-group">
                <label for="Corporation" class="Corporation">{{lang.Date_of_Birth}}</label>

                <input type="text" placeholder="Date of Birth" class="form-control" [minDate]="minDate"
                  [bsConfig]="{showWeekNumbers: false}" [maxDate]="maxDate" formControlName="employeeDateofbirth"
                  [(ngModel)]="editEmployeeDateofbirth" bsDatepicker>

                <div *ngIf="emp['employeeDateofbirth'].touched && emp['employeeDateofbirth'].invalid"
                  class="help-block text-danger">
                  <div *ngIf="emp['employeeDateofbirth'].errors && emp['employeeDateofbirth'].errors['required']">
                    {{lang.Date_of_Birth}}</div>
                  <div *ngIf="emp['employeeDateofbirth'].errors && emp['employeeDateofbirth'].errors['pattern']">
                    {{lang.Date_of_birth_Shouldn_t_allow_numbers_special_characters_and_blank_spaces}}</div>

                </div>
              </div>

            </div>
          </div>

          <div class="row" [hidden]="true">

            <div class="col-md-4 col-6">
              <div class="form-group">
                <label for="Corporation" class="Corporation">{{lang.Gender}}</label>
                <select class="form-control" id="gender" placeholder="Select" formControlName="employeeGender"
                  [(ngModel)]="editEmployeesex">
                  <option [value]="null">{{lang.Select}}</option>
                  <option value="Male"> {{lang.Male}} </option>
                  <option value="Female"> {{lang.Female }}</option>
                  <option value="Non-Binary">{{lang.Non_Binary }}</option>
                  <option value="Undisclosed"> {{lang.Undisclosed}} </option>

                </select>
                <div *ngIf="emp['employeeGender'].touched && emp['employeeGender'].invalid"
                  class="help-block text-danger">
                  <div *ngIf="emp['employeeGender'].errors && emp['employeeGender'].errors['required']">
                    {{lang.Please_select_gender}}</div>

                </div>
              </div>
            </div>
            <div class="col-md-4 col-6">
              <div class="form-group">
                <label for="Corporation" class="Corporation">{{lang.Marital_Status}}</label>
                <select class="form-control" id="familyStatus" placeholder="Select"
                  formControlName="employeefamilyStatus" [(ngModel)]="editEmployeefamilyStatus">

                  <option [value]="null">{{lang.Select}}</option>
                  <option value="Single"> {{lang.Single}} </option>
                  <option value="Couple"> {{lang.Couple}} </option>
                  <option value="Family">{{lang.Family}}</option>

                </select>
                <div *ngIf="emp['employeefamilyStatus'].touched && emp['employeefamilyStatus'].invalid"
                  class="help-block text-danger">
                  <div *ngIf="emp['employeefamilyStatus'].errors && emp['employeefamilyStatus'].errors['required']">
                    {{lang.Please_select_Marital_Status}}</div>
                </div>
              </div>
            </div>

            <div class="col-md-4 col-6" *ngIf="walletConfigCheck">
              <div class="form-group">
                <label for="Corporation" class="Corporation">{{lang.Annual_Income}}<span *ngIf="walletConfigforemployee"
                    style="color: red">*</span></label>

                <input type="text" class="form-control checking-field" id="walletlimit" (keypress)="numberOnly($event)"
                  placeholder="Annual Income" formControlName="empployeeAnnualIncome"
                  [(ngModel)]="editEmployeeeAnnualIncome" />
                <div *ngIf="emp['empployeeAnnualIncome'].touched && emp['empployeeAnnualIncome'].invalid"
                  class="help-block text-danger">
                  <div *ngIf="emp['empployeeAnnualIncome'].errors && emp['empployeeAnnualIncome'].errors['required']">
                    {{lang.Please_enter_annual_income}}</div>
                  <div *ngIf="emp['empployeeAnnualIncome'].errors && emp['empployeeAnnualIncome'].errors['pattern']">
                    {{lang.Annual_Income_Shouldn_t_allow_numbers_special_characters_and_blank_spaces}}</div>

                </div>
              </div>
            </div>
          </div>
          <div class="row" [hidden]="true">
            <div class="col-md-12" *ngIf="tierConfigCheck">
              <div class="form-group">
                <label for="Corporation" class="Corporation">Tier<span *ngIf="tierConfigforemployee"
                    style="color: red">*</span></label>


                <select class="form-control" id="employeeTier" placeholder="Select" formControlName="employeeTier">
                  <option [value]="null">{{lang.Select}}</option>
                  <option *ngFor="let name of configureTierList" value={{name.id}} [(ngModel)]="editEmployeeetier">
                    {{ name.name}}
                  </option>
                </select>
                <div *ngIf="emp['employeeTier'].touched && emp['employeeTier'].invalid" class="help-block text-danger">
                  <div *ngIf="emp['employeeTier'].errors && emp['employeeTier'].errors['required']">
                    Please select tier
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- <div class="row" style="margin:0px">
            <div class="col-md-12">
              <button class="btn btn-primary" type="button" (click)="editemployeetolist()"><i class="fa fa-save" ></i>&nbsp;Save&nbsp;&nbsp;</button>

              <button class="btn btn-primary" id="employeeCancelButton" type="button" (click)="editemployeeform()"> Cancel &nbsp;&nbsp;</button>&nbsp;&nbsp;
            </div>
          </div> -->


        </form>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" id="closeaddadmin" data-bs-dismiss="modal" #closemodel>
          {{lang.Close}}
        </button>
        <button type="submit" class="btn btn-primary" (click)="editemployeetolist()">
          &nbsp;{{lang.Save}}&nbsp;&nbsp;
        </button>
      </div>
      <!-- <button class="btn btn-primary"  type="submit">Submit</button> -->
    </div>
  </div>
</div>
<div class="modal fade" id="editEmployeewaddel-modal" tabindex="-1">
  <div class="modal-dialog model-md">
    <div class="modal-content">
      <div class="modal-header">
        <h6 class="modal-title">{{lang.Edit_Employee}}</h6>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <form class="" [formGroup]="addEmployeeformListwaddell">


          <div class="row">


            <div class="col-md-4 col-6">
              <div class="form-group">
                <label for="Corporation" class="Corporation">{{lang.First_Name}}<span
                    style="color: red">*</span></label>

                <input type="text" class="form-control checking-field" id="firstname"
                  (keypress)="alphabatesOnly($event)" placeholder={{lang.First_Name}}
                  formControlName="employeeFirstName" [(ngModel)]="editEmployeefirstname" />
                <div *ngIf="empwaddell['employeeFirstName'].touched && empwaddell['employeeFirstName'].invalid"
                  class="help-block text-danger">
                  <div
                    *ngIf="empwaddell['employeeFirstName'].errors && empwaddell['employeeFirstName'].errors['required']">
                    {{lang.Please_enter_first_name}}</div>
                  <div
                    *ngIf="empwaddell['employeeFirstName'].errors && empwaddell['employeeFirstName'].errors['minlength']">
                    {{lang.First_name_should_be_3_characters}}</div>
                  <div
                    *ngIf="empwaddell['employeeFirstName'].errors && empwaddell['employeeFirstName'].errors['maxlength']">
                    {{lang.First_name_must_not_exceed_20_characters}}</div>
                  <div
                    *ngIf="empwaddell['employeeFirstName'].errors && empwaddell['employeeFirstName'].errors['pattern']">
                    {{lang.First_Name_Shouldn_t_allow_numbers_special_characters_and_blank_spaces}}
                  </div>
                </div>
              </div>
            </div>

            <div class="col-md-4 col-6">
              <div class="form-group">
                <label for="Corporation" class="Corporation">{{lang.Last_Name}}<span style="color: red">*</span></label>

                <input type="text" class="form-control checking-field" id="lastname" placeholder={{lang.Last_Name}}
                  (keypress)="alphabatesOnly($event)" formControlName="employeeLastName"
                  [(ngModel)]="editEmployeelastname" />
                <div *ngIf="empwaddell['employeeLastName'].touched && empwaddell['employeeLastName'].invalid"
                  class="help-block text-danger">
                  <div
                    *ngIf="empwaddell['employeeLastName'].errors && empwaddell['employeeLastName'].errors['required']">
                    {{lang.Please_enter_Last_name}} </div>
                  <div
                    *ngIf="empwaddell['employeeLastName'].errors && empwaddell['employeeLastName'].errors['minlength']">
                    {{lang.Last_name_should_be_2_characters}}</div>
                  <div
                    *ngIf="empwaddell['employeeLastName'].errors && empwaddell['employeeLastName'].errors['maxlength']">
                    {{lang.Last_name_must_not_exceed_20_characters}}</div>
                  <div
                    *ngIf="empwaddell['employeeLastName'].errors && empwaddell['employeeLastName'].errors['pattern']">
                    {{lang.Last_Name_Shouldn_t_allow_numbers_special_characters_and_blank_spaces}}
                  </div>

                </div>
              </div>
            </div>
            <div class="col-md-4 col-6">
              <div class="form-group">
                <label for="Corporation" class="Corporation">{{lang.Email}}<span style="color: red">*</span></label>

                <input type="text" class="form-control checking-field" id="email" placeholder={{lang.Email}}
                  formControlName="employeeEmail" [(ngModel)]="editEmployeeemail"
                  (input)="textChangeToLowerCase1('employeeEmail')" />
                <div *ngIf="empwaddell['employeeEmail'].touched && empwaddell['employeeEmail'].invalid"
                  class="help-block text-danger">
                  <div *ngIf="empwaddell['employeeEmail'].errors && empwaddell['employeeEmail'].errors['required']">
                    {{lang.Please_enter_email}}
                  </div>
                  <div *ngIf="empwaddell['employeeEmail'].errors && empwaddell['employeeEmail'].errors['pattern']">
                    {{lang.Please_enter_valid_email}}</div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">

            <div class="col-md-4 col-6">
              <div class="form-group">
                <label for="Corporation" class="Corporation">{{lang.Phone_Number}}<span
                    style="color: red">*</span></label>

                <input type="text" class="form-control checking-field" id="firstname" (keypress)="numberOnly($event)"
                  placeholder={{lang.Phone_Number}} formControlName="employeePhoneno" [(ngModel)]="editEmployeephone" />
                <div *ngIf="empwaddell['employeePhoneno'].touched && empwaddell['employeePhoneno'].invalid"
                  class="help-block text-danger">
                  <div *ngIf="
                        empwaddell['employeePhoneno'].errors && empwaddell['employeePhoneno'].errors['required']
                      ">
                    {{lang.Please_enter_phone_number}}
                  </div>
                  <div *ngIf="
                        empwaddell['employeePhoneno'].errors &&
                        empwaddell['employeePhoneno'].errors['minlength']
                      ">
                    {{lang.Phone_number_minimum_of_10_digits}}
                  </div>
                  <div *ngIf="
                        empwaddell['employeePhoneno'].errors &&
                        empwaddell['employeePhoneno'].errors['maxlength']
                      ">
                    {{lang.Phone_number_maximum_of_10_digits}}
                  </div>
                  <!-- <div *ngIf="f['adminphone'].errors && f['adminphone'].errors['maxlength']">Phone number must not exceed 20 digits</div> -->
                </div>
              </div>
            </div>

            <div class="col-md-4 col-6">
              <div class="form-group">
                <label for="Corporation" class="Corporation">{{lang.Street_Address}}<span
                    style="color: red">*</span></label>

                <input type="text" class="form-control checking-field" id="lastname" placeholder={{lang.Street_Address}}
                  formControlName="employeeStreetAddress" [(ngModel)]="editEmployeeStreeAddress" />
                <div *ngIf="empwaddell['employeeStreetAddress'].touched && empwaddell['employeeStreetAddress'].invalid"
                  class="help-block text-danger">
                  <div
                    *ngIf="empwaddell['employeeStreetAddress'].errors && empwaddell['employeeStreetAddress'].errors['required']">
                    {{lang.Please_enter_street_address}}</div>
                </div>
              </div>
            </div>
            <div class="col-md-4 col-6">
              <div class="form-group">
                <label for="Corporation" class="Corporation">{{lang.Country}}<span style="color: red">*</span></label>

                <select class="form-control" id="country" placeholder="country" formControlName="employeeCountry"
                  (change)="getprovincelist($event)" [(ngModel)]="editemployeeCountry">
                  <option [value]="null" disabled>{{lang.Select}}</option>
                  <option *ngFor="let country of countryList" [value]="country.name">
                    {{country.name}}
                  </option>
                </select>
                <div *ngIf="empwaddell['employeeCountry'].touched && empwaddell['employeeCountry'].invalid"
                  class="help-block text-danger">
                  <div *ngIf="empwaddell['employeeCountry'].errors && empwaddell['employeeCountry'].errors['required']">
                    {{lang.Please_select_country}}
                  </div>


                </div>
              </div>
            </div>
          </div>
          <div class="row">


            <div class="col-md-4 col-6">
              <div class="form-group">
                <label for="Corporation" class="Corporation">{{lang.City}}<span style="color: red">*</span></label>

                <input type="text" class="form-control checking-field" id="city" (keypress)="alphabatesOnly($event)"
                  placeholder={{lang.City}} formControlName="employeeCity" [(ngModel)]="editEmployeeCity" />
                <div *ngIf="empwaddell['employeeCity'].touched && empwaddell['employeeCity'].invalid"
                  class="help-block text-danger">
                  <div *ngIf="empwaddell['employeeCity'].errors && empwaddell['employeeCity'].errors['required']">
                    {{lang.Please_enter_city}}</div>


                </div>
              </div>
            </div>

            <div class="col-md-4 col-6">
              <div class="form-group">
                <label for="Corporation" class="Corporation">{{lang.Province}}<span style="color: red">*</span></label>

                <select class="form-control" id="Province" formControlName="employeeProvince"
                  (change)="provincelistwaddell($event)" [(ngModel)]="editEmployeeProvicne">
                  <option value="" [disabled]="true">{{lang.Select}}</option>
                  <option *ngFor="let name of configprovincereslist" [value]="name.shortName">
                    {{ name.shortName }}
                  </option>
                </select>
                <div *ngIf="empwaddell['employeeProvince'].touched && empwaddell['employeeProvince'].invalid"
                  class="help-block text-danger">
                  <div
                    *ngIf="empwaddell['employeeProvince'].errors && empwaddell['employeeProvince'].errors['required']">
                    {{lang.Please_select_Province}}
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-4 col-6">
              <div class="form-group">
                <label for="Corporation" class="Corporation">{{lang.Postal_Code}}<span
                    style="color: red">*</span></label>


                <input type="text" class="form-control checking-field" id="postalcode" placeholder={{lang.Postal_Code}}
                  onkeyup="this.value = this.value.toUpperCase();" formControlName="employeePostalCode"
                  [(ngModel)]="editEmployeeposatlCode"
                  (input)="changeTextToUppercasewaddell('employeePostalCode', $event)" />
                <div *ngIf="empwaddell['employeePostalCode'].touched && empwaddell['employeePostalCode'].invalid"
                  class="help-block text-danger">
                  <div
                    *ngIf="empwaddell['employeePostalCode'].errors && empwaddell['employeePostalCode'].errors['required']">
                    {{lang.Please_enter_postal_code}}
                  </div>
                  <div *ngIf="
                        invalidpostalcodeprivincewaddell ||
                        (empwaddell['employeePostalCode'].touched &&
                        empwaddell['employeePostalCode'].hasError('invalidPostalCodewaddell'))
                      ">
                    {{lang.Please_enter_valid_postal_code}}
                  </div>

                </div>
              </div>
            </div>
          </div>
          <div class="row" [hidden]="true">
            <div class="col-md-4 col-6">
              <div class="form-group">
                <label for="Corporation" class="Corporation">{{lang.Employee_ID}}</label>

                <input type="text" class="form-control checking-field" id="Employee ID" placeholder={{lang.Employee_ID}}
                  formControlName="employeeId" [(ngModel)]="editEmployeeId"
                  (keypress)="alphaNumaricssWithHipen($event)" />
                <div *ngIf="empwaddell['employeeId'].touched && empwaddell['employeeId'].invalid"
                  class="help-block text-danger">
                  <div *ngIf="empwaddell['employeeId'].errors && empwaddell['employeeId'].errors['required']">
                    {{lang.Please_enter_Employee_ID}}
                  </div>
                </div>
              </div>
            </div>


          </div>



          <!-- <div class="row" style="margin:0px">
            <div class="col-md-12">
              <button class="btn btn-primary" type="button" (click)="editemployeetolist()"><i class="fa fa-save" ></i>&nbsp;Save&nbsp;&nbsp;</button>

              <button class="btn btn-primary" id="employeeCancelButton" type="button" (click)="editemployeeform()"> Cancel &nbsp;&nbsp;</button>&nbsp;&nbsp;
            </div>
          </div> -->


        </form>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" id="closeaddadmin" data-bs-dismiss="modal" #closemodel>
          {{lang.Close}}
        </button>
        <button type="submit" class="btn btn-primary" (click)="editemployeetolistwaddell()">
          &nbsp;{{lang.Save}}&nbsp;&nbsp;
        </button>
      </div>
      <!-- <button class="btn btn-primary"  type="submit">Submit</button> -->
    </div>
  </div>
</div>
<div class="modal fade" data-bs-backdrop="static" id="existmail-modal" tabindex="-1">
  <div class="modal-dialog model-sm modal-dialog-centered " role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h6 class="modal-title">{{lang.Existing_Emails}}</h6>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <table>
          <!-- <th>S.no</th> -->
          <th>{{lang.Email}}</th>
          <tr *ngFor="let item of failedEmployeesList;let i=index">
            <!-- <td>{{i+1}}</td> -->
            <td>{{item.mailId}}</td>
          </tr>
        </table>

      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" id="closeaddadmin" data-bs-dismiss="modal" #closemodel>
          {{lang.Close}}
        </button>

      </div>
      <!-- <button class="btn btn-primary"  type="submit">Submit</button> -->
    </div>
  </div>
</div>
<app-confirmation-dialog [message]="message" [isCorporate]="isCorporate" [languageData]="languageData"
  [checkboxes]="checkboxesForMail">
</app-confirmation-dialog>
<!-- Footer of the Application -->

<a (click)="scrollTop()" class="back-to-top d-flex align-items-center justify-content-center"><i
    class="bi bi-arrow-up-short"></i></a>

<app-header></app-header>

<!-- <app-header *ngIf="false"></app-header> -->

<!-- <app-reports></app-reports> -->

<!-- <app-footer></app-footer> -->

<div class="modal fade" id="edit-headcount" data-backdrop="static" tabindex="-1">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h6 class="modal-title w-100 text-center">Edit Head Count</h6>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">

        <div class="packageWrapper block3packagewrapper plansscreenbulk"
          *ngFor="let package of balkPlans; let i = index">
          <div class="form-group package" style="margin-top:-2px">
            <div class="package-groups1" *ngFor="let group of package?.groups; let j = index" title="">
              <div class="planbody" *ngIf="
                group && group.subGroups && group.subGroups.length > 0
              ">
                <div *ngFor="let subgroup of group.subGroups; let k = index">
                  <div *ngIf="subgroup" id="collapsethreeBulk{{
                      package?.groups?.length >  1
                        ? subgroup.parentId
                        : package?.id
                    }}" class="accordion-collapse collapse show">
                    <div>
                      <div id="checkbox-{{subgroup.id}}"
                        *ngIf="checkboxCheck[subgroup.id]==true && editPlanHeadCount.planLevelId == subgroup.id"
                        class="countblock">

                        <table class="border-0">
                          <tbody>

                            <!-- current head count -->
                            <tr class="bg-transparent">
                              <td>
                                <label for="Corporation" class="Corporation">Current Head Count</label>
                              </td>
                              <td>
                                <input type="number" class="headcountbox" [(ngModel)]="currentHeadCount"
                                  class="headerCount" (keypress)="preventNegative($event)"
                                  (input)="preventNonNumeric($event)"
                                  (change)="updateBulkHeadCountTotal($event,subgroup,subgroup.settings?.requiredCustomersCount)"
                                  disabled>&nbsp;
                                &nbsp;
                                <span class="text-left"
                                  *ngIf="checkboxCheck[subgroup.id] && showinputboxvalue[subgroup.id] && (showHeadCount[subgroup.id] || showHeadCount[subgroup.id] >0)">
                                  <i class="fa fa-eye" title="view" aria-hidden="true" data-bs-toggle="modal"
                                    (click)="editEmployees(subgroup.id,'view','show')"></i>
                                </span>
                              </td>
                            </tr>

                            <!-- new head count -->
                            <tr class="bg-transparent">
                              <td>
                                <label for="Corporation" class="Corporation">New Head Count</label>
                              </td>
                              <td>
                                <input type="number" class="headcountbox" [(ngModel)]="newHeadCount" class="headerCount"
                                  (keypress)="preventNegative($event)" (input)="preventNonNumeric($event)"
                                  (change)="updateBulkHeadCountTotal($event,subgroup,subgroup.settings?.requiredCustomersCount)">&nbsp;
                                <label for="Corporation" class="Corporation" *ngIf="!newHeadCount || newHeadCount <=0"
                                  style="color:red">
                                  {{lang.Please_enter_head_count_for}} {{subgroup?.name}}</label>
                                &nbsp;

                                <span class="text-left"
                                  *ngIf="checkboxCheck[subgroup.id] && showinputboxvalue[subgroup.id] && (showHeadCount[subgroup.id] || showHeadCount[subgroup.id] >0)">
                                  <label for="DownloadButton" id="uploadButtonExcel" title="Download Template"
                                    data-taggle="tooltip"
                                    (click)="exportAsXLSX(subgroup.id,subgroup.settings.memberDetailsKeysDB)"
                                    class="Cursorpointer">
                                    <img src="../../../assets/img/download-template.png"
                                      style="width:100px;height:30px">
                                  </label>&nbsp;
                                  <label for="uploadButton-{{subgroup.id}}" id="uploadButtonExcel-{{subgroup.id}}"
                                    title="Upload Employee/Entity List" data-taggle="tooltip" class="Cursorpointer">
                                    <img src="../../../assets/img/upload-employee-list.png"
                                      style="width:100px;height:30px">
                                    <input id="uploadButton-{{subgroup.id}}" #myFileInput style="display: none"
                                      type="file"
                                      (input)="onFileChangeExcel($event,subgroup.id,subgroup.settings.memberDetailsKeysDB)" />
                                  </label> &nbsp;
                                  <i class="fa fa-eye" title="view" aria-hidden="true" data-bs-toggle="modal"
                                    (click)="editEmployees(subgroup.id,'edit','show')"></i>
                                </span>
                              </td>
                            </tr>

                            <!-- effective date -->
                            <tr class="bg-transparent">
                              <td>
                                <label>Effective Date</label>
                              </td>
                              <td>
                                <select class="form-control1" style="width:auto; font-size: 14px;" id="lengthofService"
                                  [(ngModel)]="effectiveDate" (change)="toggleExpandActivePlanExpiry('date')">
                                  <option *ngFor="let date of dateOptions" [value]="date.value">{{ date.text }}</option>
                                </select>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                        <div *ngIf="nonEditingBulkPlan" class="d-flex">
                          <input type="checkbox" (change)="toggleExpandActivePlanExpiry()"
                            id="expandActivePlanExpiry" />&nbsp;
                          <label for="expandActivePlanExpiry" class="mx-2">Expand termination date of active plan to
                            activation date of provisioning plan</label>
                        </div>
                      </div>
                    </div>
                  </div>

                </div>

              </div>

            </div>
          </div>

        </div>

      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" tooltip="Close" id="closeaddadmin" data-bs-dismiss="modal"
          #closemodel>
          {{lang.Close}}
        </button>
        <button type="button" class="btn btn-primary saveAndNext" tooltip="Save" data-bs-dismiss="modal"
          style="background:rgb(56, 76, 159) !important;color:white !important;" (click)="saveHeadCount()">
          {{lang.Save}}
        </button>

      </div>
      <!-- <button class="btn btn-primary"  type="submit">Submit</button> -->
    </div>
  </div>
</div>


<div class="modal fade" id="terminate-bulkplan" data-backdrop="static" tabindex="-1">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h6 class="modal-title w-100 text-center">Terminate {{editPlanHeadCount.planLevel}}</h6>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">

        <div class="row">
          <div class="col-12 mb-3">
            Choose termination date to expire {{editPlanHeadCount.planLevel}} plan of headcount
            {{editPlanHeadCount.quantity}}
          </div>

          <div class="col-4 mb-3">
            <label>Effective Date</label>
          </div>
          <div class="col-8 mb-3">
            <select class="form-control1" style="width:auto; font-size: 14px;" id="lengthofService"
              [(ngModel)]="effectiveDate" (change)="toggleTerminationExpiryDate()">
              <option *ngFor="let date of dateOptions" [value]="date.value">{{ date.text }}</option>
            </select>
          </div>

          <div *ngIf="editPlanHeadCount.status=='Provisioning' && nonEditingBulkPlan && showActivateOldPlan">
            <input type="checkbox" [checked]="activateOldPlan" (click)="toggleActivateOldPlan()"
              id="activateOldPlan" />&nbsp;
            <label for="activateOldPlan" class="mx-2">Remove termination date for active plan?</label>
          </div>
          <div *ngIf="editPlanHeadCount.status=='Active' && nonEditingBulkPlan">
            <input type="checkbox" [checked]="updateProvisioningDate" (click)="toggleUpdateProvisioningDate()"
              id="updateProvisioningDate" />&nbsp;
            <label for="updateProvisioningDate" class="mx-2">Activate Provisioning Plan to the effective date</label>
          </div>
        </div>

      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" tooltip="Close" id="closeaddadmin" data-bs-dismiss="modal"
          #closemodel>
          {{lang.Close}}
        </button>
        <button type="button" class="btn btn-primary saveAndNext" tooltip="Save" data-bs-dismiss="modal"
          style="background:rgb(56, 76, 159) !important;color:white !important;" (click)="submitExpiration()"
          [disabled]="effectiveDate==null">
          {{lang.Save}}
        </button>

      </div>
      <!-- <button class="btn btn-primary"  type="submit">Submit</button> -->
    </div>
  </div>
</div>


<div class="modal fade" id="deleteTierConfiguration" data-backdrop="static" tabindex="-1">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h6 class="modal-title w-100 text-center">Delete Tier :{{deleteTierName}}</h6>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">

        <div class="row">
          <div class="col-12 mb-3">
            Are you sure you want to move employees to another tier?
          </div>

          <div class="col-4 mb-3">
            <label>Effective Date</label>
          </div>

        </div>

      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" tooltip="Close" id="closeaddadmin" data-bs-dismiss="modal"
          #closemodel>
          {{lang.Close}}
        </button>
        <button type="button" class="btn btn-primary saveAndNext" tooltip="Save" data-bs-dismiss="modal"
          style="background:rgb(56, 76, 159) !important;color:white !important;" (click)="submitExpiration()">
          {{lang.Save}}
        </button>

      </div>
      <!-- <button class="btn btn-primary"  type="submit">Submit</button> -->
    </div>
  </div>
</div>


<!-- <div class="modal fade" data-bs-backdrop="static" id="historyInvoice-modal" tabindex="-1">
  <div class="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable"> -->

<div class="modal modal-md fade" id="historyInvoice-modal" aria-labelledby="exampleModalLabel" aria-hidden="true"
  style="max-width: 100% !important;">
  <div class="modal-dialog modal-md modal-dialog-centered modal-dialog-scrollable" id="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h6 class="modal-title">History</h6>
        <div class="col-1 text-end ms-2 ms-md-2">
          <i style="margin-right: 4px" class="bi bi-x-circle" role="button" aria-hidden="true"
            data-bs-dismiss="modal"></i>
        </div>
      </div>
      <div class="modal-body">

        <div class="container">

          <div class="table-responsive">
            <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger1" id="DataTables_Table_2"
              class="table text-nowrap" *ngIf="historyDetails.length>1">
              <thead>
                <tr>
                  <th style="width: 30px">#</th>
                  <th>Date</th>
                  <th>Modified By</th>
                  <th>Note</th>

                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let tier of historyDetails; let i = index">
                  <td>{{i+1}}</td>
                  <td>{{tier.created | date}}</td>
                  <td>{{tier.changedByUsername}}</td>
                  <td>{{tier.reason}}</td>
                </tr>

              </tbody>
            </table>
          </div>
          <div class="table-responsive" *ngIf="historyDetails.length==1">
            <!-- <table>
              <thead>
                <tr>
                  <th style="width: 30px">#</th>

                  <th>Date</th>
                  <th>Modified By</th>
                  <th>Note</th>

                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let invoice of historyDetails; let i = index">
                  <td>{{i+1}}</td>
                  <td>{{invoice.created | date}}</td>
                  <td>{{invoice.changedByUsername}}</td>
                  <td>{{invoice.reason}}</td>

                </tr>

              </tbody>
            </table> -->
          </div>
          <div style="text-align: center;margin-top: 10px" *ngIf="historyDetails.length==0">
            <span>No data found in history.</span>

          </div>

        </div>
      </div>

      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" id="closeaddadmin" data-bs-dismiss="modal" #closemodel>
          Close
        </button>

      </div>
    </div>
  </div>
</div>

<div class="modal modal-xl fade" id="membersList-modal" aria-labelledby="exampleModalLabel" aria-hidden="true"
  style="max-width: 100% !important;">
  <div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable" id="modal-dialog">
    <div class="modal-content" id="modal-content">
      <div class="modal-header" id="backgroundColor">
        <h6 class="modal-title">Members List</h6>
        <div class="col-1 text-end ms-2 ms-md-2">
          <i style="margin-right: 4px" class="bi bi-x-circle" role="button" aria-hidden="true"
            data-bs-dismiss="modal"></i>
        </div>
      </div>
      <div class="modal-body">
        <table class="table text-nowrap" *ngIf="tierMembers.length>=1">
          <thead>
            <tr>
              <th style="width: 30px">#</th>
              <th>Name</th>
              <th>Email</th>
              <th>Status</th>

            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let tier of tierMembers; let i = index">
              <td>{{i+1}}</td>
              <td>{{tier.firstName}}&nbsp;&nbsp;{{tier.lastName}}</td>
              <td>{{tier.email}}</td>
              <td>{{tier.status}}</td>
            </tr>

          </tbody>
        </table>


      </div>

      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" id="closeaddadmin" data-bs-dismiss="modal" #closemodel>
          Close
        </button>

      </div>
    </div>
  </div>
</div>

<div class="modal modal-xl fade" id="membersList12-modal" aria-labelledby="exampleModalLabel" aria-hidden="true"
  style="max-width: 100% !important;" *ngIf="checkMemeberTier">
  <div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable" id="modal-dialog">
    <div class="modal-content" id="modal-content">
      <div class="modal-header" id="backgroundColor">
        <h6 class="modal-title">Members List</h6>
        <div class="col-1 text-end ms-2 ms-md-2">
          <i style="margin-right: 4px" class="bi bi-x-circle" role="button" aria-hidden="true"
            data-bs-dismiss="modal"></i>
        </div>
      </div>
      <div class="modal-body">

        <div class="row">
          <!-- <div class="col-12 mb-3">
            <b>{{tierDetails.name}}</b>&nbsp;Tier contain {{tierDetails.memberCount}} members
          </div> -->

          <table class="table text-nowrap" *ngIf="tierMembers.length>1">
            <thead>
              <tr>
                <th class="my-auto">
                  <input type="checkbox" (change)="toggleAllPlans($event)" aria-label="Select All Plans" />
                  &nbsp;#
                </th>
                <th>Name</th>
                <th>Email</th>
                <th>Status</th>
                <th>Tier</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let tier of tierMembers; let i = index">
                <td>
                  <input type="checkbox" id="planCheckbox{{tier.staxbillId}}" [checked]="tier?.planCheckbox === true"
                    (change)="planCheckbox(tier.staxbillId, $event)" aria-label="Select Plan {{tier.staxbillId}}" />
                  {{i+1}}
                </td>
                <td>{{tier.firstName}}&nbsp;&nbsp;{{tier.lastName}}</td>
                <td>{{tier.email}}</td>
                <td>{{tier.status}}</td>
                <td>
                  <select class="form-control" id="country" placeholder="Tier"
                    [(ngModel)]="selectedTierName[tier.staxbillId]"
                    (ngModelChange)="onTierChange(tier.staxbillId, $event)">
                    <option value="" [disabled]="true">Select</option>
                    <option *ngFor="let tier of corporateTiers" [value]="tier.id">
                      {{ tier.name }}
                    </option>

                  </select>
                </td>
              </tr>

            </tbody>
          </table>


        </div>

      </div>

      <div class="modal-footer">
        <button type="button" class="btn btn-primary" [disabled]="!isAnyPlanCheckboxSelected()"
          (click)="submitChangetierMembers()">
          Proceed
        </button>
        <!-- <button type="button" class="btn btn-primary" *ngIf="deleteTierForm.get('memberCheck')?.value === 'false'"
          (click)="deleteTierwithoutMembers()">
          Proceed
        </button> -->
        <button type="button" class="btn btn-secondary" id="closeaddadmin" data-bs-dismiss="modal" #closemodel>
          Close
        </button>

      </div>
    </div>
  </div>
</div>

<div class="modal modal-xl fade" id="deleteMembers-modal" aria-labelledby="exampleModalLabel" aria-hidden="true"
  style="max-width: 100% !important;" *ngIf="checkDeleteTier">
  <div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable" id="modal-dialog">
    <div class="modal-content" id="modal-content">
      <div class="modal-header" id="backgroundColor">
        <h6 class="modal-title">Members List</h6>
        <div class="col-1 text-end ms-2 ms-md-2">
          <i style="margin-right: 4px" class="bi bi-x-circle" role="button" aria-hidden="true"
            data-bs-dismiss="modal"></i>
        </div>
      </div>
      <div class="modal-body">

        <div class="row">
          <div class="col-12 mb-3">
            <!-- <b>{{tierDetails.name}}</b>&nbsp;Tier contain {{tierDetails.memberCount}} members -->
            <b>{{tierDetails.name}}</b>&nbsp;Tier contain {{tierDetails.memberCount}} <span
              *ngIf="tierDetails.memberCount==1;else showmembers">member</span><ng-template
              #showmembers>members</ng-template>

          </div>
          <form [formGroup]="deleteTierForm">
            <div class="col-12 mb-3">
              <label>Do you want to move members to another tier?</label>
              <div>
                <input class="" type="radio" name="memebrTiers" id="memberTierCheck" value="true"
                  formControlName="memberCheck" (click)="membersTierCheck($event)" />
                <label class="form-check-label" for="memebrTiersYes">&nbsp;{{lang.Yes}}</label>&nbsp;&nbsp;
                <input class="" type="radio" name="memebrTiers" id="memberTierCheck" value="false"
                  formControlName="memberCheck" (click)="membersTierCheck($event)" checked />
                <label class="form-check-label" for="memebrTiersNo">&nbsp;{{lang.No}}</label>
              </div>
            </div>
          </form>
          <ng-conatiner *ngIf="deleteTierForm.get('memberCheck')?.value == 'true'">
            <table class="table text-nowrap" *ngIf="tierMembers.length>=1">
              <thead>
                <tr>
                  <th class="my-auto">
                    <input type="checkbox" (change)="toggleAllPlans($event)" aria-label="Select All Plans" />
                    &nbsp;#
                  </th>
                  <th>Name</th>
                  <th>Email</th>
                  <th>Status</th>
                  <th>Tier</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let tier of tierMembers; let i = index">
                  <td>
                    <input type="checkbox" id="planCheckbox{{tier.staxbillId}}" [checked]="tier?.planCheckbox === true"
                      (change)="planCheckbox(tier.staxbillId, $event)" aria-label="Select Plan {{tier.staxbillId}}" />
                    {{i+1}}
                  </td>
                  <td>{{tier.firstName}}&nbsp;&nbsp;{{tier.lastName}}</td>
                  <td>{{tier.email}}</td>
                  <td>{{tier.status}}</td>
                  <td>
                    <select class="form-control" id="country" placeholder="Tier"
                      [(ngModel)]="selectedTierName[tier.staxbillId]"
                      (ngModelChange)="onTierChange(tier.staxbillId, $event)">
                      <option value="" [disabled]="true">Select</option>
                      <option *ngFor="let tier of corporateTiersDeleteList" [value]="tier.id">
                        {{ tier.name }}
                      </option>

                    </select>
                  </td>
                </tr>

              </tbody>
            </table>
          </ng-conatiner>

        </div>

      </div>

      <div class="modal-footer">
        <button type="button" class="btn btn-primary" [disabled]="!isAnyPlanCheckboxSelected()"
          (click)="submitterminationTiersWithMembers()" *ngIf="deleteTierForm.get('memberCheck')?.value === 'true'">
          Proceed
        </button>
        <button type="button" class="btn btn-primary" *ngIf="deleteTierForm.get('memberCheck')?.value === 'false'"
          (click)="deleteTierwithoutMembers()">
          Proceed
        </button>
        <button type="button" class="btn btn-secondary" id="closeaddadmin" data-bs-dismiss="modal" #closemodel>
          Close
        </button>

      </div>
    </div>
  </div>
</div>
<!-- <div class="modal fade" data-bs-backdrop="static" id="EditTierandWalletConfig-modal" tabindex="-1">
  <div class="modal-dialog modal-lg modal-dialog-scrollable">
    <div class="modal-content">
      <div class="modal-header"> -->

<div class="modal modal-xl fade" id="EditTierandWalletConfig-modal" aria-labelledby="exampleModalLabel"
  aria-hidden="true" style="max-width: 100% !important;">
  <div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable" id="modal-dialog">
    <div class="modal-content" id="modal-content">
      <div class="modal-header" id="backgroundColor">
        <h6 class="modal-title">Edit Tier</h6>
        <div class="col-1 text-end ms-2 ms-md-2">
          <i style="margin-right: 4px" class="bi bi-x-circle" role="button" aria-hidden="true" data-bs-dismiss="modal"
            (click)="showEditTier=false"></i>
        </div>
      </div>
      <div class="modal-body">

        <div class="row">
          <!-- <ng-container *ngIf="showTierandWalletConfig"> -->
          <ng-container *ngIf="showTierConfig">
            <div class="col-12 col-md-12 d-flex justify-content-between"
              style="background-color: #142a49!important; font-size:14px;margin-top: 5px;">
              <h6 class="admintitle my-auto">
                Tier Configuration&nbsp;&nbsp;
              </h6>


            </div>
            <form [formGroup]="addTierForm">
              <div class="row">
                <div class="col-12 col-md-2">
                  <div class="form-group">
                    <label for="Corporation" class="Corporation">Tier Name<span style="color: red">*</span></label>

                    <input type="text" class="form-control checking-field" formControlName="tierName"
                      id="nameofcorporation" placeholder="Tier Name" [(ngModel)]="tierName" />

                    <div *ngIf="
                        tier['tierName'].touched &&
                        tier['tierName'].invalid
                      " class="help-block text-danger">
                      <div *ngIf="
                        tier['tierName'].errors &&
                        tier['tierName'].errors['required']
                      ">
                        Please enter tier name
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-12 col-md-2">
                  <div class="form-group">
                    <label for="Corporation" class="Corporation">Description<span style="color: red">*</span></label>

                    <input type="text" class="form-control checking-field" formControlName="tierDescription"
                      id="nameofcorporation" placeholder="Tier Description" [(ngModel)]="tierDescription">

                    <div *ngIf="
                        tier['tierDescription'].touched &&
                        tier['tierDescription'].invalid
                      " class="help-block text-danger">
                      <div *ngIf="
                        tier['tierDescription'].errors &&
                        tier['tierDescription'].errors['required']
                      ">
                        Please enter tier description
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-12 col-md-1">
                  <div class="form-group">
                    <label for="Corporation" class="Corporation">Status<span style="color: red">*</span></label>

                    <select class="form-control" id="country" placeholder="Country" formControlName="tierStatus"
                      [(ngModel)]="tierStatus">
                      <option value="" [disabled]="true">Select</option>
                      <option value="Active">Active</option>
                      <option value="Inactive">In Active</option>

                    </select>
                    <div *ngIf="
                      tier['tierStatus'].touched &&
                      tier['tierStatus'].invalid
                    " class="help-block text-danger">
                      <div *ngIf="
                        tier['tierStatus'].errors &&
                        tier['tierStatus'].errors['required']
                      ">
                        Please select tier status
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-12 col-md-2">
                  <div class="form-group">
                    <label for="Corporation" class="Corporation">Effective Date<span style="color: red">*</span></label>

                    <!-- <input type="text" placeholder="Effective Date" class="form-control"
                      formControlName="tierEffectiveDate" [(ngModel)]="tierEffectiveDate"
                      [bsConfig]="{dateInputFormat: 'MM-DD-YYYY',showWeekNumbers: false}" bsDatepicker> -->

                    <select class="form-control" id="Effective Date" placeholder="Select"
                      formControlName="tierEffectiveDate" [(ngModel)]="tierEffectiveDate">
                      <option value="" [disabled]="true">{{lang.Select}}</option>
                      <option *ngFor="let name of enrollmentDates" [value]="name" [label]="name">
                        {{ name }}
                      </option>
                    </select>
                    <div *ngIf="
                        tier['tierEffectiveDate'].touched &&
                        tier['tierEffectiveDate'].invalid
                      " class="help-block text-danger">
                      <div *ngIf="
                        tier['tierEffectiveDate'].errors &&
                        tier['tierEffectiveDate'].errors['required']
                      ">
                        Please select Effective Date
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-12 col-md-2">
                  <div class="form-group">
                    <label for="Corporation" class="Corporation">Length of Service<span
                        style="color: red">*</span></label>

                    <select class="form-control" id="country" placeholder="Length of Service"
                      [(ngModel)]="tierTimeofService" formControlName="tierTimeOfService"
                      (change)="tiersServiceCheck($event)">
                      <option value="" [disabled]="true">Select</option>
                      <option value="true">Yes</option>
                      <option value="false">No</option>

                    </select>
                    <div *ngIf="
                        tier['tierTimeOfService'].touched &&
                        tier['tierTimeOfService'].invalid
                      " class="help-block text-danger">
                      <div *ngIf="
                        tier['tierTimeOfService'].errors &&
                        tier['tierTimeOfService'].errors['required']
                      ">
                        Please select length of service
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-12 col-md-2"
                  *ngIf="addTierForm.get('tierTimeOfService')?.value === 'true' || showTierlist">
                  <div class="form-group">
                    <label for="Corporation" class="Corporation">Min Length of Service<span
                        style="color: red">*</span></label>

                    <select class="form-control" id="country" placeholder="Min Length of Service"
                      formControlName="mintierTimeOfService" [(ngModel)]="tierMinTimeofService"
                      (change)="minServiceCheck($event)">
                      <option value="" [disabled]="true">Select</option>
                      <option value="0">New Joinee-0 Year</option>
                      <option value="1">1 year</option>
                      <option value="2">2 years</option>
                      <option value="3">3 years</option>
                      <option value="4">4 years</option>
                      <option value="5">5 years</option>
                      <option value="6">6 years</option>
                      <option value="7">7 years</option>
                      <option value="8">8 years</option>
                      <option value="9">9 years</option>
                      <option value="10">10 years</option>
                    </select>
                    <div *ngIf="
                        tier['mintierTimeOfService'].touched &&
                        tier['mintierTimeOfService'].invalid
                      " class="help-block text-danger">
                      <div *ngIf="
                          tier['mintierTimeOfService'].errors &&
                          tier['mintierTimeOfService'].errors['required']
                        ">
                        Please select Min length of service
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-12 col-md-2"
                  *ngIf="addTierForm.get('tierTimeOfService')?.value === 'true' || showTierlist">
                  <div class="form-group">
                    <label for="Corporation" class="Corporation">Max Length of Service<span
                        style="color: red">*</span></label>

                    <select class="form-control" id="country" placeholder="Max Tier of Service"
                      formControlName="maxtierTimeOfService" [(ngModel)]="tierMaxTimeofService"
                      (change)="maxServiceCheck($event)">
                      <option value="" [disabled]="true">Select</option>
                      <option value="1">1 year</option>
                      <option value="2">2 years</option>
                      <option value="3">3 years</option>
                      <option value="4">4 years</option>
                      <option value="5">5 years</option>
                      <option value="6">6 years</option>
                      <option value="7">7 years</option>
                      <option value="8">8 years</option>
                      <option value="9">9 years</option>
                      <option value="10">10 years</option>

                    </select>
                    <div *ngIf="
                        tier['maxtierTimeOfService'].touched &&
                        tier['maxtierTimeOfService'].invalid
                      " class="help-block text-danger">
                      <div *ngIf="
                          tier['maxtierTimeOfService'].errors &&
                          tier['maxtierTimeOfService'].errors['required']
                        ">
                        Please select Max length of service
                      </div>
                    </div>
                  </div>
                </div>

              </div>
              <div class="row d-flex align-items-center">
                <div class="col"></div>
                <div class="col-auto">
                  <button class="btn btn-primary" [disabled]="addTierForm.invalid"
                    (click)="editTierDetails()">{{lang.Save}}</button>
                </div>
              </div>




            </form>
          </ng-container>
          <ng-container *ngIf="showWalletConfig">
            <div class="col-12 col-md-12 d-flex justify-content-between"
              style="background-color: #142a49!important; font-size:14px;margin-top: 5px;">
              <h6 class="admintitle my-auto">
                Wallet Configuration&nbsp;&nbsp;
              </h6>


            </div>
            <form [formGroup]="addWalletForm">
              <div class="row">
                <div class="col-12 col-md-2">
                  <div class="form-group">
                    <label for="Corporation" class="Corporation">Wallet Amount<span style="color: red">*</span></label>
                    <div class="input-group">
                      <span class="input-group-text" style="line-height: 1.1 !important">$</span>
                      <input type="text" class="form-control checking-field" id="nameofcorporation"
                        formControlName="walletAmount" placeholder="$1000" [(ngModel)]="walletAmount"
                        (input)="clearIfStartsWithZero()" (ngModelChange)="formatAmount()" />
                    </div>
                    <div *ngIf="wallet['walletAmount'].touched && wallet['walletAmount'].invalid"
                      class="help-block text-danger">
                      <div *ngIf="wallet['walletAmount'].errors?.required">
                        Please enter wallet Amount
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-12 col-md-2">
                  <div class="form-group">
                    <label for="Corporation" class="Corporation">Carry Forward Amount<span
                        style="color: red">*</span></label>

                    <select class="form-control" id="country" placeholder="Carry Forword Amount"
                      [(ngModel)]="walletCarryForwordAmount" formControlName="carryForwordAmount"
                      (change)="checkAllocationTier($event)">
                      <option value="" [disabled]="true">Select</option>
                      <option value="true">Yes</option>
                      <option value="false">No</option>

                    </select>
                    <div *ngIf="wallet['carryForwordAmount'].touched && wallet['carryForwordAmount'].invalid"
                      class="help-block text-danger">
                      <div *ngIf="wallet['carryForwordAmount'].errors?.required">
                        Please Select Carry Forward Amount
                      </div>
                    </div>
                  </div>
                </div>
                <!-- *ngIf="addWalletForm.get('carryForwordAmount')?.value === 'true'" -->
                <div class="col-12 col-md-2">
                  <div class="form-group">
                    <label for="Corporation" class="Corporation"> Allocation<span style="color: red">*</span></label>

                    <select class="form-control" id="country" placeholder="Allocation" formControlName="allocation"
                      [(ngModel)]="walletAllocation" (change)="checkAllocation($event)">
                      <option value="" [disabled]="true">Select</option>

                      <option *ngFor="let item of tierWalletConfig.rollOverAllocationTypes" [value]="item.value">
                        {{item.label}}
                      </option>


                    </select>

                    <div *ngIf="wallet['allocation'].touched && wallet['allocation'].invalid"
                      class="help-block text-danger">
                      <div *ngIf="wallet['allocation'].errors?.required">
                        Please select Allocation
                      </div>
                    </div>
                  </div>
                </div>
                <!-- <div class="col-12 col-md-2">
                  <div class="form-group">
                    <label for="Corporation" class="Corporation">Industry Category<span
                        style="color: red">*</span></label>

                    <select class="form-control" id="country" placeholder="Industry Category"
                      formControlName="industryCategory" [(ngModel)]="walletIndustryCategory">
                      <option value="" [disabled]="true">Select</option>
                      <option *ngFor="let item of tierWalletConfig.industryCatagories" [value]="item.name">
                        {{item.name}}
                      </option>

                    </select>
                    <div *ngIf="wallet['industryCategory'].touched && wallet['industryCategory'].invalid"
                      class="help-block text-danger">
                      <div *ngIf="wallet['industryCategory'].errors?.required">
                        Please select Industry Category
                      </div>
                    </div>
                  </div>
                </div> -->
                <div class="col-12 col-md-2">
                  <div class="form-group">
                    <label for="Corporation" class="Corporation">Intial Balance Setup<span
                        style="color: red">*</span></label>

                    <select class="form-control" id="country" placeholder="Intial Balance Setup"
                      formControlName="intialBalanceSetup" [(ngModel)]="walletIntialBalanceSetup">
                      <option value="" [disabled]="true">Select</option>
                      <!-- <option *ngFor="let item of tierWalletConfig.initialBalanceSetup" [value]="item.value"> -->
                      <option *ngFor="let item of tierWalletConfig.initialBalanceSetup" [value]="item.value">
                        {{item.label}}
                      </option>

                    </select>
                    <div *ngIf="wallet['intialBalanceSetup'].touched && wallet['intialBalanceSetup'].invalid"
                      class="help-block text-danger">
                      <div *ngIf="wallet['intialBalanceSetup'].errors?.required">
                        Please select Initial Balance Setup
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-12 col-md-2">
                  <div class="form-group">
                    <label for="Corporation" class="Corporation">Coverage Percentage<span
                        style="color: red">*</span></label>

                    <select class="form-control" id="country" placeholder="Country"
                      formControlName="coveragePerecentage" [(ngModel)]="walletCoveragePercentage">
                      <option value="" [disabled]="true">Select</option>
                      <option value="100">100%</option>
                      <option value="95">95%</option>
                      <option value="90">90%</option>
                      <option value="85">85%</option>
                      <option value="80">80%</option>
                      <option value="75">75%</option>
                      <option value="70">70%</option>
                      <option value="65">65%</option>
                      <option value="60">60%</option>
                      <option value="55">55%</option>
                      <option value="50">50%</option>


                    </select>
                    <div *ngIf="wallet['coveragePerecentage'].touched && wallet['coveragePerecentage'].invalid"
                      class="help-block text-danger">
                      <div *ngIf="wallet['coveragePerecentage'].errors?.required">
                        Please select Coverage Percentage
                      </div>
                    </div>
                  </div>

                </div>

                <div class="col-12 col-md-2">
                  <div class="form-group">
                    <label for="Corporation" class="Corporation">Wallet Type<span style="color: red">*</span></label>

                    <!-- <select class="form-control" id="country" placeholder="Wallet Type" formControlName=Wallet Type1
                        [(ngModel)]="walletType"
                        > -->


 <div class="d-flex align-items-center">
  <select
    class="form-control position-relative"
    id="country"
    formControlName="walletType"
    [(ngModel)]="walletType"
    (change)="onWalletTypeSelected($event)">
    
    <option value="" disabled>Select</option>
    <option *ngFor="let item of tierWalletConfig.walletTypes" [value]="item.value">
      {{ item.label }}
    </option>
  </select>
  <!--  Show edit icon ONLY if 'mywsa' is selected -->
  <button
    *ngIf="walletType === 'MYWSA'"
    class="btn btn-sm btn-outline-secondary ms-2"
    type="button"
    (click)="openEditWSA()">
    <!-- (click)="updateWSAForm(item, i)"> -->
    <i class="bi bi-pencil-square"></i>
  </button>

</div>

  
                    <div *ngIf="wallet['walletType'].touched && wallet['walletType'].invalid"
                      class="help-block text-danger">
                      <div *ngIf="wallet['walletType'].errors?.required">
                        Please select wallet Type
                      </div>
                    </div>
                  </div>
                </div>



              </div>
              <div class="row">
                <!-- <div class="col-12 col-md-2">
                  <div class="form-group">
                    <label for="Corporation" class="Corporation">Advisor Commission<span
                        style="color: red">*</span></label>
<div class="input-group">
  <span class="input-group-text" style="line-height: 1.1 !important">%</span>
                    <input type="text" class="form-control checking-field" id="nameofcorporation" (input)="checkAdvisorCommision()"
                      placeholder="Advsior Commission" formControlName="advsiorFee" [(ngModel)]="walletAdvsiorFeeStructure" />
                      </div>
                    <div *ngIf="wallet['advsiorFee'].touched && wallet['advsiorFee'].invalid"
                      class="help-block text-danger">
                      <div *ngIf="wallet['advsiorFee'].errors?.required">
                        Please enter Advisor Commission
                      </div>
                    </div>
                  </div>
                </div> -->


              </div>
              <div class="row d-flex align-items-center mt-2">
                <div class="col"></div>
                <div class="col-auto">
                  <button class="btn btn-primary" [disabled]="addWalletForm.invalid"
                    (click)="editWalletDetails()">{{lang.Save}}</button>
                </div>
              </div>
            </form>
          </ng-container>

          <!-- common-plans for edit tiers -->
          <ng-container *ngIf="showEditTier">
            <app-common-plans #commonPlansEditTiers [viewPlan]="false" [isCorporate]="true" [bulkPlansData]="balkPlans"
              [plansData]="plansBlock1" [paidByCompany]="paidByCompany" [coveredByCompany]="coveredByCompany"
              [paidByEmployee]="paidByEmployee" [bulkplans]="bulkplans" [mode]="'edit'"
              [multiSelectProviancenames]="multiSelectProviancenames" (submitTriggered)="editTierPlansInfo()"
              [addWalletForm]="addWalletForm" [addTierForm]="addTierForm" [clientregform]="clientregform"
              [crateTierid]="crateTierid" [corpModal]="'EditTierandWalletConfig-modal'"></app-common-plans>

            <!-- </ng-container> -->
            <div class="linescrollbar form-container" style="margin-top:10px" *ngIf="false">
              <div class="row pb-2">
                <div class="col-12 col-md-12">
                  <div class="form-group">

                    <h6 class="admintitle">{{lang.Corporate_Level_Group_Plans}}
                      <!-- &nbsp;&nbsp; -->
                    </h6>
                  </div>
                </div>
              </div>
              <!-- Block1 With No Tier -->
              <!-- bulk plans -->
              <div class="row">
                <div class="packageWrapper block3packagewrapper plansscreenbulk"
                  *ngFor="let package of balkPlans; let i = index">
                  <div class="planheadingwrap" style="padding-left: 0px;">
                    <!-- && package && package?.id !== 2 -->
                    <!-- <div class=" planheadingwrap" *ngIf="package"></div> -->
                    <div class="d-flex position-relative">
                      <h6 *ngIf="package?.groups?.length >= 1" class="planheading panel-title ps-3"
                        [attr.data-bs-target]="'#collapsethreeBulk' + package?.id" data-bs-toggle="collapse"
                        aria-expanded="true" aria-controls="collapsethreeBulk{{ package?.id }}">
                        {{ package?.name }}
                      </h6>
                      <!-- <h6 class="planheading" *ngIf="package?.groups?.length >  1">
                    <h6 class="planheading" *ngIf="package?.groups?.length >  1">
                      {{ package?.name }}
                    </h6> -->
                      <div class="position-absolute" style="top: 18px;left: 10px;bottom: -39px;">
                        <div *ngIf="role==='ADMINISTRATOR' && package?.groups?.length >= 1"
                          title="{{getTextForTooltip1(package?.published,package?.restrictedAccess)}}"
                          [ngStyle]=" {'border-color' : getColorForPlans1(package?.published,package?.restrictedAccess) }"
                          class="outer my-auto col-2" data-bs-toggle="">
                          <span class="inner"
                            [ngStyle]="{ 'background': getColorForPlans1(package?.published,package?.restrictedAccess) }"></span>
                        </div>
                      </div>

                    </div>

                  </div>

                  <div class="form-group package" style="margin-top:-2px">
                    <!-- &&package && package?.id !== 2 -->
                    <div class="package-groups1" *ngFor="let group of package?.groups; let j = index" title="">
                      <div class="price" *ngIf="group && group != null">
                        <div class="header overflow-ellipsis1 panel-title"
                          [attr.data-bs-target]="'#collapsethreeBulk' + group.id" data-bs-toggle="collapse"
                          aria-expanded="true" aria-controls="collapsethreeBulk{{ group.id }}" title="{{ group.name }}"
                          *ngIf="
                        group &&
                        group.subGroups &&
                        group.subGroups.length > 0 &&
                        package?.groups?.length >  1
                      ">
                          {{ group.name }}
                        </div>
                      </div>
                      <div class="planbody" *ngIf="
                      group && group.subGroups && group.subGroups.length > 0
                    ">
                        <div *ngFor="let subgroup of group.subGroups; let k = index">
                          <div *ngIf="subgroup" id="collapsethreeBulk{{
                          package?.groups?.length >  1
                            ? subgroup.parentId
                            : package?.id
                        }}" class="accordion-collapse collapse show">
                            <div style="display: flex;" class="position-relative">
                              <div class="featuutrebody1 row justify-content-center align-items-center"
                                [style.background-color]="
                              subgroup.backgroundColor
                                ? subgroup.backgroundColor
                                : defaultColor
                            " *ngIf="subgroup">
                                <div class="col-1">
                                  <div *ngIf="role==='ADMINISTRATOR' && package?.groups?.length >= 1"
                                    title="{{getTextForTooltip(subgroup.published?.data[0],subgroup.restricted)}}"
                                    [ngStyle]=" {'border-color' : getColorForPlans(subgroup.published?.data[0],subgroup.restricted) }"
                                    class="outer my-auto col-2" data-bs-toggle="">
                                    <span class="inner"
                                      [ngStyle]="{ 'background': getColorForPlans(subgroup.published?.data[0],subgroup.restricted,subgroup.name) }"></span>
                                  </div>
                                </div>
                                <span class="col-10">{{ subgroup.name }}</span>

                                <input type="checkbox" id="plancheckboxbulk{{ subgroup.id }}" class=" col-1 plancheckboxbulk{{
                                package?.id
                              }} plancv largerCheckbox" attr.data="{{ package?.allowMultiple }}##{{
                                subgroup.disallowedPlanLevels
                              }}##{{ package?.id }}##{{ subgroup.parentId }}##{{
                                subgroup.id
                              }}##{{ package?.name }}##{{ subgroup.name }}##{{
                                subgroup
                              }}##{{ subgroup.ordering }}" (change)="
                              onCheckboxChangeBulkPlns(
                                  $event,
                                  package?.allowMultiple,
                                  subgroup.disallowedPlanLevels,
                                  package?.id,
                                  subgroup?.id,
                                  package?.name,
                                  subgroup.name,
                                  subgroup,
                                  subgroup.ordering,
                                  group.id,
                                  group.name,
                                  i,
                                  j,
                                  k
                                )
                              " />


                              </div>

                              <!-- <div>{{checkboxCheck[subgroup.id]}}{{subgroup.id}}</div> -->

                              <div id="checkbox-{{subgroup.id}}" *ngIf="checkboxCheck[subgroup.id]==true"
                                class="countblock">
                                &nbsp;

                                <label for="Corporation" class="Corporation">Head Count:</label>

                                <input type="number" class="headcountbox" [(ngModel)]="showHeadCount[subgroup.id]"
                                  class="headerCount" (keypress)="preventNegative($event)"
                                  (input)="preventNonNumeric($event)"
                                  (change)="updateTotal(j,$event,subgroup,subgroup.settings?.requiredCustomersCount)">&nbsp;
                                <label for="Corporation" class="Corporation"
                                  *ngIf="!showHeadCount[subgroup.id] || showHeadCount[subgroup.id] <=0"
                                  style="color:red">
                                  {{lang.Please_enter_head_count_for}}</label>
                                &nbsp;

                                <span class="text-left"
                                  *ngIf="checkboxCheck[subgroup.id] && showinputboxvalue[subgroup.id] && (showHeadCount[subgroup.id] || showHeadCount[subgroup.id] >0)">
                                  <label for="DownloadButton" id="uploadButtonExcel" title="Download Template"
                                    data-taggle="tooltip"
                                    (click)="exportAsXLSX(subgroup.id,subgroup.settings.memberDetailsKeysDB)"
                                    class="Cursorpointer">
                                    <img src="../../../assets/img/download-template.png"
                                      style="width:100px;height:30px">
                                  </label>&nbsp;
                                  <label for="uploadButton-{{subgroup.id}}" id="uploadButtonExcel-{{subgroup.id}}"
                                    title="Upload Employee/Entity List" data-taggle="tooltip" class="Cursorpointer">
                                    <img src="../../../assets/img/upload-employee-list.png"
                                      style="width:100px;height:30px">
                                    <input id="uploadButton-{{subgroup.id}}" #myFileInput style="display: none"
                                      type="file"
                                      (input)="onFileChangeExcel($event,subgroup.id,subgroup.settings.memberDetailsKeysDB)" />
                                  </label> &nbsp;
                                  <i class="fa fa-eye" title="view" aria-hidden="true" data-bs-toggle="modal"
                                    (click)="editEmployees(subgroup.id)"></i>

                                </span>
                              </div>

                              <!-- new process of updating bulk plan head count -->
                              <!-- <div id="checkbox-{{subgroup.id}}" *ngIf="checkboxCheck[subgroup.id]==true && !isPlanInBulkplans(subgroup.id)" class="countblock">&nbsp;

                              <label for="Corporation" class="Corporation">Head Count:</label>

                              <input type="number" class="headcountbox" [(ngModel)]="showHeadCount[subgroup.id]"
                                class="headerCount" (keypress)="preventNegative($event)" (input)="preventNonNumeric($event)"
                                (change)="updateTotal(j,$event,subgroup,subgroup.settings?.requiredCustomersCount)">&nbsp;
                              <label for="Corporation" class="Corporation"
                                *ngIf="!showHeadCount[subgroup.id] || showHeadCount[subgroup.id] <=0" style="color:red">
                                {{lang.Please_enter_head_count_for}} {{subgroup.name}}</label>
                              &nbsp;

                              <span class="text-left"
                                *ngIf="checkboxCheck[subgroup.id] && showinputboxvalue[subgroup.id] && (showHeadCount[subgroup.id] || showHeadCount[subgroup.id] >0)">
                                <label for="DownloadButton" id="uploadButtonExcel" title="Download Template" data-taggle="tooltip"
                                  (click)="exportAsXLSX(subgroup.id,subgroup.settings.memberDetailsKeysDB)" class="Cursorpointer">
                                  <img src="../../../assets/img/download-template.png" style="width:100px;height:30px">
                                </label>&nbsp;
                                <label for="uploadButton-{{subgroup.id}}" id="uploadButtonExcel-{{subgroup.id}}"
                                  title="Upload Employee/Entity List" data-taggle="tooltip" class="Cursorpointer">
                                  <img src="../../../assets/img/upload-employee-list.png" style="width:100px;height:30px">
                                  <input id="uploadButton-{{subgroup.id}}" #myFileInput style="display: none" type="file"
                                    (input)="onFileChangeExcel($event,subgroup.id,subgroup.settings.memberDetailsKeysDB)" />
                                </label> &nbsp;
                                <i class="fa fa-eye" title="view" aria-hidden="true" data-bs-toggle="modal"
                                  (click)="editEmployees(subgroup.id,'edit')"></i>

                              </span>
                            </div>

                            <div *ngIf="isPlanInBulkplans(subgroup.id)" class='mx-2'>
                              <div id="checkbox-{{subgroup.id}}" *ngIf="checkboxCheck[subgroup.id] == true" class="countblock">
                                <div *ngFor="let plan of getPlansByPlanLevel(subgroup.id), let index = i" class="d-flex align-items-center">
                                  <label for="Corporation" class="Corporation">Head Count:</label>
                                  <label>{{ plan.quantity }}</label>&nbsp;
                                  <label *ngIf="plan.terminationDate" class="d-flex align-items-center">
                                    | Termination Date : {{plan.terminationDate?.slice(0,10)}}&nbsp;
                                      <i
                                        style="color:rgb(56, 76, 159)"
                                        class="bi bi-pencil-fill"
                                        data-bs-target="#edit-headcount"
                                        data-bs-toggle="modal"
                                        (click)="updateBulkHeadCount(plan)"
                                        ></i>&nbsp;&nbsp;
                                        <i
                                        style="color:red"
                                        class="bi bi-x-lg"
                                        data-bs-target="#terminate-bulkplan"
                                        data-bs-toggle="modal"
                                        (click)="terminateBulkPlan(plan)"
                                      ></i>
                                  </label>
                                  <label *ngIf="!plan.terminationDate">| Activation Date : {{plan.activationDate?.slice(0,10)}}&nbsp;
                                      <i
                                        style="color:rgb(56, 76, 159)"
                                        class="bi bi-pencil-fill"
                                        data-bs-target="#edit-headcount"
                                        data-bs-toggle="modal"
                                        (click)="updateBulkHeadCount(plan,i)"
                                        ></i>&nbsp;&nbsp;
                                        <i
                                        style="color:red"
                                        class="bi bi-x-lg"
                                        data-bs-target="#terminate-bulkplan"
                                        data-bs-toggle="modal"
                                        (click)="terminateBulkPlan(plan,i)"
                                      ></i>
                                  </label>
                                </div>
                              </div>
                            </div> -->



                              <!-- <div class="countblock" *ngIf="package?.id==2">&nbsp;
                              <label for="Corporation" class="Corporation" *ngIf="showinputbox==k">Head Count:</label>

                              <input type="text" class="headcountbox" *ngIf="showinputbox==k"
                                [(ngModel)]="showEmployeeValue" class="headerCount"
                                (change)="updateTotal(j,$event)">&nbsp;
                              <label for="Corporation" class="Corporation" *ngIf="showinputbox==k && headCountmiss"
                                style="color:red">Please enter
                                head count</label>
                              &nbsp;

                              <span class="text-left"
                                *ngIf="subgroup.name=='Complete Wellness' && showinputboxvalue==20 && showEmployeeValue">
                                <label for="DownloadButton" id="uploadButtonExcel" title="Download Template"
                                  data-taggle="tooltip" (click)="exportAsXLSX()" class="Cursorpointer">
                                  <img src="../../../assets/img/download-template.png" style="width:100px;height:30px">
                                </label>&nbsp;
                                <label for="uploadButton" id="uploadButtonExcel" title="Upload Employee/Entity List"
                                  data-taggle="tooltip" class="Cursorpointer">
                                  <img src="../../../assets/img/upload-employee-list.png"
                                    style="width:100px;height:30px">
                                  <input id="uploadButton" #myFileInput style="display: none" type="file"
                                    (input)="onFileChangeExcel($event)" />
                                </label> &nbsp;
                                <i class="fa fa-eye" title="view" aria-hidden="true" data-bs-toggle="modal"
                                  data-bs-target="#showBulkEmployeelist"></i>
                              </span>
                            </div>

                            <div class="countblock" *ngIf="package?.id==11">&nbsp;
                              <label for="Corporation" class="Corporation" *ngIf="showinputbox1==k">Head Count:</label>

                              <input type="text" class="headcountbox" *ngIf="showinputbox1==k"
                                [(ngModel)]="showEmployeeValue1" class="headerCount"
                                (change)="updateTotal1(j,$event)">&nbsp;
                              <label for="Corporation" class="Corporation" *ngIf="showinputbox1==k && headCountmiss1"
                                style="color:red">Please enter
                                head count</label>
                              &nbsp;

                              <span class="text-left"
                                *ngIf="subgroup.name=='Personal Protection' && showinputboxvalue1==34 && showEmployeeValue1">
                                <label for="DownloadButton" id="uploadButtonExcel" title="Download Template"
                                  data-taggle="tooltip" (click)="exportAsXLSXWaddel()" class="Cursorpointer">
                                  <img src="../../../assets/img/download-template.png" style="width:100px;height:30px">
                                </label>&nbsp;
                                <label for="uploadButtonwaddell" id="uploadButtonExcelwaddell"
                                  title="Upload Employee/Entity List" data-taggle="tooltip" class="Cursorpointer">
                                  <img src="../../../assets/img/upload-employee-list.png"
                                    style="width:100px;height:30px">
                                  <input id="uploadButtonwaddell" #myFileInputwaddel style="display: none" type="file"
                                    (input)="onFileChangeExcelWaddel($event)" />
                                </label> &nbsp;
                                <i class="fa fa-eye" title="view" aria-hidden="true" data-bs-toggle="modal"
                                  data-bs-target="#showBulkEmployeelistwaddell"></i>
                              </span>
                            </div> -->
                            </div>
                          </div>


                          <!-- <textarea type="text" class="tierconfig"> Employee</textarea> -->
                        </div>

                      </div>

                    </div>
                  </div>

                </div>

              </div>

              <div class="row">
                <div class="col-12 col-md-12">
                  <div class="form-group">
                    <span class="coreplans" *ngIf="showtierbasicplans">{{lang.Template}}
                      <select (change)="coreplantemplate($event)" [(ngModel)]="coreplantemplateValue">
                        <option [value]="null">{{lang.Select}}</option>
                        <option value="starter">{{lang.Starter}}</option>
                        <option value="standard">{{lang.Standard}}</option>
                        <option value="executive">{{lang.Executive}}</option>
                        <option value="custom">{{lang.Custom}}</option>
                      </select>
                    </span>
                    <h6 class="admintitle">
                      {{lang.Core_Plans_Premium_paid_100_by_employer}}&nbsp;&nbsp;
                      <!--  -->
                    </h6>
                  </div>
                </div>
              </div>

              <!-- *ngIf="showtierbasicplans" -->
              <!-- Block1 With No Tier -->
              <div class="row">
                <div class="col-12 col-md-12 pb-2">
                  <span class="enabledplans1">
                    <!-- Enabled?<input class="" type="radio" name="upgradeplans" id="upgradeplanstrue" #upgradeplanstrue value="true"
                  (click)="upgradeplans($event)" />
                <label class="form-check-label" for="workinghoursno" class="upgradeplans">&nbsp;Yes</label>&nbsp;&nbsp;
                <input class="" type="radio" name="upgradeplans" id="upgradeplansfalse" #upgradeplansfalse value="false"
                  (click)="upgradeplans($event)" checked />
                <label class="form-check-label" for="workinghoursno" class="upgradeplans">&nbsp;No</label>
               -->
                  </span>

                  <!-- <h6 class="admintitle">
                Core Plans (Premium paid 100% by employer).&nbsp;&nbsp;
              </h6> -->
                </div>

                <div class="packageWrapper plansscreen" *ngFor="let package of plansBlock1; let i = index">
                  <div class="planheadingwrap" style="padding-left: 6px;">
                    <!-- *ngIf="!(package?.id == hidementalplans || package?.id == hidewaddellplans)" -->
                    <div class="d-flex position-relative">
                      <h6 *ngIf="package?.groups?.length >= 1 && showPackageName(package?.groups,'core')"
                        class="planheading ps-3" id="plancheckcollapseone{{ package?.id }}" aria-expanded="true"
                        aria-controls="collapseone{{ package?.id }}"
                        [attr.data-bs-target]="'#collapseone' + package?.id" data-bs-toggle="collapse"
                        style="justify-content: space-around;" (click)="toggleCollapsee(package?.id)" id="parent1">
                        {{ package?.name }}<span>{{ isCollapsed[package?.id] ? '+' : '-' }}</span>
                      </h6>
                      <!-- <h6 class="planheading" *ngIf="package?.groups?.length >  1">
                      {{ package?.name }}
                    </h6> -->
                      <div class="position-absolute" style="top: 18px;left: 10px;bottom: -39px;">
                        <div
                          *ngIf="role==='ADMINISTRATOR' && package?.groups?.length >= 1 && showPackageName(package?.groups,'core')"
                          title="{{getTextForTooltip1(package?.published,package?.restrictedAccess)}}"
                          [ngStyle]=" {'border-color' : getColorForPlans1(package?.published,package?.restrictedAccess) }"
                          class="outer my-auto col-2" data-bs-toggle="">
                          <span class="inner"
                            [ngStyle]="{ 'background': getColorForPlans1(package?.published,package?.restrictedAccess) }"></span>
                        </div>
                      </div>
                      <div class="form-group package" *ngIf="!isCollapsed[package?.id]">
                        <!-- *ngIf="!(package?.id == hidementalplans || package?.id == hidewaddellplans)" -->
                        <div class="package-groups1" *ngFor="let group of package?.groups; let j = index" title="">
                          <div class="price" id="myGroup">
                            <div *ngIf="package?.groups?.length >  1 && showPackageName(package?.groups,'core')"
                              class="header overflow-ellipsis1 panel-title" [style.background-color]="
                              group.backgroundColor
                                ? group.backgroundColor
                                : defaultColor
                            " id="plancheckcollapseone{{ group.id }}" [attr.data-bs-target]="'#collapseone' + group.id"
                              data-bs-toggle="collapse" aria-expanded="true" aria-controls="collapseone{{ group.id }}"
                              title="{{ group.name }}">
                              {{ group.name }}
                            </div>
                          </div>
                          <div class="planbody" *ngIf="group.subGroups && group.subGroups.length > 0 ">
                            <div *ngFor="let subgroup of group.subGroups; let k = index">
                              <!-- <div>collapseone{{
                              package?.groups?.length > 1
                              ? subgroup.parentId
                              : package?.id
                              }}{{package?.groups.length}}</div> -->
                              <div *ngIf="subgroup && subgroup?.settings?.core" id="collapseone{{
                                package?.groups?.length >  1
                                  ? subgroup.parentId
                                  : package?.id
                              }}" class="accordion-collapse collapse show">
                                <div class="featuutrebody" [style.background-color]="
                                  subgroup.backgroundColor
                                    ? subgroup.backgroundColor
                                    : defaultColor
                                ">
                                  <!-- <span>&#x2713; {{ subgroup.name }}</span> -->
                                  <div class="row justify-content-center align-items-center">
                                    <div class="col-1">
                                      <div *ngIf="role==='ADMINISTRATOR' && package?.groups?.length >= 1"
                                        title="{{getTextForTooltip(subgroup.published?.data[0],subgroup.restricted)}}"
                                        [ngStyle]=" {'border-color' : getColorForPlans(subgroup.published?.data[0],subgroup.restricted) }"
                                        class="outer my-auto col-2" data-bs-toggle="">
                                        <span class="inner"
                                          [ngStyle]="{ 'background': getColorForPlans(subgroup.published?.data[0],subgroup.restricted,subgroup.name) }"></span>
                                      </div>
                                    </div>
                                    <span class="col-9"> {{ subgroup.name }}</span>
                                    <input type="checkbox" [checked]="subgroup.checked" id="plancheck{{ subgroup.id }}"
                                      class="col-1 plancheckbox{{
                                      package?.id
                                    }} plancv largerCheckbox block1" attr.data="{{ package?.allowMultiple }}##{{
                                      subgroup.disallowedPlanLevels
                                    }}##{{ package?.id }}##{{
                                      subgroup.parentId
                                    }}##{{ subgroup.id }}##{{ package?.name }}##{{
                                      subgroup.namego
                                    }}##{{ subgroup }}##{{ subgroup.ordering }}##{{
                                      i
                                    }}##{{ j }}##{{ k }}" (change)="
                                      onCheckboxChange1(
                                        $event,
                                        package?.allowMultiple,
                                        subgroup.disallowedPlanLevels,
                                        package?.id,
                                        subgroup.id,
                                        package?.name,
                                        subgroup.name,
                                        subgroup,
                                        subgroup.ordering,
                                        group.id,
                                        group.name,
                                        i,
                                        j,
                                        k
                                      )
                                    " />
                                  </div>
                                  <!-- <div class="executiveplansselection" *ngIf="subgroup.coverage=='Exec'"> -->

                                  <div class="executiveplansselection"
                                    *ngIf="subgroup.id == '17' || subgroup.id == '18' || subgroup.id == '28'">
                                    <label class="radio-inline executiveplans">
                                      <input type="checkbox" name="executiveplans{{ subgroup.id }}"
                                        id="executiveplanssingle{{ subgroup.id }}" style="vertical-align: bottom"
                                        (click)="
                                        executiveplansCoverage(
                                          $event,
                                          i,
                                          j,
                                          k,
                                          subgroup.id
                                        )
                                      " />
                                      {{lang.Single}}
                                    </label>
                                    <label class="radio-inline executiveplans">
                                      <input type="checkbox" name="executiveplans{{ subgroup.id }}"
                                        id="executiveplanscouple{{ subgroup.id }}" style="vertical-align: bottom"
                                        (click)="
                                        executiveplansCoverage(
                                          $event,
                                          i,
                                          j,
                                          k,
                                          subgroup.id
                                        )
                                      " />
                                      {{lang.Couple}}
                                    </label>
                                    <label class="radio-inline executiveplans">
                                      <input type="checkbox" name="executiveplans{{ subgroup.id }}"
                                        id="executiveplansfamily{{ subgroup.id }}" style="vertical-align: bottom"
                                        (click)="
                                        executiveplansCoverage(
                                          $event,
                                          i,
                                          j,
                                          k,
                                          subgroup.id
                                        )
                                      " />
                                      {{lang.Family}}
                                    </label>
                                  </div>


                                </div>
                                <ng-container *ngIf="role==='ADMINISTRATOR'">
                                  <div class="planCoverage"
                                    *ngIf="subgroup.checked && plansCoveragecheckboxCheck[subgroup.id]">
                                    <!-- <ul class="tiersConfigul">
                                    <li>Configure Tier</li>
                                  </ul> -->
                                    <div class="d-flex align-items-center">
                                      <select class="form-control" id="Province" placeholder="Province"
                                        [(ngModel)]="getPlanCoverage[subgroup.id]">
                                        <option value="" [disabled]="true" selected>{{lang.Select}}</option>
                                        <option *ngFor="let coverage of companyPaidCoveragePlanLevels[subgroup.id]"
                                          [value]="coverage.value">
                                          {{ coverage.label }}&nbsp;<i class="fa fa-info-circle" aria-hidden="true"
                                            title="{{coverage.description}}"></i>
                                        </option>
                                      </select>
                                    </div>
                                  </div>
                                </ng-container>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                  </div>

                </div>

                <!-- <div class="row">
                <div class="offset-md-10 col-md-2">
                  <button class="btn btn-primary" type="button" data-bs-toggle="modal" data-bs-target="#tierConfigure"
                    *ngIf="showtieradvplans" style="float: right" (click)="configuretiers()">
                    Configure&nbsp;&nbsp;<i aria-hidden="true" class="fa fa-long-arrow-right"></i>
                  </button>
                </div>
              </div> -->
              </div>

              <!-- Block2 With No Tier -->
              <div class="row" style="width: 100%;">
                <div class="row header-title m-2 d-flex justify-content-between header-title">
                  <div class="my-auto mx-2" style="width:auto;">
                    {{lang.Upgrade_Plans_Premium_difference_paid_by_employee_through_payroll_deduction}}&nbsp;&nbsp;
                    <!--  -->
                  </div>
                  <div class="my-auto mx-4" style="width:auto;">{{lang.Enabled}}
                    <input class="" type="radio" name="upgradeplans" id="upgradeplanstrue" #upgradeplanstrue
                      value="true" (click)="upgradeplans($event)" />
                    <label class="form-check-label" for="workinghoursno"
                      class="upgradeplans">&nbsp;{{lang.Yes}}</label>&nbsp;&nbsp;
                    <input class="" type="radio" name="upgradeplans" id="upgradeplansfalse" #upgradeplansfalse
                      value="false" (click)="upgradeplans($event)" checked />
                    <label class="form-check-label" for="workinghoursno" class="upgradeplans">&nbsp;{{lang.No}}</label>
                  </div>

                </div>
                <!-- <div class="col-12 col-md-12 pb-2">
                <span class="enabledplans1">Enabled?
                  <input class="" type="radio" name="upgradeplans" id="upgradeplanstrue" #upgradeplanstrue value="true"
                    (click)="upgradeplans($event)" />
                  <label class="form-check-label" for="workinghoursno"
                    class="upgradeplans">&nbsp;Yes</label>&nbsp;&nbsp;
                  <input class="" type="radio" name="upgradeplans" id="upgradeplansfalse" #upgradeplansfalse
                    value="false" (click)="upgradeplans($event)" checked />
                  <label class="form-check-label" for="workinghoursno" class="upgradeplans">&nbsp;No</label>
                </span>

                <h6 class="admintitle">
                  Upgrade Plans (Premium difference paid by employee through
                  payroll deduction).&nbsp;&nbsp;
                </h6>
              </div> -->
                <div class="row" *ngIf="upgradeplansselection">
                  <div class="packageWrapper block2packagewrapper plansscreen2"
                    *ngFor="let package of plansresblack2; let i = index">
                    <div class="planheadingwrap" style="padding-left: 6px;">
                      <!-- *ngIf="package && package?.id !== 3 && package?.id !== hidewaddellplans" -->
                      <div class="d-flex position-relative">
                        <h6 *ngIf="package?.groups?.length >= 1 && showPackageName(package?.groups,'upgrade')"
                          class="planheading" [attr.data-bs-target]="'#collapsetwo' + package?.id"
                          data-bs-toggle="collapse" aria-expanded="true" aria-controls="collapsetwo{{ package?.id }}"
                          style="justify-content: space-around;" (click)="toggleCollapseeTwo(package?.id)" id="parent2">
                          {{ package?.name }}<span>{{ isCollapsedTwo[package?.id] ? '+' : '-' }}</span>
                        </h6>
                        <!-- <h6 class="planheading" *ngIf="package?.groups?.length >  1">
                        {{ package?.name }}
                      </h6> -->
                        <div class="position-absolute" style="top: 18px;left: 10px;bottom: -39px;">
                          <div
                            *ngIf="role==='ADMINISTRATOR' && package?.groups?.length >= 1 && showPackageName(package?.groups,'upgrade')"
                            title="{{getTextForTooltip1(package?.published,package?.restrictedAccess)}}"
                            [ngStyle]=" {'border-color' : getColorForPlans1(package?.published,package?.restrictedAccess) }"
                            class="outer my-auto col-2" data-bs-toggle="">
                            <span class="inner"
                              [ngStyle]="{ 'background': getColorForPlans1(package?.published,package?.restrictedAccess) }"></span>
                          </div>
                        </div>
                        <div class="form-group package" *ngIf="!isCollapsedTwo[package?.id]">
                          <!-- *ngIf="package && package?.id !== 3 && package?.id !== hidewaddellplans" -->
                          <div class="package-groups1" *ngFor="let group of package?.groups; let j = index" title="">
                            <div class="price"
                              *ngIf="group && group != null  && showPackageName(package?.groups,'upgrade')">
                              <div class="header overflow-ellipsis1 panel-title" [style.background-color]="
                                group.backgroundColor
                                  ? group.backgroundColor
                                  : defaultColor
                              " [attr.data-bs-target]="'#collapsetwo' + group.id" data-bs-toggle="collapse"
                                aria-expanded="true" aria-controls="collapsetwo{{ group.id }}" title="{{ group.name }}"
                                *ngIf="
                                group &&
                                group.subGroups &&
                                group.subGroups.length > 0 &&
                                package?.groups?.length >  1
                              ">
                                {{ group.name }}
                              </div>
                            </div>

                            <div class="planbody" *ngIf="
                              group && group.subGroups && group.subGroups.length > 0
                            ">
                              <div *ngFor="
                                let subgroup of group.subGroups;
                                let k = index
                              ">
                                <!-- {{subgroup?.settings?.upgrade}} -->

                                <div *ngIf="subgroup && subgroup?.settings?.upgrade" id="collapsetwo{{
                                  package?.groups?.length >  1
                                    ? subgroup.parentId
                                    : package?.id
                                }}" class="accordion-collapse collapse show">
                                  <div class="featuutrebody row justify-content-center align-items-center"
                                    [style.background-color]="
                                    subgroup.backgroundColor
                                      ? subgroup.backgroundColor
                                      : defaultColor
                                  " *ngIf="subgroup">
                                    <div class="col-2">
                                      <div *ngIf="role==='ADMINISTRATOR' && package?.groups?.length >= 1"
                                        title="{{getTextForTooltip(subgroup.published?.data[0],subgroup.restricted)}}"
                                        [ngStyle]=" {'border-color' : getColorForPlans(subgroup.published?.data[0],subgroup.restricted) }"
                                        class="outer my-auto col-2" data-bs-toggle="">
                                        <span class="inner"
                                          [ngStyle]="{ 'background': getColorForPlans(subgroup.published?.data[0],subgroup.restricted,subgroup.name) }"></span>
                                      </div>
                                    </div>
                                    <span class="col-9">{{ subgroup.name }}</span>
                                    <input class="col-1" type="checkbox" id="plancheck2Upgrade{{ subgroup.id }}" class="plancheckbox2{{
                                      package?.id
                                    }} plancheckbox2{{
                                      subgroup.id
                                    }} plancv largerCheckbox block2" attr.data="{{ package?.allowMultiple }}##{{
                                      subgroup.disallowedPlanLevels
                                    }}##{{ package?.id }}##{{
                                      subgroup.parentId
                                    }}##{{ subgroup.id }}##{{ package?.name }}##{{
                                      subgroup.name
                                    }}##{{ subgroup }}##{{ subgroup.ordering }}##{{
                                      i
                                    }}##{{ j }}##{{ k }}" (change)="
                                      onCheckboxChange2(
                                        $event,
                                        package?.allowMultiple,
                                        subgroup.disallowedPlanLevels,
                                        package?.id,
                                        subgroup.id,
                                        package?.name,
                                        subgroup.name,
                                        subgroup,
                                        subgroup.ordering,
                                        group.id,
                                        group.name,
                                        i,
                                        j,
                                        k
                                      )
                                    " />

                                    <div class="executiveplansselection" *ngIf="
                                      subgroup.coverage == '' && (subgroup.id == '17' || subgroup.id == '18' || subgroup.id == '28')
                                    ">
                                      <label class="radio-inline executiveplans">
                                        <input type="checkbox" name="executiveplansblock2{{ subgroup.id }}" id="executiveplansblock2single{{
                                          subgroup.id
                                        }}" style="vertical-align: bottom" (click)="
                                          executiveplansCoverage2(
                                            $event,
                                            i,
                                            j,
                                            k,
                                            subgroup.id
                                          )
                                        " />
                                        {{lang.Single}}
                                      </label>
                                      <label class="radio-inline executiveplans">
                                        <input type="checkbox" name="executiveplansblock2{{ subgroup.id }}" id="executiveplansblock2couple{{
                                          subgroup.id
                                        }}" style="vertical-align: bottom" (click)="
                                          executiveplansCoverage2(
                                            $event,
                                            i,
                                            j,
                                            k,
                                            subgroup.id
                                          )
                                        " />
                                        {{lang.Couple}}
                                      </label>
                                      <label class="radio-inline executiveplans">
                                        <input type="checkbox" name="executiveplansblock2{{ subgroup.id }}" id="executiveplansblock2family{{
                                          subgroup.id
                                        }}" style="vertical-align: bottom" (click)="
                                          executiveplansCoverage2(
                                            $event,
                                            i,
                                            j,
                                            k,
                                            subgroup.id
                                          )
                                        " />
                                        {{lang.Family}}
                                      </label>
                                    </div>

                                    <div class="executiveplansselection" *ngIf="
                                      subgroup.coverage == '001' && (subgroup.id == '17' || subgroup.id == '18' || subgroup.id == '28')
                                    ">
                                      <label class="radio-inline executiveplans">
                                        <input type="checkbox" name="executiveplansblock2{{ subgroup.id }}" id="executiveplansblock2couple{{
                                          subgroup.id
                                        }}" style="vertical-align: bottom" (click)="
                                          executiveplansCoverage2(
                                            $event,
                                            i,
                                            j,
                                            k,
                                            subgroup.id
                                          )
                                        " />
                                        {{lang.Couple}}
                                      </label>
                                      <label class="radio-inline executiveplans">
                                        <input type="checkbox" name="executiveplansblock2{{ subgroup.id }}" id="executiveplansblock2family{{
                                          subgroup.id
                                        }}" style="vertical-align: bottom" (click)="
                                          executiveplansCoverage2(
                                            $event,
                                            i,
                                            j,
                                            k,
                                            subgroup.id
                                          )
                                        " />
                                        {{lang.Family}}
                                      </label>
                                    </div>
                                    <div class="executiveplansselection" *ngIf="
                                      subgroup.coverage == '010' && (subgroup.id == '17' || subgroup.id == '18' || subgroup.id == '28')
                                    ">
                                      <label class="radio-inline executiveplans">
                                        <input type="checkbox" name="executiveplansblock2{{ subgroup.id }}" id="executiveplansblock2family{{
                                          subgroup.id
                                        }}" style="vertical-align: bottom" (click)="
                                          executiveplansCoverage2(
                                            $event,
                                            i,
                                            j,
                                            k,
                                            subgroup.id
                                          )
                                        " />
                                        {{lang.Family}}
                                      </label>
                                    </div>
                                    <div class="executiveplansselection" *ngIf="
                                      subgroup.coverage == '011' && (subgroup.id == '17' || subgroup.id == '18' || subgroup.id == '28')
                                    ">
                                      <label class="radio-inline executiveplans">
                                        <input type="checkbox" name="executiveplansblock2{{ subgroup.id }}" id="executiveplansblock2family{{
                                          subgroup.id
                                        }}" style="vertical-align: bottom" (click)="
                                          executiveplansCoverage2(
                                            $event,
                                            i,
                                            j,
                                            k,
                                            subgroup.id
                                          )
                                        " />
                                        {{lang.Family}}
                                      </label>
                                    </div>
                                  </div>
                                </div>
                                <!-- <textarea type="text" class="tierconfig"> Employee</textarea> -->
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <!-- <div class="planheadingwrap" *ngIf="package"></div> package && package?.id !== 2 -->
                      <!-- <h6 class="planheading">{{ package?.name }}<span *ngIf="package?.groups.length<=1" class="panel-title" [attr.data-bs-target]="'#collapsetwo'+package?.id" data-bs-toggle="collapse"   aria-expanded="true" aria-controls="collapsetwo{{package?.id}}"></span></h6> -->
                    </div>

                  </div>
                </div>
              </div>
              <!-- Block3 With No Tier -->
              <div class="row mt-2" style="width: 100%;">
                <div class="row header-title m-2 d-flex justify-content-between">
                  <div class="my-auto mx-2" style="width: auto;">
                    {{lang.Voluntary_Plans_Premium_paid_100_by_employee_directly}}.&nbsp;&nbsp;
                    <!--  -->
                  </div>
                  <div class="my-auto mx-4" style="width: auto;">{{lang.Enabled}}
                    <input class="" type="radio" name="employeepurchase" id="employeepurchasetrue" #employeepurchasetrue
                      value="true" (click)="planpurchase($event)" />
                    <label class="form-check-label" for="employeepurchasetrue"
                      class="employeepurchase">&nbsp;{{lang.Yes}}</label>&nbsp;&nbsp;
                    <input class="" type="radio" name="employeepurchase" id="employeepurchasefalse"
                      #employeepurchasefalse value="false" (click)="planpurchase($event)" checked />
                    <label class="form-check-label" for="employeepurchasefalse"
                      class="employeepurchase">&nbsp;{{lang.No}}</label>
                  </div>
                </div>


                <div class="row" *ngIf="employeeplanpurchase">
                  <div class="packageWrapper block3packagewrapper plansscreen3"
                    *ngFor="let package of plansresblack3; let i = index">
                    <div class="planheadingwrap" style="padding-left: 6px;">
                      <div class="d-flex position-relative">
                        <h6 *ngIf="package?.groups?.length >= 1 && showPackageName(package?.groups,'voluntary')"
                          class="planheading" [attr.data-bs-target]="'#collapsethree' + package?.id"
                          data-bs-toggle="collapse" aria-expanded="true" aria-controls="collapsethree{{ package?.id }}"
                          style="justify-content: space-around;" (click)="toggleCollapseeThree(package?.id)"
                          id="parent3">
                          {{ package?.name }}<span>{{ isCollapsedThree[package?.id] ? '+' : '-' }}</span>
                        </h6>
                        <!-- <h6 class="planheading" *ngIf="package?.groups?.length >  1">
                        {{ package?.name }}
                      </h6> -->
                        <div class="position-absolute" style="top: 18px;left: 10px;bottom: -39px;">
                          <div
                            *ngIf="role==='ADMINISTRATOR' && package?.groups?.length >= 1 && showPackageName(package?.groups,'voluntary')"
                            title="{{getTextForTooltip1(package?.published,package?.restrictedAccess)}}"
                            [ngStyle]=" {'border-color' : getColorForPlans1(package?.published,package?.restrictedAccess) }"
                            class="outer my-auto col-2" data-bs-toggle="">
                            <span class="inner"
                              [ngStyle]="{ 'background': getColorForPlans1(package?.published,package?.restrictedAccess) }"></span>
                          </div>
                        </div>
                        <div class="form-group package" *ngIf="!isCollapsedThree[package?.id]">
                          <!-- *ngIf="
                        package &&
                        package?.id !== 1 &&
                        package &&
                        package?.id !== 4 &&
                        package &&
                        package?.id !== 2 && package?.id !== hidewaddellplans" -->
                          <!-- &&package && package?.id !== 2 -->
                          <div class="package-groups1" *ngFor="let group of package?.groups; let j = index" title="">
                            <div class="price"
                              *ngIf="group && group != null  && showPackageName(package?.groups,'voluntary')">
                              <div class="header overflow-ellipsis1 panel-title"
                                [attr.data-bs-target]="'#collapsethree' + group.id" data-bs-toggle="collapse"
                                aria-expanded="true" aria-controls="collapsethree{{ group.id }}"
                                title="{{ group.name }}" *ngIf="
                                group &&
                                group.subGroups &&
                                group.subGroups.length > 0 &&
                                package?.groups?.length >  1
                              ">
                                {{ group.name }}
                              </div>
                            </div>
                            <div class="planbody" *ngIf="
                              group && group.subGroups && group.subGroups.length > 0
                            ">
                              <div *ngFor="
                                let subgroup of group.subGroups;
                                let k = index
                              ">
                                <div *ngIf="subgroup &&  subgroup?.settings?.voluntary" id="collapsethree{{
                                  package?.groups?.length >  1
                                    ? subgroup.parentId
                                    : package?.id
                                }}" class="accordion-collapse collapse show">
                                  <div class="featuutrebody row justify-content-center align-items-center"
                                    [style.background-color]="
                                    subgroup.backgroundColor
                                      ? subgroup.backgroundColor
                                      : defaultColor
                                  " *ngIf="subgroup">
                                    <div class="col-3">
                                      <div *ngIf="role==='ADMINISTRATOR' && package?.groups?.length >= 1"
                                        title="{{getTextForTooltip(subgroup.published?.data[0],subgroup.restricted)}}"
                                        [ngStyle]=" {'border-color' : getColorForPlans(subgroup.published?.data[0],subgroup.restricted) }"
                                        class="outer my-auto col-2" data-bs-toggle="">
                                        <span class="inner"
                                          [ngStyle]="{ 'background': getColorForPlans(subgroup.published?.data[0],subgroup.restricted,subgroup.name) }"></span>
                                      </div>
                                    </div>
                                    <span class="col-8">{{ subgroup.name }}</span>
                                    <input type="checkbox" id="plancheck3Voluntry{{ subgroup.id }}" class=" col-1 plancheckbox3{{
                                      package?.id
                                    }} plancv largerCheckbox" attr.data="{{ package?.allowMultiple }}##{{
                                      subgroup.disallowedPlanLevels
                                    }}##{{ package?.id }}##{{
                                      subgroup.parentId
                                    }}##{{ subgroup.id }}##{{ package?.name }}##{{
                                      subgroup.name
                                    }}##{{ subgroup }}##{{ subgroup.ordering }}" (change)="
                                      onCheckboxChange3(
                                        $event,
                                        package?.allowMultiple,
                                        subgroup.disallowedPlanLevels,
                                        package?.id,
                                        subgroup.id,
                                        package?.name,
                                        subgroup.name,
                                        subgroup,
                                        subgroup.ordering,
                                        group.id,
                                        group.name,
                                        i,
                                        j,
                                        k
                                      )
                                    " />
                                    <ng-container>
                                      <div *ngIf="
                                        subgroup.coverage == '' && (subgroup.id == '17' || subgroup.id == '18' || subgroup.id == '28')
                                      ">
                                        <form class="executiveplansselection">
                                          <label class="radio-inline executiveplans">
                                            <input type="checkbox" name="executiveplansblock3{{
                                              subgroup.id
                                            }}" id="executiveplansblock3single{{
                                              subgroup.id
                                            }}" style="vertical-align: bottom" (click)="
                                              executiveplansCoverage3(
                                                $event,
                                                i,
                                                j,
                                                k,
                                                subgroup.id
                                              )
                                            " />
                                            {{lang.Single}}
                                          </label>
                                          <label class="radio-inline executiveplans">
                                            <input type="checkbox" name="executiveplansblock3{{
                                              subgroup.id
                                            }}" id="executiveplansblock3couple{{
                                              subgroup.id
                                            }}" style="vertical-align: bottom" (click)="
                                              executiveplansCoverage3(
                                                $event,
                                                i,
                                                j,
                                                k,
                                                subgroup.id
                                              )
                                            " />
                                            {{lang.Couple}}
                                          </label>
                                          <label class="radio-inline executiveplans">
                                            <input type="checkbox" name="executiveplansblock3{{
                                              subgroup.id
                                            }}" id="executiveplansblock3family{{
                                              subgroup.id
                                            }}" style="vertical-align: bottom" (click)="
                                              executiveplansCoverage3(
                                                $event,
                                                i,
                                                j,
                                                k,
                                                subgroup.id
                                              )
                                            " />
                                            {{lang.Family}}
                                          </label>
                                        </form>
                                      </div>
                                      <div *ngIf="
                                        subgroup.coverage == 'Family' &&
                                        (subgroup.id == '17' || subgroup.id == '18' || subgroup.id == '28')
                                      ">

                                      </div>

                                      <div *ngIf="
                                        subgroup.coverage == '001' &&
                                         (subgroup.id == '17' || subgroup.id == '18' || subgroup.id == '28')
                                      ">
                                        <form class="executiveplansselection">
                                          <!-- <label class="radio-inline executiveplans">
                            <input type="radio" name="executiveplans" style="vertical-align: bottom;" value="Family" (click)="executiveplansCoverage3($event,i,j,k)"> Single
                          </label> -->
                                          <label class="radio-inline executiveplans">
                                            <input type="checkbox" name="executiveplansblock3{{
                                              subgroup.id
                                            }}" id="executiveplansblock3couple{{
                                              subgroup.id
                                            }}" style="vertical-align: bottom" (click)="
                                              executiveplansCoverage3(
                                                $event,
                                                i,
                                                j,
                                                k,
                                                subgroup.id
                                              )
                                            " />
                                            {{lang.Couple}}
                                          </label>
                                          <label class="radio-inline executiveplans">
                                            <input type="checkbox" name="executiveplansblock3{{
                                              subgroup.id
                                            }}" id="executiveplansblock3family{{
                                              subgroup.id
                                            }}" style="vertical-align: bottom" (click)="
                                              executiveplansCoverage3(
                                                $event,
                                                i,
                                                j,
                                                k,
                                                subgroup.id
                                              )
                                            " />
                                            {{lang.Family}}
                                          </label>
                                        </form>
                                      </div>
                                      <div *ngIf="
                                        subgroup.coverage == '010' &&
                                        (subgroup.id == '17' || subgroup.id == '18' || subgroup.id == '28')

                                      ">
                                        <form class="executiveplansselection">
                                          <label class="radio-inline executiveplans">
                                            <input type="checkbox" name="executiveplansblock3{{
                                              subgroup.id
                                            }}" id="executiveplansblock3family{{
                                              subgroup.id
                                            }}" style="vertical-align: bottom" (click)="
                                              executiveplansCoverage3(
                                                $event,
                                                i,
                                                j,
                                                k,
                                                subgroup.id
                                              )
                                            " />
                                            {{lang.Family}}
                                          </label>
                                          <!-- <label class="radio-inline executiveplans">
                            <input type="radio" name="executiveplans" style="vertical-align: bottom;" value="Couple" (click)="executiveplansCoverage3($event,i,j,k)"> Couple
                          </label> -->
                                        </form>
                                      </div>
                                      <div *ngIf="
                                        subgroup.coverage == '011' &&
                                        (subgroup.id == '17' || subgroup.id == '18'|| subgroup.id == '28')

                                      ">
                                        <form class="executiveplansselection">
                                          <label class="radio-inline executiveplans">
                                            <input type="checkbox" name="executiveplansblock3{{
                                              subgroup.id
                                            }}" id="executiveplansblock3family{{
                                              subgroup.id
                                            }}" style="vertical-align: bottom" (click)="
                                              executiveplansCoverage3(
                                                $event,
                                                i,
                                                j,
                                                k,
                                                subgroup.id
                                              )
                                            " />
                                            {{lang.Family}}
                                          </label>
                                          <!-- <label class="radio-inline executiveplans">
                        <input type="radio" name="executiveplans" style="vertical-align: bottom;" value="Couple" (click)="executiveplansCoverage3($event,i,j,k)"> Couple
                      </label> -->
                                        </form>
                                      </div>
                                    </ng-container>
                                  </div>
                                </div>
                                <!-- <textarea type="text" class="tierconfig"> Employee</textarea> -->
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                  </div>
                </div>
              </div>

            </div>

            <!-- Plans screen footerpage -->

            <div class="row d-flex align-items-center">
              <div class="col"></div>
              <div class="col-auto">
                <!-- <button class="btn btn-primary"
                (click)="editTierPlansInfo()">{{lang.Save}}</button> -->
                <button class="btn btn-primary" (click)="commonPlansEditTiers.plansSumitInfo()">{{lang.Save}}</button>
              </div>
            </div>
          </ng-container>

        </div>


      </div>

      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" id="closeaddadmin" data-bs-dismiss="modal" #closemodel
          (click)="closeEditTierdModel()">
          Close
        </button>

      </div>
    </div>
  </div>
</div>

<!---WSA Model-->

  <div class="modal fade" data-bs-backdrop="static" id="wsadata">
  <div class="modal-dialog modal-dialog-centered modal-xl modal-dialog-scrollable" id="modal-dialog" style="max-width: 55vw; margin-top: 85px;">
    <div class="modal-content" id="modal-content">
      <div class="modal-header" id="backgroundColor">
        <span class="modal-title">Wellness Spending Account(taxable)</span>
        <i class="bi bi-x-circle" role="button" aria-hidden="true" data-bs-dismiss="modal"></i>
      </div>

      <div class="modal-body">
        <div class="row">
          <!-- Grace Period -->
          <div class="col-12" *ngIf="gracePeriod?.options?.length" style="width:46%">
            <label class="Corporation">
              <!-- {{ gracePeriod.field.label }} -->
                Grace period
              <i class="bi bi-info-circle-fill ms-1 tooltiptext" style="color: rgb(93, 124, 155); cursor: pointer;" tabindex="0" id="tooltip" data-bs-placement="top"
                title="The time frame after renewal that employees can submit outstanding claims from the previous benefit year (standard is 90 days)."
              ></i>
            </label>
            <select class="form-control" [(ngModel)]="selectedGracePeriodKey" name="gracePeriodSelect" required #graceRef="ngModel">
              <option value="" disabled>{{lang.Select || 'Select'}}</option>
              <option>Cannot submit claims for the previous benefit year after renewal</option>
              <option *ngFor="let option of gracePeriod.options" [value]="option.value">{{ option.label }}</option>
            </select>
            <!-- <div *ngIf="graceRef.invalid && graceRef.touched" class="text-danger">Grace period is required.</div> -->
          </div>

          <!-- Reimbursement Freeze -->
         <div class="col-12 mt-3" *ngIf="reimbursement?.field?.label">
  <label class="form-label small-label">
    <!-- {{ reimbursement.field.label }} -->
      WSA Reimbursement Freeze
    <i class="bi bi-info-circle-fill ms-1 tooltiptext" style="color: rgb(93, 124, 155); cursor: pointer;"
      tabindex="0" id="tooltip" data-bs-placement="top"
       title="Select a date in December to freeze WSA claim reimbursements allowing payroll teams to properly categorize these expenses as taxable benefits for the following year."
       >
    </i>
  </label>

  <!-- Yes/No radios side by side on a new line -->
  <div class="radio-inline-below">
    <div class="form-check form-check-inline">
      <input class="form-check-input"
             type="radio"
             name="wsaReimbursementFreeze"
             [(ngModel)]="wsaReimbursementFreeze"
             value="Yes"
             id="reimYes" (ngModelChange)="onReimbursementFreezeChange($event)">
      <label class="form-check-label small-label" for="reimYes">Yes</label>
    </div>

    <div class="form-check form-check-inline">
      <input class="form-check-input"  type="radio"  name="wsaReimbursementFreeze" [(ngModel)]="wsaReimbursementFreeze" 
             value="No"   id="reimNo" (ngModelChange)="onReimbursementFreezeChange($event)">
      <label class="form-check-label small-label" for="reimNo">No</label>
    </div>
  </div>
</div>


          <!-- Freeze Start Date -->
          <div class="col-12 mt-3" *ngIf="wsaReimbursementFreeze === 'Yes'" >
            <label class="Corporation">December</label>
            <input type="text"   class="form-control border border-dark"  placeholder="Select WSA freeze start date" [bsConfig]="bsConfig"

  [minDate]="decemberStart" [maxDate]="decemberEnd" bsDatepicker [(ngModel)]="freezeStartDate" name="freezeStartDate"  (bsValueChange)="checkDateOfBirth($event)"
  style="width: 44.5%" />        
          </div>
         
<div *ngIf="validationMessage" class="alert alert-info mt-2">
  {{ validationMessage }}
</div>

          

          <!-- Allow Carry Over -->
          <div class="col-12 mt-3" *ngIf="allowCarryOver?.field?.label"  >
            <label class="Corporation">
              <!-- {{ allowCarryOver.field.label }}? -->
                Allow carry over?
              <i class="bi bi-info-circle-fill ms-1 tooltiptext" style="color: rgb(93, 124, 155);cursor: pointer;"
       tabindex="0" tabindex="0" id="tooltip" data-bs-placement="top"
       
                title="This refers to a credit carry-forward. Any unused funds at the end of the benefit year will rollover into the next benefit year (up to 12 months)"
                ></i>
            </label>
            <select class="form-control" [(ngModel)]="allowCarryOver1" name="allowCarryOver1" required #carryRef="ngModel" style="width:44.5%">
              <option [ngValue]="'Yes'">Yes</option>
              <option [ngValue]="'No'">No</option>
            </select>
          </div>

          <!-- Maximum Carry Over Limit -->
          <div class="col-12 mt-3" *ngIf="allowCarryOver1 === 'Yes' && maximumCarryOverLimitAmount?.field?.label">
            <label class="Corporation">
              <!-- {{ maximumCarryOverLimitAmount.field.label }} -->
                Set a maximum carry over limit
            </label>
            <div>
              <label class="me-2">
                <input type="radio" name="maxCarryOverLimit" [(ngModel)]="maxCarryOverLimit" [value]="'Yes'"  #maxRef="ngModel" /> Yes
              </label>
              <label>
                <input type="radio" name="maxCarryOverLimit" [(ngModel)]="maxCarryOverLimit" [value]="'No'" /> No
              </label>
              <div *ngIf="maxRef.invalid && maxRef.touched" class="text-danger">Please select max carry over option.</div>
            </div>

            <div *ngIf="maxCarryOverLimit === 'Yes'" class="mt-2" style="width:44.5%">
              <!-- <input type="number" class="form-control" [(ngModel)]="maxCarryOverAmount" name="maxCarryOverAmount" placeholder="Enter maximum carryover limit" required min="1" #maxAmountRef="ngModel" /> -->
               <input  type="number"  class="form-control"  [(ngModel)]="maxCarryOverAmount"  name="maxCarryOverAmount"  placeholder="Enter maximum carryover limit"

  required  min="1" #maxAmountRef="ngModel" />
           <div *ngIf="maxAmountRef.invalid && maxAmountRef.touched" class="text-danger">Maximum amount is required and must be a number.</div>
            </div>
          </div>

          <!-- WSA Categories with Subcategories -->
          <div class="col-12 mt-3" *ngFor="let item of categoriesWithSubcategories">
            <label class="d-inline-flex align-items-center" style="white-space: nowrap;">
              <input type="checkbox" [checked]="isCategorySelected(item.category.id)" (change)="onCategoryChange($event, item.category.id)" style="margin-right: 5px;" />
              <span style="font-weight: bold;">{{ item.category.label }}</span>
            </label>

            <!-- Subcategories -->
            <div *ngIf="isCategorySelected(item.category.id)" class="ms-3">
              <div *ngFor="let sub of item.subcategories">
                <ng-container *ngIf="!sub.id.startsWith('custom-')">
                  <label class="d-inline-flex align-items-center" style="white-space: nowrap;">
                    <input type="checkbox" [checked]="isSubCategorySelected(sub.id, sub.categoryId)" (change)="onSubCategoryChange($event, sub.id, sub.categoryId)" style="margin-right: 5px;" />
                    {{ sub.label }}
                  </label>

                  <!-- Custom Subcategory Input -->
                  <div *ngIf="sub.label === 'Add custom sub category' && isSubCategorySelected(sub.id, sub.categoryId)" class="" style="width:44.5%">
                    <div class="input-group">
                      <input type="text" class="form-control" placeholder="Add custom subcategory" required minlength="3" [(ngModel)]="item.customSubcategoryLabel" 
                      #customSubcatRef="ngModel"   (keypress)="preventNumbers($event)"/>
                      <span class="input-group-text" (click)="addCustomCategory(item)" style="cursor: pointer;" title="Add Category">
                        <i class="bi bi-plus-circle-fill" style="color: rgb(93, 124, 155);"></i>
                      </span>
                    </div>
                    <div *ngIf="customSubcatRef.invalid && customSubcatRef.touched" class="text-danger"></div>
                  </div>
                </ng-container>
              </div>

              <!-- Custom Added Subcategories -->
              <div *ngIf="item.subcategories?.length" class="">
                <div *ngFor="let sub of item.subcategories" class="d-flex align-items-center" style="margin-top: 5px; width:44.5%">
                  <ng-container *ngIf="sub.id.startsWith('custom-')">
                    <label class="m-0 flex-grow-1">
                      <input type="checkbox" [checked]="isSubCategorySelected(sub.id, sub.categoryId)" (change)="onSubCategoryChange($event, sub.id, sub.categoryId)" style="margin-right: 5px;" />
                      {{ sub.label }}
                    </label>
            
                     <span
  class="text-danger"
  style="cursor: pointer;"
  (click)="removeCustomSubCategory(item, sub)"
  title="Remove Subcategory">
  Remove
</span>

                  </ng-container>
                </div>
              </div>
            </div>
          </div>

          <!-- Modal Footer -->
          <div class="col-12 mt-4">
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" (click)="closeEditTierdModel()">Close</button>
              <button type="button" class="btn btn-primary" [disabled]="formInvalid()" (click)="submitSelectedData()">Submit</button>
            </div>
          </div>

        </div> <!-- End of row -->
      </div>
    </div>
  </div>
</div>



